
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4VvyX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSidebar", () => $1ad6ee7b1ef3c0e6$export$54c70f22f548bff8);
$parcel$export(module.exports, "BulkOperationsCoreFull", () => $1ad6ee7b1ef3c0e6$export$8564253619317e8c);
$parcel$export(module.exports, "default", () => $1ad6ee7b1ef3c0e6$export$2e2bcd8739ae039);

var $khSYU = parcelRequire("khSYU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lq8LU = parcelRequire("lq8LU");

var $6m6ZF = parcelRequire("6m6ZF");

var $d5C8k = parcelRequire("d5C8k");

var $dNPZM = parcelRequire("dNPZM");
const $1ad6ee7b1ef3c0e6$var$SidebarForm = ({ resizerStyles: resizerStyles, setResizerRef: setResizerRef, setFormRef: setFormRef })=>{
    const setRef = (0, $eJOHy.useCallback)((node)=>{
        setFormRef(node);
        setResizerRef(node);
    }, [
        setFormRef,
        setResizerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "bulk-operations-full-core.box",
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: resizerStyles,
        ref: setRef,
        padding: "space.150",
        xcss: $1ad6ee7b1ef3c0e6$var$contentStyles
    });
};
const $1ad6ee7b1ef3c0e6$var$DEFAULT_RATIO = 0.35;
const $1ad6ee7b1ef3c0e6$var$MIN_RATIO = 0.3;
const $1ad6ee7b1ef3c0e6$var$MAX_RATIO = 0.5;
const $1ad6ee7b1ef3c0e6$export$54c70f22f548bff8 = ()=>(0, $eJOHy.useState)(false);
const $1ad6ee7b1ef3c0e6$var$BulkOperationsCoreFullInternal = (props)=>{
    const [openSidebar, setOpenSidebar] = $1ad6ee7b1ef3c0e6$export$54c70f22f548bff8();
    const bulkOperationsForm = (0, $6m6ZF.useReferenceLoader)();
    const onOpenForm = (0, $eJOHy.useCallback)(()=>{
        setOpenSidebar(true);
    }, [
        setOpenSidebar
    ]);
    const onCloseForm = (0, $eJOHy.useCallback)(()=>{
        setOpenSidebar(false);
    }, [
        setOpenSidebar
    ]);
    const onRatioChange = (0, $eJOHy.useCallback)((ratio)=>{
        (0, $dNPZM.setStoredRatio)(ratio);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8LU.BulkOpsCoreWithToolbar), {
        ...props,
        bulkOperationsForm: bulkOperationsForm,
        onCloseForm: onCloseForm,
        onOpenForm: onOpenForm
    }), openSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5C8k.default), {
        defaultRatio: (0, $dNPZM.getStoredRatio)($1ad6ee7b1ef3c0e6$var$DEFAULT_RATIO),
        minRatio: $1ad6ee7b1ef3c0e6$var$MIN_RATIO,
        maxRatio: $1ad6ee7b1ef3c0e6$var$MAX_RATIO,
        onRatioChange: onRatioChange
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ad6ee7b1ef3c0e6$var$SidebarForm, {
            resizerStyles: style,
            setResizerRef: ref,
            setFormRef: bulkOperationsForm.setRef
        })));
};
const $1ad6ee7b1ef3c0e6$export$8564253619317e8c = ({ permissionsQueryRef: permissionsQueryRef, ...props })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $khSYU.default), permissionsQueryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ad6ee7b1ef3c0e6$var$BulkOperationsCoreFullInternal, {
        ...props,
        hasBulkEditPermission: data.jira?.permission?.hasPermission ?? false
    });
};
const $1ad6ee7b1ef3c0e6$var$EntryPointContent = ({ props: props, queries: { permissionsQuery: permissionsQuery } })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ad6ee7b1ef3c0e6$export$8564253619317e8c, {
        ...props,
        permissionsQueryRef: permissionsQuery
    });
var $1ad6ee7b1ef3c0e6$export$2e2bcd8739ae039 = $1ad6ee7b1ef3c0e6$var$EntryPointContent;
const $1ad6ee7b1ef3c0e6$var$contentStyles = (0, $1DXK0.xcss)({
    height: '100%'
});

});
parcelRegister("khSYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dae39d2c974941a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef11623e69968eee1d8492a798c2e0fc>>
 * @relayHash da2409ae2bc56c51b0f8898e8ba8c588
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7

var $37Ewn = parcelRequire("37Ewn");
const $2dae39d2c974941a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "BULK_CHANGE"
                        }
                    ],
                    "concreteType": "JiraPermission",
                    "kind": "LinkedField",
                    "name": "permission",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPermission"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcFullCoreQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcFullCoreQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7",
            "metadata": {},
            "name": "srcFullCoreQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2dae39d2c974941a$var$node.hash = "8f533a407f873e189baff8b23fd6e216";
(0, $37Ewn.PreloadableQueryRegistry).set($2dae39d2c974941a$var$node.params.id, $2dae39d2c974941a$var$node);
var $2dae39d2c974941a$export$2e2bcd8739ae039 = $2dae39d2c974941a$var$node;

});

parcelRegister("lq8LU", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCore", () => $f374a1d520cac248$export$ac7b39f8b8a9f5cd);
$parcel$export(module.exports, "BulkOpsCoreWithToolbar", () => $f374a1d520cac248$export$e277fa5a9b41268f);

var $eJOHy = parcelRequire("eJOHy");

var $ceICw = parcelRequire("ceICw");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $i6Lq2 = parcelRequire("i6Lq2");

var $gkScf = parcelRequire("gkScf");

var $ftN6c = parcelRequire("ftN6c");

var $fQzwI = parcelRequire("fQzwI");

var $jLWCe = parcelRequire("jLWCe");

var $epTsa = parcelRequire("epTsa");

var $C81Q0 = parcelRequire("C81Q0");
const $f374a1d520cac248$var$entryPointParams = {};
const $f374a1d520cac248$export$ac7b39f8b8a9f5cd = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $C81Q0.asyncBulkOpsCoreEntryPoint), $f374a1d520cac248$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core",
        packageName: "jiraBulkOperationsCore",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: props
    });
};
const $f374a1d520cac248$export$e277fa5a9b41268f = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, ...props })=>{
    const hasSelectAllButton = Boolean(props.onSelectAll);
    const extraToolbarButtonsSkeleton = props.extraToolbarButtons?.map((button)=>({
            hasIcon: Boolean(button.icon),
            text: button.name
        })) || [];
    const { dismissBulkOperation: dismissBulkOperation } = (0, $gkScf.useBulkOperationsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onDeselectAll = (0, $eJOHy.useCallback)(()=>{
        dismissBulkOperation({
            createAnalyticsEvent: createAnalyticsEvent,
            dismissType: 'DESELECT_ALL_ISSUES'
        });
    }, [
        createAnalyticsEvent,
        dismissBulkOperation
    ]);
    // TODO: move this back to the bottom when cleaning up bulk_delete_experiment AND isLegacyBulkOperations
    const toolbarWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i6Lq2.ToolbarWrapper), {
        show: props.selectedIssueIds.length > 0,
        width: "calc(100% - var(--leftSidebarWidth, 0px))",
        onDeselectAll: onDeselectAll
    }, bulkOpsCoreEntryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jiraAsyncBulkOperationsCoreWithToolBar",
        packageName: "jiraBulkOperationsCoreWithToolBar",
        teamName: "deliveroo",
        entryPointReferenceSubject: bulkOpsCoreEntryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ceICw.BulkOperationsToolbarSkeleton), {
            buttons: extraToolbarButtonsSkeleton,
            hasSelectAllButton: hasSelectAllButton
        }),
        runtimeProps: props
    }));
    if (!(0, $epTsa.expVal)('bulk_delete_experiment', 'isEnabled', false) || props.isLegacyBulkOperations) return toolbarWrapper;
    const formProps = {
        selectedIssueIds: props.selectedIssueIds,
        onOpenForm: props.onOpenForm,
        onCloseForm: props.onCloseForm,
        onUpdateError: props.onUpdateError,
        onUpdateSuccess: props.onUpdateSuccess,
        onLegacyBulkEditRequest: props.onLegacyBulkEditRequest,
        onUpdateStart: props.onUpdateStart
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQzwI.FormSubmissionStatusContainer), {
        isGlobal: true,
        ...formProps
    }, toolbarWrapper, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLWCe.EditFormSubmitStatus), null));
};

});
parcelRegister("ceICw", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsToolbarSkeleton", () => $2a84c038f1d9f0b3$export$59bb23e2f88d002d);

var $eJOHy = parcelRequire("eJOHy");

var $lNTgs = parcelRequire("lNTgs");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $l4AGD = parcelRequire("l4AGD");

var $ej0Zh = parcelRequire("ej0Zh");

var $aq3A1 = parcelRequire("aq3A1");

var $i4BDD = parcelRequire("i4BDD");
const $2a84c038f1d9f0b3$export$59bb23e2f88d002d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const allButtons = [
        {
            text: formatMessage((0, $ej0Zh.messages).editButton),
            hasIcon: true
        },
        {
            text: formatMessage((0, $l4AGD.messages).changeStatus),
            hasIcon: true
        },
        ...(0, $epTsa.expVal)('bulk_delete_experiment', 'isEnabled', false) ? [
            {
                text: formatMessage((0, $aq3A1.messages).deleteButton),
                hasIcon: true
            }
        ] : [],
        ...(0, $epTsa.expVal)('bulk_watch_unwatch', 'isEnabled', false) ? [
            {
                text: formatMessage((0, $i4BDD.messages).watchOptions),
                hasIcon: true
            }
        ] : [],
        ...buttons
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lNTgs.ToolbarSkeleton), {
        hasSelectAllButton: hasSelectAllButton,
        buttons: allButtons
    });
};

});
parcelRegister("lNTgs", function(module, exports) {

$parcel$export(module.exports, "ToolbarSkeleton", () => $e6ee4dc3942bb796$export$5e29225d56ca7c7d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $l45MB = parcelRequire("l45MB");

var $5283O = parcelRequire("5283O");
const $e6ee4dc3942bb796$var$SkeletonBase = (props)=>/*#__PURE__*/ $eJOHy.createElement((0, $jjS5D.default), {
        ...props,
        height: "7px",
        isShimmering: true,
        color: "var(--ds-background-accent-gray-subtle, #8590A2)",
        ShimmeringEndColor: "var(--ds-background-accent-gray-bolder, #626F86)",
        width: props.width || '100%',
        "aria-hidden": "true"
    });
const $e6ee4dc3942bb796$var$SkeletonActionButton = ({ width: width, text: text, hasIcon: hasIcon })=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $e6ee4dc3942bb796$var$skeletonButtonStyles,
        "aria-hidden": "true",
        testId: "floating-toolbar.ui.skeleton.box"
    }, /*#__PURE__*/ $eJOHy.createElement($e6ee4dc3942bb796$var$SkeletonBase, {
        width: width
    }), /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), null, /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $e6ee4dc3942bb796$var$invisibleTextStyles
    }, text), /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: hasIcon ? $e6ee4dc3942bb796$var$iconSpacerStyles : $e6ee4dc3942bb796$var$noIconSpacerStyles
    })));
};
const $e6ee4dc3942bb796$var$SkeletonCloseIcon = ()=>/*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $e6ee4dc3942bb796$var$closeIconContainerStyles
    }, /*#__PURE__*/ $eJOHy.createElement($e6ee4dc3942bb796$var$SkeletonBase, {
        width: "16px"
    })); // These props are used to calculate a more appropriate skeleton
const $e6ee4dc3942bb796$export$5e29225d56ca7c7d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $l45MB.FloatingToolbarContainer), null, /*#__PURE__*/ $eJOHy.createElement((0, $l45MB.FloatingToolbarContent), null, /*#__PURE__*/ $eJOHy.createElement((0, $l45MB.FloatingToolbarSideContent), null, /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), null, /*#__PURE__*/ $eJOHy.createElement($e6ee4dc3942bb796$var$SkeletonBase, null), /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        space: "space.050",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $eJOHy.createElement("h2", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c1txw _1n261g80 _4cvr1h6o _ae4v1h6o _3um015vq _4t3iidpf"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $kDaaB.default), {
        ...(0, $5283O.default).selectedItemsLabel,
        values: {
            numberOfSelectedItems: 1,
            numberSelected: /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
                xcss: $e6ee4dc3942bb796$var$numberSelectedStyles
            }, 1)
        }
    }))))), hasSelectAllButton && /*#__PURE__*/ $eJOHy.createElement($e6ee4dc3942bb796$var$SkeletonActionButton, {
        text: formatMessage((0, $5283O.default).selectAllButtonLabel),
        hasIcon: true
    }), /*#__PURE__*/ $eJOHy.createElement((0, $l45MB.FloatingToolbarSeparator), null), /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        alignBlock: "center"
    }, buttons.map((button)=>{
        return /*#__PURE__*/ $eJOHy.createElement($e6ee4dc3942bb796$var$SkeletonActionButton, {
            key: button.text,
            ...button
        });
    }), /*#__PURE__*/ $eJOHy.createElement($e6ee4dc3942bb796$var$SkeletonCloseIcon, null))));
};
const $e6ee4dc3942bb796$var$skeletonButtonStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.150'
});
const $e6ee4dc3942bb796$var$closeIconContainerStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $e6ee4dc3942bb796$var$selectedContainer = null;
const $e6ee4dc3942bb796$var$iconSpacerStyles = (0, $1DXK0.xcss)({
    width: '26px'
});
const $e6ee4dc3942bb796$var$noIconSpacerStyles = (0, $1DXK0.xcss)({
    width: '4px'
});
const $e6ee4dc3942bb796$var$invisibleTextStyles = (0, $1DXK0.xcss)({
    height: '0',
    visibility: 'hidden'
});
const $e6ee4dc3942bb796$var$numberSelectedStyles = (0, $1DXK0.xcss)({
    width: '24px',
    marginRight: 'space.050'
});

});
parcelRegister("l45MB", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarContainer", () => $22300aa91d72ae41$export$da9876c16f406ff3);
$parcel$export(module.exports, "FloatingToolbarContent", () => $22300aa91d72ae41$export$634954b758f92d4);
$parcel$export(module.exports, "FloatingToolbarSeparator", () => $22300aa91d72ae41$export$e9d27765ebab091b);
$parcel$export(module.exports, "FloatingToolbarSideContent", () => $22300aa91d72ae41$export$fcfdbfa230cd1442);
$parcel$export(module.exports, "ContentSlider", () => $22300aa91d72ae41$export$ff7934be9f806b5f);

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $8UpxG = parcelRequire("8UpxG");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $1JSuz = parcelRequire("1JSuz");
const $22300aa91d72ae41$export$da9876c16f406ff3 = ({ children: children, onKeyDown: onKeyDown })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "toolbar",
        xcss: $22300aa91d72ae41$var$floatingContainerStyles,
        "aria-label": formatMessage((0, $1JSuz.messages).toolbarName),
        onKeyDown: onKeyDown
    }, children);
};
const $22300aa91d72ae41$export$634954b758f92d4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $22300aa91d72ae41$var$contentContainerStyles,
        alignBlock: "center"
    }, children);
const $22300aa91d72ae41$export$e9d27765ebab091b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $22300aa91d72ae41$var$separatorStyles
    });
const $22300aa91d72ae41$export$fcfdbfa230cd1442 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $22300aa91d72ae41$var$sideContentContainer
    }, children);
const $22300aa91d72ae41$export$ff7934be9f806b5f = ({ children: children, show: show })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), null, show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UpxG.default), {
        enterFrom: "bottom",
        fade: "inout"
    }, (slideInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", slideInProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $22300aa91d72ae41$var$mainContainerStyles
        }, children))));
const $22300aa91d72ae41$var$floatingContainerStyles = (0, $1DXK0.xcss)({
    padding: 'space.100',
    backgroundColor: 'color.background.neutral.bold.pressed',
    borderRadius: '6px',
    boxShadow: 'elevation.shadow.overlay'
});
const $22300aa91d72ae41$var$contentContainerStyles = (0, $1DXK0.xcss)({
    height: '32px',
    color: 'color.text.inverse',
    fontVariantNumeric: 'tabular-nums'
});
const $22300aa91d72ae41$var$separatorStyles = (0, $1DXK0.xcss)({
    height: '16px',
    width: '1px',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: '2px',
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
const $22300aa91d72ae41$var$sideContentContainer = (0, $1DXK0.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $22300aa91d72ae41$var$mainContainerStyles = (0, $1DXK0.xcss)({
    pointerEvents: 'auto'
});

});
parcelRegister("1JSuz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $50e1004b77fc81ec$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $50e1004b77fc81ec$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    toolbarName: {
        "id": "floating-toolbar.common.toolbar-name",
        "defaultMessage": "Bulk actions"
    }
});

});


parcelRegister("5283O", function(module, exports) {

$parcel$export(module.exports, "default", () => $d270c5bdf720b47c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d270c5bdf720b47c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    selectedItemsLabel: {
        "id": "floating-toolbar.selected-items-label",
        "defaultMessage": "{numberSelected} {numberOfSelectedItems, plural, one {selected} other {selected}}"
    },
    clearAllButton: {
        "id": "floating-toolbar.clear-all-button",
        "defaultMessage": "Clear all"
    },
    selectAllButtonLabel: {
        "id": "floating-toolbar.select-all-button-label",
        "defaultMessage": "Select all"
    }
});

});


parcelRegister("l4AGD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0081362c093a647f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $0081362c093a647f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    changeStatus: {
        "id": "bulk-operations-core.toolbar.use-status-action.change-status",
        "defaultMessage": "Change status"
    }
});

});

parcelRegister("ej0Zh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $470a9d898367917b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $470a9d898367917b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    editButton: {
        "id": "bulk-operations-core.toolbar.use-edit-action.edit-button",
        "defaultMessage": "Edit fields"
    }
});

});

parcelRegister("aq3A1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $04e29cb499fec232$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $04e29cb499fec232$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    deleteButton: {
        "id": "bulk-operations-core.toolbar.use-bulk-delete-action.detele-button",
        "defaultMessage": "Delete"
    }
});

});

parcelRegister("i4BDD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2b0abeb4df2e083c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2b0abeb4df2e083c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    watchOptions: {
        "id": "bulk-operations-core.toolbar.use-watch-action.watch-options",
        "defaultMessage": "Watch options"
    },
    startWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.start-watching",
        "defaultMessage": "Start watching"
    },
    stopWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.stop-watching",
        "defaultMessage": "Stop watching"
    },
    successFlagDescriptionStartWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.success-flag-description-start-watching",
        "defaultMessage": "You're watching {itemCount, plural, one {this work item} other {# work items}}."
    },
    successFlagDescriptionStopWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.success-flag-description-stop-watching",
        "defaultMessage": "You aren't watching {itemCount, plural, one {this work item} other {# work items}}."
    }
});

});


parcelRegister("i6Lq2", function(module, exports) {

$parcel$export(module.exports, "ToolbarWrapper", () => $8749ea5d436d1959$export$b705b0380e6fe1b0);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6d9QY = parcelRequire("6d9QY");

var $l45MB = parcelRequire("l45MB");
const $8749ea5d436d1959$export$b705b0380e6fe1b0 = ({ children: children, show: show, width: width, onDeselectAll: onDeselectAll })=>{
    const previousShow = (0, $6d9QY.usePrevious)(show);
    (0, $eJOHy.useEffect)(()=>{
        if (previousShow && !show) onDeselectAll?.();
    }, [
        onDeselectAll,
        previousShow,
        show
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $8749ea5d436d1959$var$floatingPositionerStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute -- width of component can change depending on the consumer
        style: {
            width: width || '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l45MB.ContentSlider), {
        show: show
    }, children));
};
const $8749ea5d436d1959$var$floatingPositionerStyles = (0, $1DXK0.xcss)({
    position: 'fixed',
    bottom: 'space.100',
    zIndex: 'layer',
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)'
});

});

parcelRegister("fQzwI", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionStatusContainer", () => $90f6b490793e7ee9$export$89eaa1757634ea57);
$parcel$export(module.exports, "useBulkOperationsFormSubmissionActions", () => $90f6b490793e7ee9$export$497042634f495a36);
$parcel$export(module.exports, "useFormSubmitStatus", () => $90f6b490793e7ee9$export$18b9f82ace8120bc);
$parcel$export(module.exports, "useFormSubmitProgressData", () => $90f6b490793e7ee9$export$f978a44c91fecf30);
$parcel$export(module.exports, "useFormSubmitSuccessData", () => $90f6b490793e7ee9$export$6def2d73afa09050);
$parcel$export(module.exports, "useFormSubmitIssueIds", () => $90f6b490793e7ee9$export$ec939e52c2362761);
$parcel$export(module.exports, "useFormSubmitErrorData", () => $90f6b490793e7ee9$export$1b826b4651e625bf);
$parcel$export(module.exports, "useFormSubmitFlagData", () => $90f6b490793e7ee9$export$f99368b86d418226);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $1Ye0P = parcelRequire("1Ye0P");

var $fkSe3 = parcelRequire("fkSe3");
const $90f6b490793e7ee9$var$initialState = {
    flagStatus: (0, $fkSe3.SubmitFlagStatus).NoFlag,
    flagData: undefined,
    data: undefined,
    callbacks: {},
    issueIds: []
};
const $90f6b490793e7ee9$var$Store = (0, $GtRbT.createStore)({
    initialState: $90f6b490793e7ee9$var$initialState,
    actions: $1Ye0P.actions,
    name: 'bulk-operations-form-submit-state'
});
const $90f6b490793e7ee9$export$31c34f2147c0d0ae = (0, $iJq0l.createHook)($90f6b490793e7ee9$var$Store);
const $90f6b490793e7ee9$export$c88ec44e7ac83ded = ()=>({ setState: setState }, { selectedIssueIds: selectedIssueIds, ...callbacks })=>{
        setState({
            callbacks: callbacks,
            issueIds: selectedIssueIds
        });
    };
const $90f6b490793e7ee9$export$89eaa1757634ea57 = (0, $6E16M.createContainer)($90f6b490793e7ee9$var$Store, {
    onInit: $90f6b490793e7ee9$export$c88ec44e7ac83ded,
    onUpdate: $90f6b490793e7ee9$export$c88ec44e7ac83ded
});
const $90f6b490793e7ee9$export$497042634f495a36 = (0, $iJq0l.createActionsHook)($90f6b490793e7ee9$var$Store);
const $90f6b490793e7ee9$var$getFormSubmitStatus = (state)=>state.flagStatus;
const $90f6b490793e7ee9$export$18b9f82ace8120bc = (0, $iJq0l.createStateHook)($90f6b490793e7ee9$var$Store, {
    selector: $90f6b490793e7ee9$var$getFormSubmitStatus
});
const $90f6b490793e7ee9$var$getFormSubmitProgressData = (state)=>{
    if (state.flagStatus === (0, $fkSe3.SubmitFlagStatus).ProgressFlag || state.flagStatus === (0, $fkSe3.SubmitFlagStatus).NoFlag) return state.data;
    return undefined;
};
const $90f6b490793e7ee9$export$f978a44c91fecf30 = (0, $iJq0l.createStateHook)($90f6b490793e7ee9$var$Store, {
    selector: $90f6b490793e7ee9$var$getFormSubmitProgressData
});
const $90f6b490793e7ee9$var$getFormSubmitSuccessData = (state)=>{
    if (state.flagStatus === (0, $fkSe3.SubmitFlagStatus).SuccessFlag) return state.data.numberOfIssuesUpdated;
    return undefined;
};
const $90f6b490793e7ee9$export$6def2d73afa09050 = (0, $iJq0l.createStateHook)($90f6b490793e7ee9$var$Store, {
    selector: $90f6b490793e7ee9$var$getFormSubmitSuccessData
});
const $90f6b490793e7ee9$var$getFormSubmitIssueIds = (state)=>state.issueIds;
const $90f6b490793e7ee9$export$ec939e52c2362761 = (0, $iJq0l.createStateHook)($90f6b490793e7ee9$var$Store, {
    selector: $90f6b490793e7ee9$var$getFormSubmitIssueIds
});
const $90f6b490793e7ee9$var$getFormSubmitErrorData = (state)=>{
    if (state.flagStatus === (0, $fkSe3.SubmitFlagStatus).PartialErrorFlag) return state.data;
    return undefined;
};
const $90f6b490793e7ee9$export$1b826b4651e625bf = (0, $iJq0l.createStateHook)($90f6b490793e7ee9$var$Store, {
    selector: $90f6b490793e7ee9$var$getFormSubmitErrorData
});
const $90f6b490793e7ee9$var$getFormSubmitFlagData = (state)=>state.flagData;
const $90f6b490793e7ee9$export$f99368b86d418226 = (0, $iJq0l.createStateHook)($90f6b490793e7ee9$var$Store, {
    selector: $90f6b490793e7ee9$var$getFormSubmitFlagData
});

});
parcelRegister("1Ye0P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e9bbdff5c32e9818$export$e324594224ef24da);

var $bpkMB = parcelRequire("bpkMB");

var $epTsa = parcelRequire("epTsa");

var $hdUAR = parcelRequire("hdUAR");

var $fkSe3 = parcelRequire("fkSe3");
const $e9bbdff5c32e9818$export$e324594224ef24da = {
    startSubmit: (interactionSource)=>({ setState: setState })=>{
            setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).NoFlag,
                data: undefined,
                interactionSource: interactionSource
            });
        },
    setIdle: ()=>({ setState: setState })=>{
            setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).NoFlag,
                data: undefined
            });
        },
    dismissPollingFlag: ()=>({ setState: setState, getState: getState })=>{
            const { flagStatus: flagStatus, data: data } = getState();
            if (flagStatus === (0, $fkSe3.SubmitFlagStatus).ProgressFlag) setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).NoFlag,
                flagData: undefined,
                data: data
            });
        },
    setPollingStart: (taskId, inputData, flagData)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks } = getState();
            callbacks.onUpdateStart?.(inputData.map(({ issueIds: issueIds, data: data, bulkOperationType: bulkOperationType })=>({
                    data: data,
                    issueIds: (0, $hdUAR.transformIssueArisToIds)(issueIds),
                    bulkOperationType: (0, $epTsa.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? bulkOperationType : undefined
                })));
            setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).ProgressFlag,
                flagData: flagData,
                data: {
                    taskId: taskId
                }
            });
        },
    /*
		This action is a temporary workaround to open the legacy bulk edit page.
		The Bulk Transition doesn't have support to return the issueKeys so this implementation was done here
		and will be removed when we implement Bulk Transition with multiple workflows.
		Project Plan: https://hello.atlassian.net/wiki/spaces/JSDee/pages/3388755384/Bulk+Transition+Project+Plan
		*/ redirectToLegacyBulkTransition: ()=>({ getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds } = getState();
            callbacks.onLegacyBulkEditRequest?.(issueIds);
        },
    updateProgress: (progress)=>({ setState: setState, getState: getState })=>{
            const { flagStatus: flagStatus, data: data } = getState();
            if (flagStatus !== (0, $fkSe3.SubmitFlagStatus).ProgressFlag) return;
            setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).ProgressFlag,
                data: {
                    progress: progress,
                    taskId: data.taskId
                }
            });
        },
    setError: ()=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds, interactionSource: interactionSource } = getState();
            if (interactionSource) (0, $bpkMB.setInteractionError)(interactionSource, {
                name: 'errorSubmitBulkEdit',
                errorMessage: `Error submitting changes for issues:${issueIds}`
            });
            callbacks.onUpdateError?.(issueIds);
            setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).ErrorFlag,
                data: {}
            });
        },
    setPartialError: (totalCount, failedCount, failedIssueKeys, failedIssueIds)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks } = getState();
            callbacks.onUpdateError?.(failedIssueIds.map(Number));
            setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).PartialErrorFlag,
                data: {
                    totalCount: totalCount,
                    failedCount: failedCount,
                    issueKeys: failedIssueKeys
                }
            });
        },
    setSuccess: (numberOfIssuesUpdated)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds } = getState();
            callbacks.onUpdateSuccess?.(issueIds);
            setState({
                flagStatus: (0, $fkSe3.SubmitFlagStatus).SuccessFlag,
                data: {
                    numberOfIssuesUpdated: numberOfIssuesUpdated
                }
            });
        }
};

});
parcelRegister("hdUAR", function(module, exports) {

$parcel$export(module.exports, "transformIssueArisToIds", () => $a6f5ec2b5fdda0d6$export$98b993b1def7c51b);

var $2ApNu = parcelRequire("2ApNu");
const $a6f5ec2b5fdda0d6$export$98b993b1def7c51b = (issueAris)=>issueAris.map((issueAri)=>parseInt((0, $2ApNu.JiraIssueAri).parse(issueAri).issueId, 10));

});
parcelRegister("2ApNu", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $1e22f45952f0c501$export$1da6808e89ee03e);

var $dhskT = parcelRequire("dhskT");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue/manifest.ts
var $1e22f45952f0c501$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dhskT.JiraIssueAriResourceOwner),
    resourceType: (0, $dhskT.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $1e22f45952f0c501$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dhskT", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $9ab2d7d34ec0a003$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $9ab2d7d34ec0a003$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $9ab2d7d34ec0a003$export$665a39f1b4e29e0a = "jira", $9ab2d7d34ec0a003$export$76beb4d0da177ad4 = "issue";

});



parcelRegister("fkSe3", function(module, exports) {

$parcel$export(module.exports, "SubmitFlagStatus", () => $d920471abbc64318$export$1f723227c515b0bc);
const $d920471abbc64318$export$1f723227c515b0bc = {
    ProgressFlag: 'ProgressFlag',
    SuccessFlag: 'SuccessFlag',
    ErrorFlag: 'ErrorFlag',
    PartialErrorFlag: 'PartialErrorFlag',
    NoFlag: 'NoFlag'
};

});



parcelRegister("jLWCe", function(module, exports) {

$parcel$export(module.exports, "EditFormSubmitStatus", () => $3948568ba905d5b2$export$ef11ca2bf4b4dcc1);

var $eJOHy = parcelRequire("eJOHy");

var $7uSfV = parcelRequire("7uSfV");

var $bNHev = parcelRequire("bNHev");

var $aCHrm = parcelRequire("aCHrm");
const $3948568ba905d5b2$export$ef11ca2bf4b4dcc1 = ()=>{
    (0, $aCHrm.useEditFormStatusFlags)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uSfV.BulkOperationsErrorBoundary), {
        id: "bulk-operations.core.edit-form.submit-status.progress-polling"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bNHev.EditFormSubmitStatusProgressPolling), null));
};

});
parcelRegister("7uSfV", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsErrorBoundary", () => $b26ef9eb863f86f2$export$d8d35fe42889b9a4);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");
const $b26ef9eb863f86f2$export$d8d35fe42889b9a4 = ({ id: id, children: children, fallback: fallback, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        packageName: "jiraBulkOperationsCommon",
        fallback: fallback || 'unmount',
        teamName: "deliveroo",
        onError: onError
    }, children);

});

parcelRegister("bNHev", function(module, exports) {

$parcel$export(module.exports, "EditFormSubmitStatusProgressPolling", () => $5788c320498d5641$export$6777d6eee8444c89);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ch9En = parcelRequire("ch9En");

var $8jqvI = parcelRequire("8jqvI");

var $kEUB1 = parcelRequire("kEUB1");

var $fQzwI = parcelRequire("fQzwI");

var $eWqTy = parcelRequire("eWqTy");

var $5GD4n = parcelRequire("5GD4n");
const $5788c320498d5641$export$6777d6eee8444c89 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { taskId: taskId } = (0, $fQzwI.useFormSubmitProgressData)() || {};
    const reset = (0, $eWqTy.useResetFormSubmissionState)();
    const [queryReference, fetchFormStatus, disposeQuery] = (0, $j4oe4.useQueryLoader)((0, $8jqvI.default));
    const refetch = (0, $eJOHy.useCallback)((id)=>{
        fetchFormStatus({
            taskId: id,
            cloudId: cloudId
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        cloudId,
        fetchFormStatus
    ]);
    (0, $eJOHy.useEffect)(()=>reset, [
        reset
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (taskId) refetch(taskId);
    }, [
        refetch,
        taskId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!taskId) disposeQuery();
    }, [
        disposeQuery,
        taskId
    ]);
    return queryReference && taskId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "bulk-operations.core.form.submit-status.progress-polling",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GD4n.ProgressPolling), {
        taskId: taskId,
        queryReference: queryReference,
        refetch: refetch
    })) : null;
};

});
parcelRegister("8jqvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3174135862998d78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40d6ef912a0c10b81e4bb6bf5d4de0cd>>
 * @relayHash 7fbd44b7b195b0263a244f68b9781379
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c
const $3174135862998d78$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "taskId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "taskId",
            "variableName": "taskId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "progress"
    }, v3 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueBulkOperationProgress",
                            "kind": "LinkedField",
                            "name": "bulkOperationProgress",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "processResponse_bulkOperationsCommon"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueBulkOperationProgress",
                            "kind": "LinkedField",
                            "name": "bulkOperationProgress",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueCount"
                                },
                                {
                                    "concreteType": "JiraIssueBulkOperationFailureConnection",
                                    "kind": "LinkedField",
                                    "name": "failedAccessibleIssues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueBulkOperationFailureEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueBulkOperationFailure",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c",
            "metadata": {},
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3174135862998d78$var$node.hash = "5fda96b9fc7b0bf909c4b82c92314696";
var $3174135862998d78$export$2e2bcd8739ae039 = $3174135862998d78$var$node;

});

parcelRegister("eWqTy", function(module, exports) {

$parcel$export(module.exports, "useFormStatusFlags", () => $2295d5e98db373ae$export$6c43148bc841854a);
$parcel$export(module.exports, "useResetFormSubmissionState", () => $2295d5e98db373ae$export$fc35d2af96f6134d);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $fQzwI = parcelRequire("fQzwI");

var $fkSe3 = parcelRequire("fkSe3");
const $2295d5e98db373ae$export$6c43148bc841854a = ({ renderSuccessFlag: renderSuccessFlag, renderInProgressFlag: renderInProgressFlag, renderErrorFlag: renderErrorFlag, renderPartialErrorFlag: renderPartialErrorFlag })=>{
    const submitStatus = (0, $fQzwI.useFormSubmitStatus)();
    const existingFlagId = (0, $eJOHy.useRef)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const { setIdle: setIdle, dismissPollingFlag: dismissPollingFlag } = (0, $fQzwI.useBulkOperationsFormSubmissionActions)();
    const dismissExistingFlag = (0, $eJOHy.useCallback)(()=>{
        if (existingFlagId.current) {
            dismissFlag(existingFlagId.current);
            existingFlagId.current = undefined;
        }
    }, [
        dismissFlag
    ]);
    const flags = (0, $eJOHy.useMemo)(()=>({
            [(0, $fkSe3.SubmitFlagStatus).ProgressFlag]: {
                id: 'in-progress-flag',
                render: (props)=>renderInProgressFlag({
                        ...props,
                        onDismissed: dismissPollingFlag
                    })
            },
            [(0, $fkSe3.SubmitFlagStatus).ErrorFlag]: {
                id: 'error-flag',
                render: (props)=>renderErrorFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            },
            [(0, $fkSe3.SubmitFlagStatus).PartialErrorFlag]: {
                id: 'partial-error-flag',
                render: (props)=>renderPartialErrorFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            },
            [(0, $fkSe3.SubmitFlagStatus).SuccessFlag]: {
                id: 'success-flag',
                render: (props)=>renderSuccessFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            }
        }), [
        dismissPollingFlag,
        renderErrorFlag,
        renderInProgressFlag,
        renderPartialErrorFlag,
        renderSuccessFlag,
        setIdle
    ]);
    (0, $eJOHy.useEffect)(()=>dismissExistingFlag, [
        dismissExistingFlag
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const flag = flags[submitStatus];
        if (!flag) {
            dismissExistingFlag();
            return;
        }
        if (existingFlagId.current) setTimeout(()=>{
            existingFlagId.current = showFlag(flag);
            dismissFlag('in-progress-flag');
        }, 200);
        else existingFlagId.current = showFlag(flag);
    }, [
        dismissFlag,
        dismissExistingFlag,
        setIdle,
        flags,
        submitStatus,
        showFlag
    ]);
};
const $2295d5e98db373ae$export$fc35d2af96f6134d = ()=>{
    const { setIdle: setIdle } = (0, $fQzwI.useBulkOperationsFormSubmissionActions)();
    return setIdle;
};

});

parcelRegister("5GD4n", function(module, exports) {

$parcel$export(module.exports, "ProgressPolling", () => $82ac610bbd1d686a$export$906b2a9d5f88a9d9);

var $8jqvI = parcelRequire("8jqvI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $gx60d = parcelRequire("gx60d");

var $fQzwI = parcelRequire("fQzwI");

var $c2lH5 = parcelRequire("c2lH5");

var $1xBhI = parcelRequire("1xBhI");
const $82ac610bbd1d686a$export$7f111648ca05f056 = 'bulkEditProgressPolling';
const $82ac610bbd1d686a$export$5578b12147815e51 = ()=>(0, $eJOHy.useRef)();
const $82ac610bbd1d686a$export$906b2a9d5f88a9d9 = ({ queryReference: queryReference, refetch: refetch, taskId: taskId })=>{
    const { logRetryAttempt: logRetryAttempt, retryStatus: retryStatus, resetRetryCount: resetRetryCount } = (0, $1xBhI.useAllowedRetries)();
    const previousProgress = $82ac610bbd1d686a$export$5578b12147815e51();
    const { setError: setError } = (0, $fQzwI.useBulkOperationsFormSubmissionActions)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $8jqvI.default), queryReference);
    const { status: status, taskId: dataTaskId, progress: progress } = data.jira?.bulkOperationProgress || {};
    const retry = (0, $eJOHy.useCallback)(()=>{
        if (previousProgress.current !== progress) resetRetryCount();
        else /*  Log retry attempt as task error when no status/taskId returned.
               Task errors happen because there is a delay before task reaches progress queue.
               Delay P99 is ~1s. */ logRetryAttempt(!status || !dataTaskId);
        // eslint-disable-next-line react-hooks/react-compiler
        previousProgress.current = progress;
        refetch(dataTaskId || taskId);
    }, [
        progress,
        previousProgress,
        refetch,
        dataTaskId,
        taskId,
        resetRetryCount,
        logRetryAttempt,
        status
    ]);
    const clearRetryInterval = (0, $1xBhI.useRetryInterval)(taskId, retry);
    (0, $eJOHy.useEffect)(()=>{
        if (retryStatus !== 'underLimit') {
            setError();
            if (retryStatus === 'maxTaskErrorAttemptsReached') (0, $gYnSx.default)({
                meta: (0, $gx60d.getAnalyticsMeta)($82ac610bbd1d686a$export$7f111648ca05f056),
                error: new Error('jira.bulkOperationProgress is null or undefined')
            });
            clearRetryInterval();
        }
    }, [
        clearRetryInterval,
        retryStatus,
        setError
    ]);
    return data.jira?.bulkOperationProgress ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c2lH5.ProcessResponse), {
        fragmentRef: data.jira.bulkOperationProgress,
        onStopRetry: clearRetryInterval,
        retryStatus: retryStatus
    }) : null;
};

});
parcelRegister("gx60d", function(module, exports) {

$parcel$export(module.exports, "generateButtonAction", () => $9ca3ce92db9e7b84$export$523c4156c8b6dfec);
$parcel$export(module.exports, "getAnalyticsMeta", () => $9ca3ce92db9e7b84$export$f43befd82d0c5b42);
const $9ca3ce92db9e7b84$export$523c4156c8b6dfec = ({ onClick: onClick, text: text, width: width, onFocus: onFocus, appearance: appearance })=>({
        onClick: onClick,
        onFocus: onFocus,
        text: text,
        appearance: appearance,
        theme: (current, themeProps)=>appearance === 'link' ? {
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    color: "var(--ds-text-discovery, #5E4DB2)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            } : {
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    backgroundColor: "var(--ds-icon-discovery, #8270DB)",
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    width: width && width
                },
                spinnerStyles: current(themeProps).spinnerStyles
            }
    });
const $9ca3ce92db9e7b84$export$f43befd82d0c5b42 = (id)=>({
        id: id,
        packageName: 'jiraBulkOperationsCommon',
        teamName: 'deliveroo'
    });

});

parcelRegister("c2lH5", function(module, exports) {

$parcel$export(module.exports, "ProcessResponse", () => $1c43e2c9d79ed8a8$export$e9b0d96d75994f3f);

var $4s4Nj = parcelRequire("4s4Nj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $gx60d = parcelRequire("gx60d");

var $fQzwI = parcelRequire("fQzwI");
const $1c43e2c9d79ed8a8$export$7f111648ca05f056 = 'bulkEditProgressPolling';
const $1c43e2c9d79ed8a8$var$CANCELLED = 'CANCELLED';
const $1c43e2c9d79ed8a8$var$DEAD = 'DEAD';
const $1c43e2c9d79ed8a8$var$FAILED = 'FAILED';
const $1c43e2c9d79ed8a8$var$COMPLETE = 'COMPLETE';
const $1c43e2c9d79ed8a8$export$e8667bfb18d4707c = [
    $1c43e2c9d79ed8a8$var$CANCELLED,
    $1c43e2c9d79ed8a8$var$DEAD,
    $1c43e2c9d79ed8a8$var$FAILED
];
const $1c43e2c9d79ed8a8$export$e9b0d96d75994f3f = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentRef: fragmentRef, onStopRetry: onStopRetry, retryStatus: retryStatus })=>{
    const { setError: setError, setSuccess: setSuccess, updateProgress: updateProgress, setPartialError: setPartialError } = (0, $fQzwI.useBulkOperationsFormSubmissionActions)();
    const data = (0, $j4oe4.useFragment)((0, $4s4Nj.default), fragmentRef);
    const { status: status, totalIssueCount: totalIssueCount, progress: progress, failedAccessibleIssues: failedAccessibleIssues } = data;
    const { failedIds: failedIds, failedKeys: failedKeys } = (0, $eJOHy.useMemo)(()=>{
        const initial = {
            failedIds: [],
            failedKeys: []
        };
        return (failedAccessibleIssues?.edges || []).reduce((acc, curr)=>{
            const issue = curr?.node?.issue;
            if (issue?.issueId) acc.failedIds.push(Number(issue.issueId));
            if (issue?.key) acc.failedKeys.push(issue.key);
            return acc;
        }, initial);
    }, [
        failedAccessibleIssues
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (retryStatus !== 'underLimit') return;
        const isProgressFinished = status === $1c43e2c9d79ed8a8$var$COMPLETE || $1c43e2c9d79ed8a8$export$e8667bfb18d4707c.includes(status);
        const isPartialError = (status === $1c43e2c9d79ed8a8$var$FAILED || status === $1c43e2c9d79ed8a8$var$COMPLETE) && totalIssueCount && failedAccessibleIssues?.edges?.length;
        if (status === $1c43e2c9d79ed8a8$var$COMPLETE && !totalIssueCount) (0, $gYnSx.default)({
            meta: (0, $gx60d.getAnalyticsMeta)($1c43e2c9d79ed8a8$export$7f111648ca05f056),
            error: new Error('jira.bulkOperationProgress.totalIssueCount is 0, null or undefined on task complete'),
            attributes: {
                totalIssueCount: totalIssueCount,
                failures: JSON.stringify(failedAccessibleIssues)
            }
        });
        if (isProgressFinished) {
            if (isPartialError) {
                const failedCount = failedIds.length;
                setPartialError(totalIssueCount, failedCount, failedKeys, failedIds.map(Number));
            } else if (status !== $1c43e2c9d79ed8a8$var$COMPLETE) setError();
            onStopRetry();
            if (!isPartialError && status === $1c43e2c9d79ed8a8$var$COMPLETE) setSuccess(totalIssueCount || 0);
            return;
        }
        if (progress) updateProgress(progress / 100);
    }, [
        failedAccessibleIssues,
        failedAccessibleIssues?.edges?.length,
        failedIds,
        failedKeys,
        onStopRetry,
        progress,
        retryStatus,
        setError,
        setPartialError,
        setSuccess,
        status,
        totalIssueCount,
        updateProgress
    ]);
    return null;
});

});
parcelRegister("4s4Nj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aa8c70c5a79d4df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac9d636d8d9008c1a9afc7eb05dd5e9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8aa8c70c5a79d4df$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "processResponse_bulkOperationsCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "progress"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueCount"
        },
        {
            "concreteType": "JiraIssueBulkOperationFailureConnection",
            "kind": "LinkedField",
            "name": "failedAccessibleIssues",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueBulkOperationFailureEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueBulkOperationFailure",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "issueId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueBulkOperationProgress"
};
$8aa8c70c5a79d4df$var$node.hash = "6fd178055d35ff262e914a98799a4f45";
var $8aa8c70c5a79d4df$export$2e2bcd8739ae039 = $8aa8c70c5a79d4df$var$node;

});


parcelRegister("1xBhI", function(module, exports) {

$parcel$export(module.exports, "useAllowedRetries", () => $28b12ef2a169de5e$export$4ae93933b6be0be6);
$parcel$export(module.exports, "useRetryInterval", () => $28b12ef2a169de5e$export$f61ff7daea15ab2c);

var $eJOHy = parcelRequire("eJOHy");
const $28b12ef2a169de5e$export$dc3de1463a3f7c7c = 5;
const $28b12ef2a169de5e$export$9359b1dc19be60fe = 2;
const $28b12ef2a169de5e$export$996964a131ee58eb = 1500;
const $28b12ef2a169de5e$export$4ae93933b6be0be6 = ()=>{
    const [retryStatus, setRetryStatus] = (0, $eJOHy.useState)('underLimit');
    const numberOfAttempts = (0, $eJOHy.useRef)(0);
    const isPreviousTaskError = (0, $eJOHy.useRef)();
    const logRetryAttempt = (0, $eJOHy.useCallback)((isTaskError)=>{
        if (isPreviousTaskError.current !== undefined && isPreviousTaskError.current !== isTaskError) numberOfAttempts.current = 0;
        numberOfAttempts.current += 1;
        if (numberOfAttempts.current >= (isTaskError ? $28b12ef2a169de5e$export$9359b1dc19be60fe : $28b12ef2a169de5e$export$dc3de1463a3f7c7c)) setRetryStatus(isTaskError ? 'maxTaskErrorAttemptsReached' : 'maxAttemptsReached');
        isPreviousTaskError.current = isTaskError;
    }, []);
    const resetRetryCount = (0, $eJOHy.useCallback)(()=>{
        setRetryStatus('underLimit');
        numberOfAttempts.current = 0;
    }, []);
    return {
        logRetryAttempt: logRetryAttempt,
        retryStatus: retryStatus,
        resetRetryCount: resetRetryCount
    };
};
const $28b12ef2a169de5e$export$f61ff7daea15ab2c = (taskId, callback)=>{
    const callbackRef = (0, $eJOHy.useRef)(callback);
    (0, $eJOHy.useEffect)(()=>{
        // make a reference to the retry callback for setInterval to invoke.
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const intervalId = (0, $eJOHy.useRef)();
    const clearRetryInterval = (0, $eJOHy.useCallback)(()=>{
        if (intervalId.current) {
            clearInterval(intervalId.current);
            intervalId.current = undefined;
        }
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (taskId) {
            const retry = ()=>{
                callbackRef.current();
            };
            intervalId.current = typeof window !== 'undefined' ? window.setInterval(retry, $28b12ef2a169de5e$export$996964a131ee58eb) : undefined;
        }
        return clearRetryInterval;
    }, [
        clearRetryInterval,
        taskId
    ]);
    return clearRetryInterval;
};

});



parcelRegister("aCHrm", function(module, exports) {

$parcel$export(module.exports, "useEditFormStatusFlags", () => $befbe79f303c7c7b$export$7aafd3aa5686e9e5);

var $eJOHy = parcelRequire("eJOHy");

var $8mETm = parcelRequire("8mETm");

var $eWqTy = parcelRequire("eWqTy");

var $5tD8G = parcelRequire("5tD8G");

var $gbqst = parcelRequire("gbqst");

var $jmf94 = parcelRequire("jmf94");

var $ay8rp = parcelRequire("ay8rp");
const $befbe79f303c7c7b$export$7aafd3aa5686e9e5 = ()=>{
    const bulkOpsFlow = (0, $8mETm.useBulkOpsSessionContext)();
    const renderInProgressFlag = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbqst.InProgressFlag), props), []);
    const renderSuccessFlag = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ay8rp.OperationSuccessFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    const renderErrorFlag = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5tD8G.OperationErrorFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    const renderPartialErrorFlag = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmf94.OperationPartialErrorFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    (0, $eWqTy.useFormStatusFlags)({
        renderInProgressFlag: renderInProgressFlag,
        renderSuccessFlag: renderSuccessFlag,
        renderErrorFlag: renderErrorFlag,
        renderPartialErrorFlag: renderPartialErrorFlag
    });
};

});
parcelRegister("8mETm", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $cabb9ba179f51d91$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $cabb9ba179f51d91$export$95271787b6ae4d3c);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");

var $adnz6 = parcelRequire("adnz6");
const $cabb9ba179f51d91$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $cabb9ba179f51d91$export$8ab440f197429d1e = (props)=>{
    const [bulkOpsFlow] = (0, $eJOHy.useState)(new (0, $adnz6.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $eJOHy.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cabb9ba179f51d91$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $cabb9ba179f51d91$export$95271787b6ae4d3c = ()=>(0, $eJOHy.useContext)($cabb9ba179f51d91$var$BulkOpsAnalyticsContext);

});
parcelRegister("adnz6", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $7ad0310f81a686a1$export$74bf75c57acfbb74);

var $aXKmr = parcelRequire("aXKmr");
class $7ad0310f81a686a1$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    get bulkOperationType() {
        return this.bulkOperationTypeValue;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, $aXKmr.v4)();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    setBulkOperationType(bulkOperationType) {
        this.bulkOperationTypeValue = bulkOperationType;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("5tD8G", function(module, exports) {

$parcel$export(module.exports, "OperationErrorFlag", () => $c51fc71652b5339e$export$e8ce457da529d993);

var $eJOHy = parcelRequire("eJOHy");

var $a9cht = parcelRequire("a9cht");

var $lRq8t = parcelRequire("lRq8t");

var $1INRK = parcelRequire("1INRK");

var $fQzwI = parcelRequire("fQzwI");


var $9lQx1 = parcelRequire("9lQx1");
const $c51fc71652b5339e$export$e8ce457da529d993 = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issueIds = (0, $fQzwI.useFormSubmitIssueIds)();
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            numSelectedCards: issueIds.length ?? 0,
            flagType: 'error'
        }), [
        issueIds.length
    ]);
    (0, $1INRK.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.ErrorFlag), {
        ...props,
        testId: (0, $b5d0d79d2d53a324$export$a7bb072605d6094c),
        id: (0, $b5d0d79d2d53a324$export$5881677fb314e6d9),
        title: formatMessage((0, $9lQx1.default).title),
        description: formatMessage((0, $9lQx1.default).description),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.error-flag",
        messageType: "transactional"
    });
};

});
parcelRegister("1INRK", function(module, exports) {

$parcel$export(module.exports, "useFlagAnalytics", () => $41260be8c51a8cf2$export$f367641684fed076);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $41260be8c51a8cf2$export$f367641684fed076 = (attributes, bulkOpsFlow)=>{
    const analyticsEventFired = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!analyticsEventFired.current) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'bulkProcess',
                action: 'complete'
            });
            const actionSubjectId = bulkOpsFlow?.bulkOperationType;
            const analyticsAttributes = {
                ...attributes,
                bulkOpsSessionID: bulkOpsFlow?.sessionID
            };
            if (actionSubjectId) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, actionSubjectId, analyticsAttributes);
            else (0, $gCeeo.fireUIAnalytics)(analyticsEvent, analyticsAttributes);
            bulkOpsFlow?.setBulkOperationType(undefined);
            analyticsEventFired.current = true;
        }
    }, [
        createAnalyticsEvent,
        bulkOpsFlow,
        attributes
    ]);
};

});

const $b5d0d79d2d53a324$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.error-flag';
const $b5d0d79d2d53a324$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.error-flag';

parcelRegister("9lQx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $22f33644def2d631$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $22f33644def2d631$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.error-flag.title",
        "defaultMessage": "Failed to update"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.error-flag.description",
        "defaultMessage": "We were unable to make those changes. Try again, or view the items that failed to update."
    }
});

});


parcelRegister("gbqst", function(module, exports) {

$parcel$export(module.exports, "InProgressFlag", () => $90889cde6c313797$export$e75d6d3573e1e6fe);

var $eJOHy = parcelRequire("eJOHy");

var $7kJQm = parcelRequire("7kJQm");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $c9qWp = parcelRequire("c9qWp");

var $a9cht = parcelRequire("a9cht");

var $lRq8t = parcelRequire("lRq8t");

var $fQzwI = parcelRequire("fQzwI");


var $2fbUz = parcelRequire("2fbUz");
const $90889cde6c313797$export$e75d6d3573e1e6fe = ({ onDismissed: onDismissed, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const progressData = (0, $fQzwI.useFormSubmitProgressData)();
    const progress = progressData?.progress;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.InfoFlag), {
        ...props,
        testId: (0, $f7550ddbf8c4c6cd$export$a7bb072605d6094c),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        }),
        id: (0, $f7550ddbf8c4c6cd$export$5881677fb314e6d9),
        title: formatMessage((0, $2fbUz.default).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $2fbUz.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $90889cde6c313797$var$progressBarContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9qWp.default), {
            ariaLabel: formatMessage((0, $2fbUz.default).title),
            isIndeterminate: !progress,
            value: progress
        }))),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.in-progress-flag.info-flag.in-progress-flag",
        messageType: "transactional"
    });
};
const $90889cde6c313797$var$progressBarContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("c9qWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72ae726177d4e89$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $f72ae726177d4e89$var$MIN_VALUE = 0;
const $f72ae726177d4e89$var$MAX_VALUE = 1;
const $f72ae726177d4e89$var$increasingBarAnimation = null;
const $f72ae726177d4e89$var$decreasingBarAnimation = null;
const $f72ae726177d4e89$var$containerStyles = null;
const $f72ae726177d4e89$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $f72ae726177d4e89$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $f72ae726177d4e89$var$barStyles = null;
const $f72ae726177d4e89$var$determinateBarStyles = null;
const $f72ae726177d4e89$var$increasingBarStyles = null;
const $f72ae726177d4e89$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $f72ae726177d4e89$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $f72ae726177d4e89$var$MIN_VALUE : Math.max($f72ae726177d4e89$var$MIN_VALUE, Math.min(value, $f72ae726177d4e89$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $f72ae726177d4e89$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $f72ae726177d4e89$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $f72ae726177d4e89$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hcewu.default)([
                "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                $f72ae726177d4e89$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $f72ae726177d4e89$export$2e2bcd8739ae039 = $f72ae726177d4e89$var$ProgressBar;

});

const $f7550ddbf8c4c6cd$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.in-progress-flag';
const $f7550ddbf8c4c6cd$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.in-progress-flag';

parcelRegister("2fbUz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccb22170c272808$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9ccb22170c272808$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.in-progress-flag.title",
        "defaultMessage": "Bulk action in progress"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.in-progress-flag.description",
        "defaultMessage": "Stay on this page until the bulk action is finished."
    }
});

});


parcelRegister("jmf94", function(module, exports) {

$parcel$export(module.exports, "OperationPartialErrorFlag", () => $68ed34498be865be$export$3229b80e24d6bab4);

var $eJOHy = parcelRequire("eJOHy");

var $a9cht = parcelRequire("a9cht");

var $ecCxV = parcelRequire("ecCxV");

var $lRq8t = parcelRequire("lRq8t");

var $1INRK = parcelRequire("1INRK");

var $fQzwI = parcelRequire("fQzwI");


var $bvOYR = parcelRequire("bvOYR");
const $68ed34498be865be$export$3229b80e24d6bab4 = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issueIds = (0, $fQzwI.useFormSubmitIssueIds)();
    const errorData = (0, $fQzwI.useFormSubmitErrorData)();
    const openInProductHelp = (0, $ecCxV.useHelpPanelLink)();
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            numSelectedCards: issueIds.length ?? 0,
            numFailedCards: errorData?.failedCount ?? 0,
            failedIssueKeys: errorData?.issueKeys ?? [],
            flagType: 'error'
        }), [
        errorData?.failedCount,
        errorData?.issueKeys,
        issueIds.length
    ]);
    (0, $1INRK.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    const getViewSummaryURL = (0, $eJOHy.useMemo)(()=>{
        const errorDataIssueIds = errorData?.issueKeys?.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${errorDataIssueIds})`);
        return `/issues/?jql=${jqlSearch}`;
    }, [
        errorData?.issueKeys
    ]);
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        openInProductHelp((0, $bad2d7b6a3acdcd7$export$353a2cc7a64c70f2));
    }, [
        openInProductHelp
    ]);
    const flagActions = (0, $eJOHy.useMemo)(()=>[
            {
                content: formatMessage((0, $bvOYR.default).viewSummary),
                href: getViewSummaryURL,
                target: '_blank'
            },
            {
                content: formatMessage((0, $bvOYR.default).learnMore),
                onClick: handleLearnMoreClick
            }
        ], [
        formatMessage,
        getViewSummaryURL,
        handleLearnMoreClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.ErrorFlag), {
        ...props,
        testId: (0, $bad2d7b6a3acdcd7$export$a7bb072605d6094c),
        id: (0, $bad2d7b6a3acdcd7$export$5881677fb314e6d9),
        title: formatMessage((0, $bvOYR.default).title, {
            failedCount: errorData?.failedCount,
            totalCount: errorData?.totalCount
        }),
        description: formatMessage((0, $bvOYR.default).description),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.partial-error-flag.error-flag",
        messageType: "transactional",
        actions: flagActions
    });
};

});
const $bad2d7b6a3acdcd7$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.partial-error-flag';
const $bad2d7b6a3acdcd7$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.partial-error-flag';
const $bad2d7b6a3acdcd7$export$353a2cc7a64c70f2 = '62h4g5fA9BUhungZSSNyEl';

parcelRegister("bvOYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $253f9a10b4ae1ca8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $253f9a10b4ae1ca8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.title",
        "defaultMessage": "{failedCount}/{totalCount} items not updated"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.description",
        "defaultMessage": "We were unable to update some of the items. View summary to view the items that failed to update."
    },
    viewSummary: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.view-summary",
        "defaultMessage": "View summary"
    },
    learnMore: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("ay8rp", function(module, exports) {

$parcel$export(module.exports, "OperationSuccessFlag", () => $4671ec114bb82165$export$3a6420f74b01547e);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $a9cht = parcelRequire("a9cht");

var $lRq8t = parcelRequire("lRq8t");

var $1INRK = parcelRequire("1INRK");

var $fQzwI = parcelRequire("fQzwI");


var $2txFp = parcelRequire("2txFp");
const $4671ec114bb82165$export$3a6420f74b01547e = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const flagData = (0, $fQzwI.useFormSubmitFlagData)();
    const issueIds = (0, $fQzwI.useFormSubmitIssueIds)();
    const count = (0, $eJOHy.useRef)((0, $fQzwI.useFormSubmitSuccessData)());
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            numSelectedCards: issueIds.length,
            flagType: 'success',
            numCardsUpdated: count.current
        }), [
        issueIds.length
    ]);
    (0, $1INRK.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    const flagDescription = (0, $eJOHy.useMemo)(()=>{
        if (flagData && flagData.customDescription && (0, $epTsa.expVal)('bulk_watch_unwatch', 'isEnabled', false)) return flagData.customDescription;
        if ((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return formatMessage((0, $2txFp.default).descriptionIssueTermRefresh, {
            count: count.current
        });
        return formatMessage((0, $2txFp.default).description, {
            count: count.current
        });
    }, [
        flagData,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.SuccessFlag), {
        ...props,
        testId: (0, $96e19c48d05a687f$export$a7bb072605d6094c),
        id: (0, $96e19c48d05a687f$export$5881677fb314e6d9),
        title: formatMessage((0, $2txFp.default).title),
        description: flagDescription,
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.success-flag",
        messageType: "transactional"
    });
};

});
const $96e19c48d05a687f$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.submit-success-flag';
const $96e19c48d05a687f$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.operation-success-flag';

parcelRegister("2txFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c203b45838641e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $74c203b45838641e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.title",
        "defaultMessage": "Bulk action complete"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.description",
        "defaultMessage": "You\u2019ve edited {count, plural, one {# issue} other {# issues}}."
    },
    descriptionIssueTermRefresh: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.description-issue-term-refresh",
        "defaultMessage": "You\u2019ve edited {count, plural, one {# work item} other {# work items}}."
    }
});

});





parcelRegister("6m6ZF", function(module, exports) {

$parcel$export(module.exports, "useReferenceLoader", () => $c4893d6a41337b12$export$727d936bc4a88f4e);

var $eJOHy = parcelRequire("eJOHy");
const $c4893d6a41337b12$export$727d936bc4a88f4e = ()=>{
    const [ref, setRef] = (0, $eJOHy.useState)(null);
    return (0, $eJOHy.useMemo)(()=>({
            setRef: setRef,
            ref: ref
        }), [
        setRef,
        ref
    ]);
};

});

parcelRegister("dNPZM", function(module, exports) {

$parcel$export(module.exports, "getStoredRatio", () => $9440d2918e3d4518$export$ab00ac4df0fe2eb8);
$parcel$export(module.exports, "setStoredRatio", () => $9440d2918e3d4518$export$90191d29786b1c88);
$parcel$export(module.exports, "useOnUpdate", () => $9440d2918e3d4518$export$76efe25a902f3d7e);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $etNo6 = parcelRequire("etNo6");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $dnU6V = parcelRequire("dnU6V");

var $814y1 = parcelRequire("814y1");

var $3pSHx = parcelRequire("3pSHx");

var $kqd31 = parcelRequire("kqd31");

var $hOcoS = parcelRequire("hOcoS");

var $2ApNu = parcelRequire("2ApNu");

var $epTsa = parcelRequire("epTsa");
const $9440d2918e3d4518$var$getSidebarWidthCache = (()=>{
    let sidebarWidthCache;
    return ()=>{
        if (false) return;
        if (!sidebarWidthCache) sidebarWidthCache = (0, $dnU6V.createLocalStorageProvider)('bulk_operations_sidebar_ratio');
        return sidebarWidthCache;
    };
})();
const $9440d2918e3d4518$var$STORAGE_KEY = 'sidebar_ratio';
const $9440d2918e3d4518$export$ab00ac4df0fe2eb8 = (defaultValue)=>$9440d2918e3d4518$var$getSidebarWidthCache()?.get($9440d2918e3d4518$var$STORAGE_KEY) ?? defaultValue;
const $9440d2918e3d4518$export$90191d29786b1c88 = (ratio)=>$9440d2918e3d4518$var$getSidebarWidthCache()?.set($9440d2918e3d4518$var$STORAGE_KEY, ratio);
const $9440d2918e3d4518$export$76efe25a902f3d7e = (issueFields)=>{
    const onUpdate = (0, $eJOHy.useCallback)((data)=>(store)=>{
            try {
                data.forEach(({ ariIssueIds: ariIssueIds, formData: formData, extraData: extraData, bulkOperationType: bulkOperationType })=>{
                    issueFields.forEach((field)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        const formFieldData = formData[field.fieldId];
                        if (formFieldData !== undefined) ariIssueIds.forEach((ariIssueId)=>{
                            const { siteId: siteId, issueId: issueId } = (0, $2ApNu.JiraIssueAri).parse(ariIssueId);
                            const ariIssueFieldId = (0, $3pSHx.JiraIssuefieldvalueAri).create({
                                siteId: siteId,
                                issueId: issueId,
                                fieldId: field.fieldId
                            }).toString();
                            const relayDataId = (0, $kqd31.default)({
                                id: ariIssueFieldId
                            }, field.gqlType);
                            if (relayDataId) {
                                const storeField = store.get(relayDataId);
                                if (storeField) switch(field.gqlType){
                                    case 0, $814y1.PRIORITY_GQL_FIELD:
                                        {
                                            const newRecord = store.create((0, $aXKmr.v4)(), 'JiraPriority');
                                            newRecord.setValue(formFieldData.iconUrl, 'iconUrl');
                                            newRecord.setValue(formFieldData.label, 'name');
                                            storeField.setLinkedRecord(newRecord, 'priority');
                                            break;
                                        }
                                    case 0, $814y1.USER_PICKER_GQL_FIELD:
                                        {
                                            // TODO: there is a bug with Automatic not being picked up in NIN view
                                            // This needs to be fixed separately https://hello.jira.atlassian.cloud/browse/DEE-6423
                                            if (formFieldData === null) {
                                                storeField.setValue(null, 'user');
                                                return;
                                            }
                                            const newRecord = store.create((0, $aXKmr.v4)(), 'AtlassianAccountUser');
                                            if (formFieldData.accountId) {
                                                newRecord.setValue(formFieldData.accountId, 'accountId');
                                                newRecord.setValue(formFieldData.displayName, 'name');
                                                newRecord.setValue(formFieldData.avatarUrls?.['48x48'], 'picture');
                                            } else {
                                                newRecord.setValue(formFieldData.id, 'accountId');
                                                newRecord.setValue(formFieldData.name, 'name');
                                                newRecord.setValue(formFieldData.avatarUrl, 'picture');
                                            }
                                            newRecord.setValue('active', 'accountStatus');
                                            storeField.setLinkedRecord(newRecord, 'user');
                                            break;
                                        }
                                    case 0, $814y1.DATE_PICKER_GQL_FIELD:
                                        storeField.setValue(formFieldData, 'date');
                                        break;
                                    case 0, $814y1.NUMBER_GQL_FIELD:
                                        storeField.setValue(formFieldData === '' ? null : formFieldData, 'number');
                                        break;
                                    case 0, $814y1.TEXT_GQL_FIELD:
                                        storeField.setValue(formFieldData, 'text');
                                        break;
                                    case 0, $814y1.PARENT_GQL_FIELD:
                                        {
                                            if (formFieldData === null) {
                                                storeField.setValue(null, 'parentIssue');
                                                return;
                                            }
                                            const parentIssue = store.create((0, $aXKmr.v4)(), 'JiraIssue');
                                            parentIssue.setValue(formFieldData.key, 'key');
                                            const summaryField = store.create((0, $aXKmr.v4)(), 'JiraSingleLineTextField');
                                            summaryField.setValue(formFieldData.fields.summary, 'text');
                                            parentIssue.setLinkedRecord(summaryField, 'summaryField');
                                            const issueColorField = store.create((0, $aXKmr.v4)(), 'JiraColorField');
                                            const colorField = store.create((0, $aXKmr.v4)(), 'JiraColor');
                                            colorField.setValue(formFieldData.color, 'colorKey');
                                            issueColorField.setLinkedRecord(colorField, 'color');
                                            parentIssue.setLinkedRecord(issueColorField, 'issueColorField');
                                            const issueTypeField = store.create((0, $aXKmr.v4)(), 'JiraIssueTypeField');
                                            const issueType = store.create((0, $aXKmr.v4)(), 'JiraIssueType');
                                            const avatar = store.create((0, $aXKmr.v4)(), 'JiraAvatar');
                                            avatar.setValue(formFieldData.fields.issuetype.iconUrl, 'xsmall');
                                            issueType.setValue(formFieldData.fields.issuetype.name, 'name');
                                            issueType.setLinkedRecord(avatar, 'avatar');
                                            issueTypeField.setLinkedRecord(issueType, 'issueType');
                                            parentIssue.setLinkedRecord(issueTypeField, 'issueTypeField');
                                            storeField.setLinkedRecord(parentIssue, 'parentIssue');
                                            break;
                                        }
                                    case 0, $814y1.LABEL_GQL_FIELD:
                                        {
                                            const multiSelectFieldOption = extraData?.[field.fieldId];
                                            if (multiSelectFieldOption === 'ADD' || multiSelectFieldOption === 'REPLACE') {
                                                const newEdges = formFieldData.map((labelData)=>{
                                                    const label = store.create((0, $aXKmr.v4)(), 'JiraLabel');
                                                    label.setValue(labelData.value, 'name');
                                                    const edge = store.create((0, $aXKmr.v4)(), 'JiraLabelEdge');
                                                    edge.setLinkedRecord(label, 'node');
                                                    return edge;
                                                });
                                                const selectedLabelsConnection = storeField.getLinkedRecord('selectedLabelsConnection', {
                                                    first: 1000
                                                });
                                                const existingEdges = selectedLabelsConnection?.getLinkedRecords('edges') || [];
                                                const combinedEdges = [
                                                    ...multiSelectFieldOption === 'ADD' ? existingEdges : [],
                                                    ...newEdges
                                                ];
                                                const seenLabels = new Set();
                                                const uniqueEdges = combinedEdges.filter((edge)=>{
                                                    const labelName = edge.getLinkedRecord('node').getValue('name');
                                                    if (seenLabels.has(labelName)) return false;
                                                    seenLabels.add(labelName);
                                                    return true;
                                                });
                                                uniqueEdges.sort((edgeA, edgeB)=>{
                                                    const labelA = edgeA.getLinkedRecord('node').getValue('name');
                                                    const labelB = edgeB.getLinkedRecord('node').getValue('name');
                                                    return labelA.localeCompare(labelB);
                                                });
                                                selectedLabelsConnection?.setLinkedRecords(uniqueEdges, 'edges');
                                                selectedLabelsConnection?.setValue(uniqueEdges.length, 'totalCount');
                                                break;
                                            }
                                            if (multiSelectFieldOption === 'REMOVE') {
                                                const selectedLabelsConnection = storeField.getLinkedRecord('selectedLabelsConnection', {
                                                    first: 1000
                                                });
                                                if (selectedLabelsConnection) {
                                                    const existingEdges = selectedLabelsConnection.getLinkedRecords('edges') || [];
                                                    const labelsToRemove = formFieldData.map((labelData)=>labelData.value);
                                                    const updatedEdges = existingEdges.filter((edge)=>{
                                                        const labelName = edge?.getLinkedRecord('node')?.getValue('name');
                                                        return !labelsToRemove.includes(labelName);
                                                    });
                                                    selectedLabelsConnection.setLinkedRecords(updatedEdges, 'edges');
                                                    selectedLabelsConnection.setValue(updatedEdges.length, 'totalCount');
                                                }
                                                break;
                                            }
                                            if (multiSelectFieldOption === 'REMOVE_ALL') {
                                                const selectedLabelsConnection = storeField.getLinkedRecord('selectedLabelsConnection', {
                                                    first: 1000
                                                });
                                                if (selectedLabelsConnection) {
                                                    selectedLabelsConnection.setLinkedRecords([], 'edges');
                                                    selectedLabelsConnection.setValue(0, 'totalCount');
                                                }
                                                break;
                                            }
                                            break;
                                        }
                                    case 0, $814y1.DATE_TIME_GQL_FIELD:
                                        if (formFieldData === null) {
                                            storeField.setValue(null, 'dateTime');
                                            break;
                                        }
                                        storeField.setValue(formFieldData, 'dateTime');
                                        break;
                                    case 0, $814y1.RICH_TEXT_GQL_FIELD:
                                        {
                                            if (formFieldData === null) {
                                                storeField.setValue(null, 'richText');
                                                return;
                                            }
                                            const richTextDataId = (0, $aXKmr.v4)();
                                            const adfDataId = `${richTextDataId}:adfValue`;
                                            const plainTextDataId = `${adfDataId}:convertedPlainText`;
                                            const plainTextRecord = store.create(plainTextDataId, 'JiraAdfToConvertedPlainText');
                                            plainTextRecord.setValue((0, $hOcoS.convertAdfToText)(formFieldData), 'plainText');
                                            const adfRecord = store.create(`${richTextDataId}:adfValue`, 'JiraADF');
                                            adfRecord.setLinkedRecord(plainTextRecord, 'convertedPlainText');
                                            const richTextRecord = store.create(richTextDataId, 'JiraRichText');
                                            richTextRecord.setLinkedRecord(adfRecord, 'adfValue');
                                            storeField.setLinkedRecord(richTextRecord, 'richText');
                                            break;
                                        }
                                    case 0, $814y1.STATUS_GQL_FIELD:
                                        {
                                            const statusCategory = store.create((0, $aXKmr.v4)(), 'JiraStatusCategory');
                                            statusCategory.setValue(formFieldData.to.statusCategory.statusCategoryId, 'statusCategoryId');
                                            const status = store.create((0, $aXKmr.v4)(), 'JiraStatus');
                                            status.setValue(formFieldData.to.statusId, 'statusId');
                                            status.setValue(formFieldData.to.name, 'name');
                                            status.setLinkedRecord(statusCategory, 'statusCategory');
                                            storeField.setLinkedRecord(status, 'status');
                                            break;
                                        }
                                    case 0, $814y1.AFFECTED_SERVICES_GQL_FIELD:
                                        {
                                            if (!(0, $epTsa.expVal)('sunsetting_bulk_edit', 'isEnabled', false)) break;
                                            const newEdges = formFieldData.map((affectedServicesData)=>{
                                                const affectedService = store.create((0, $aXKmr.v4)(), 'JiraAffectedService');
                                                affectedService.setValue(affectedServicesData.label, 'name');
                                                affectedService.setValue(affectedServicesData.value, 'serviceId');
                                                const edge = store.create((0, $aXKmr.v4)(), 'JiraAffectedServiceEdge');
                                                edge.setLinkedRecord(affectedService, 'node');
                                                return edge;
                                            });
                                            const affectedServiceConnection = storeField.getLinkedRecord('selectedAffectedServicesConnection');
                                            affectedServiceConnection?.setLinkedRecords(newEdges, 'edges');
                                            break;
                                        }
                                    default:
                                        break;
                                }
                                /*
									We explicitly check for type on certain instances due to the face that the
									main_IssueNavigator query has the __typename of JiraFallbackField even though
									this is not accurate.
								*/ const __issueAriIdFallback = (0, $3pSHx.JiraIssuefieldvalueAri).create({
                                    siteId: siteId,
                                    issueId: issueId.toString(),
                                    fieldId: `${field.fieldId}_fallback`
                                }).toString();
                                const relayDataIdFallback = (0, $kqd31.default)({
                                    id: __issueAriIdFallback
                                }, field.gqlType);
                                if (relayDataIdFallback) {
                                    const storeFieldFallback = store.get(relayDataIdFallback);
                                    if (storeFieldFallback) switch(field.type){
                                        case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
                                            {
                                                const renderedFieldId = `${field.fieldId}-field`;
                                                const renderedFieldHtml = (0, $etNo6.renderToString)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                                                    id: renderedFieldId
                                                }, formFieldData.map((labelData, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                                                        key: `${renderedFieldId}-${labelData.label}`
                                                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, labelData.label), index !== formFieldData.length - 1 && ', '))));
                                                storeFieldFallback.setValue(renderedFieldHtml, 'renderedFieldHtml');
                                                break;
                                            }
                                        case 0, $814y1.USER_CF_TYPE:
                                            {
                                                if (formFieldData === null) {
                                                    storeFieldFallback.setValue('', 'renderedFieldHtml');
                                                    return;
                                                }
                                                const renderedFieldId = `${field.fieldId}-field`;
                                                const renderedFieldHtml = (0, $etNo6.renderToString)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                                                    id: renderedFieldId
                                                }, (0, $7jTnu.fg)('replace-anchor-with-link__deliveroo') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                                    id: renderedFieldId,
                                                    href: `/secure/ViewProfile.jspa?accountId=${formFieldData.id}`
                                                }, formFieldData.name) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                                                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                                                    id: renderedFieldId,
                                                    href: `/secure/ViewProfile.jspa?accountId=${formFieldData.id}`
                                                }, formFieldData.name)));
                                                storeFieldFallback.setValue(renderedFieldHtml, 'renderedFieldHtml');
                                                break;
                                            }
                                        default:
                                            break;
                                    }
                                }
                            }
                        });
                        else if (bulkOperationType === 'BULK_WATCH' || bulkOperationType === 'BULK_UNWATCH') ariIssueIds.forEach((ariIssueId)=>{
                            const { siteId: siteId, issueId: issueId } = (0, $2ApNu.JiraIssueAri).parse(ariIssueId);
                            const ariIssueFieldId = (0, $3pSHx.JiraIssuefieldvalueAri).create({
                                siteId: siteId,
                                issueId: issueId,
                                fieldId: field.fieldId
                            }).toString();
                            const relayDataId = (0, $kqd31.default)({
                                id: ariIssueFieldId
                            }, field.gqlType);
                            if (relayDataId) {
                                const storeField = store.get(relayDataId);
                                if (storeField) switch(field.gqlType){
                                    case 0, $814y1.WATCHES_GQL_FIELD:
                                        if ((0, $7jTnu.fg)('bulk_watch_fast_follow')) {
                                            const currentWatch = storeField.getLinkedRecord('watch');
                                            const currentCount = currentWatch?.getValue('count');
                                            const currentIsWatching = currentWatch?.getValue('isWatching');
                                            if (currentCount != null && currentIsWatching != null) {
                                                const watch = store.create((0, $aXKmr.v4)(), 'JiraWatch');
                                                let count = Number(currentCount);
                                                if (bulkOperationType === 'BULK_WATCH' && !currentIsWatching) {
                                                    count++;
                                                    watch.setValue(count, 'count');
                                                    watch.setValue(true, 'isWatching');
                                                    storeField.setLinkedRecord(watch, 'watch');
                                                    break;
                                                } else if (bulkOperationType === 'BULK_UNWATCH' && currentIsWatching && count > 0) {
                                                    count--;
                                                    watch.setValue(count, 'count');
                                                    watch.setValue(false, 'isWatching');
                                                    storeField.setLinkedRecord(watch, 'watch');
                                                    break;
                                                }
                                            }
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        });
                    });
                });
            } catch (e) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('bulk-operations.async.full-core.onUpdate', e instanceof Error ? e.toString() : 'unknown error');
            }
        }, [
        issueFields
    ]);
    return onUpdate;
};

});
parcelRegister("etNo6", function(module, exports) {

$parcel$export(module.exports, "version", () => $a8aa1580d62bc9be$export$83d89fbfd8236492, (v) => $a8aa1580d62bc9be$export$83d89fbfd8236492 = v);
$parcel$export(module.exports, "renderToString", () => $a8aa1580d62bc9be$export$80e7718417253a51, (v) => $a8aa1580d62bc9be$export$80e7718417253a51 = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $a8aa1580d62bc9be$export$eb3a06aef9e6ee51, (v) => $a8aa1580d62bc9be$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToNodeStream", () => $a8aa1580d62bc9be$export$307591e98609eddd, (v) => $a8aa1580d62bc9be$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $a8aa1580d62bc9be$export$b23711c915539651, (v) => $a8aa1580d62bc9be$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToReadableStream", () => $a8aa1580d62bc9be$export$7020a3240b287705, (v) => $a8aa1580d62bc9be$export$7020a3240b287705 = v);
var $a8aa1580d62bc9be$export$83d89fbfd8236492;
var $a8aa1580d62bc9be$export$80e7718417253a51;
var $a8aa1580d62bc9be$export$eb3a06aef9e6ee51;
var $a8aa1580d62bc9be$export$307591e98609eddd;
var $a8aa1580d62bc9be$export$b23711c915539651;
var $a8aa1580d62bc9be$export$7020a3240b287705;
'use strict';
var $a8aa1580d62bc9be$var$l, $a8aa1580d62bc9be$var$s;

$a8aa1580d62bc9be$var$l = (parcelRequire("dqBRj"));

$a8aa1580d62bc9be$var$s = (parcelRequire("tjq0h"));
$a8aa1580d62bc9be$export$83d89fbfd8236492 = $a8aa1580d62bc9be$var$l.version;
$a8aa1580d62bc9be$export$80e7718417253a51 = $a8aa1580d62bc9be$var$l.renderToString;
$a8aa1580d62bc9be$export$eb3a06aef9e6ee51 = $a8aa1580d62bc9be$var$l.renderToStaticMarkup;
$a8aa1580d62bc9be$export$307591e98609eddd = $a8aa1580d62bc9be$var$l.renderToNodeStream;
$a8aa1580d62bc9be$export$b23711c915539651 = $a8aa1580d62bc9be$var$l.renderToStaticNodeStream;
$a8aa1580d62bc9be$export$7020a3240b287705 = $a8aa1580d62bc9be$var$s.renderToReadableStream;

});
parcelRegister("dqBRj", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $9c6b1212f20a86b6$export$307591e98609eddd, (v) => $9c6b1212f20a86b6$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $9c6b1212f20a86b6$export$eb3a06aef9e6ee51, (v) => $9c6b1212f20a86b6$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $9c6b1212f20a86b6$export$b23711c915539651, (v) => $9c6b1212f20a86b6$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $9c6b1212f20a86b6$export$80e7718417253a51, (v) => $9c6b1212f20a86b6$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $9c6b1212f20a86b6$export$83d89fbfd8236492, (v) => $9c6b1212f20a86b6$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c6b1212f20a86b6$export$307591e98609eddd;
var $9c6b1212f20a86b6$export$eb3a06aef9e6ee51;
var $9c6b1212f20a86b6$export$b23711c915539651;
var $9c6b1212f20a86b6$export$80e7718417253a51;
var $9c6b1212f20a86b6$export$83d89fbfd8236492;
'use strict';

var $eJOHy = parcelRequire("eJOHy");
function $9c6b1212f20a86b6$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9c6b1212f20a86b6$var$p = Object.prototype.hasOwnProperty, $9c6b1212f20a86b6$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9c6b1212f20a86b6$var$ha = {}, $9c6b1212f20a86b6$var$ia = {};
function $9c6b1212f20a86b6$var$ja(a) {
    if ($9c6b1212f20a86b6$var$p.call($9c6b1212f20a86b6$var$ia, a)) return !0;
    if ($9c6b1212f20a86b6$var$p.call($9c6b1212f20a86b6$var$ha, a)) return !1;
    if ($9c6b1212f20a86b6$var$fa.test(a)) return $9c6b1212f20a86b6$var$ia[a] = !0;
    $9c6b1212f20a86b6$var$ha[a] = !0;
    return !1;
}
function $9c6b1212f20a86b6$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $9c6b1212f20a86b6$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9c6b1212f20a86b6$var$ka = /[\-:]([a-z])/g;
function $9c6b1212f20a86b6$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9c6b1212f20a86b6$var$ka, $9c6b1212f20a86b6$var$la);
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9c6b1212f20a86b6$var$ka, $9c6b1212f20a86b6$var$la);
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9c6b1212f20a86b6$var$ka, $9c6b1212f20a86b6$var$la);
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9c6b1212f20a86b6$var$t.xlinkHref = new $9c6b1212f20a86b6$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $9c6b1212f20a86b6$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9c6b1212f20a86b6$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9c6b1212f20a86b6$var$u).forEach(function(a) {
    $9c6b1212f20a86b6$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9c6b1212f20a86b6$var$u[b] = $9c6b1212f20a86b6$var$u[a];
    });
});
var $9c6b1212f20a86b6$var$na = /["'&<>]/;
function $9c6b1212f20a86b6$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $9c6b1212f20a86b6$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $9c6b1212f20a86b6$var$oa = /([A-Z])/g, $9c6b1212f20a86b6$var$pa = /^ms-/, $9c6b1212f20a86b6$var$qa = Array.isArray;
function $9c6b1212f20a86b6$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $9c6b1212f20a86b6$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $9c6b1212f20a86b6$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $9c6b1212f20a86b6$var$w(2, null);
        case "math":
            return $9c6b1212f20a86b6$var$w(3, null);
        case "foreignObject":
            return $9c6b1212f20a86b6$var$w(1, null);
        case "table":
            return $9c6b1212f20a86b6$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $9c6b1212f20a86b6$var$w(5, null);
        case "colgroup":
            return $9c6b1212f20a86b6$var$w(7, null);
        case "tr":
            return $9c6b1212f20a86b6$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $9c6b1212f20a86b6$var$w(1, null) : a;
}
var $9c6b1212f20a86b6$var$sa = new Map;
function $9c6b1212f20a86b6$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($9c6b1212f20a86b6$var$l(62));
    b = !0;
    for(var d in c)if ($9c6b1212f20a86b6$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $9c6b1212f20a86b6$var$v(d);
                f = $9c6b1212f20a86b6$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $9c6b1212f20a86b6$var$sa.get(e);
                void 0 !== g ? e = g : (g = $9c6b1212f20a86b6$var$v(e.replace($9c6b1212f20a86b6$var$oa, "-$1").toLowerCase().replace($9c6b1212f20a86b6$var$pa, "-ms-")), $9c6b1212f20a86b6$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $9c6b1212f20a86b6$var$p.call($9c6b1212f20a86b6$var$u, d) ? "" + f : f + "px" : $9c6b1212f20a86b6$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $9c6b1212f20a86b6$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $9c6b1212f20a86b6$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $9c6b1212f20a86b6$var$t.hasOwnProperty(c) ? $9c6b1212f20a86b6$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
            }
        } else if ($9c6b1212f20a86b6$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
        }
    }
}
function $9c6b1212f20a86b6$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($9c6b1212f20a86b6$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($9c6b1212f20a86b6$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $9c6b1212f20a86b6$var$ua(a) {
    var b = "";
    $eJOHy.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $9c6b1212f20a86b6$var$va(a, b, c, d) {
    a.push($9c6b1212f20a86b6$var$A(c));
    var f = c = null, e;
    for(e in b)if ($9c6b1212f20a86b6$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $9c6b1212f20a86b6$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $9c6b1212f20a86b6$var$y(a, f, c);
    return "string" === typeof c ? (a.push($9c6b1212f20a86b6$var$v(c)), null) : c;
}
var $9c6b1212f20a86b6$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $9c6b1212f20a86b6$var$xa = new Map;
function $9c6b1212f20a86b6$var$A(a) {
    var b = $9c6b1212f20a86b6$var$xa.get(a);
    if (void 0 === b) {
        if (!$9c6b1212f20a86b6$var$wa.test(a)) throw Error($9c6b1212f20a86b6$var$l(65, a));
        b = "<" + a;
        $9c6b1212f20a86b6$var$xa.set(a, b);
    }
    return b;
}
function $9c6b1212f20a86b6$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($9c6b1212f20a86b6$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($9c6b1212f20a86b6$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $9c6b1212f20a86b6$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $9c6b1212f20a86b6$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($9c6b1212f20a86b6$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($9c6b1212f20a86b6$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $9c6b1212f20a86b6$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $9c6b1212f20a86b6$var$ua(h), $9c6b1212f20a86b6$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $9c6b1212f20a86b6$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($9c6b1212f20a86b6$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($9c6b1212f20a86b6$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(91));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($9c6b1212f20a86b6$var$l(92));
                if ($9c6b1212f20a86b6$var$qa(n) && 1 < n.length) throw Error($9c6b1212f20a86b6$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($9c6b1212f20a86b6$var$v("" + e));
            return null;
        case "input":
            a.push($9c6b1212f20a86b6$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($9c6b1212f20a86b6$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $9c6b1212f20a86b6$var$x(a, d, g, m);
            }
            null !== n ? $9c6b1212f20a86b6$var$x(a, d, "checked", n) : null !== k && $9c6b1212f20a86b6$var$x(a, d, "checked", k);
            null !== e ? $9c6b1212f20a86b6$var$x(a, d, "value", e) : null !== h && $9c6b1212f20a86b6$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($9c6b1212f20a86b6$var$A("menuitem"));
            for(var C in c)if ($9c6b1212f20a86b6$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(400));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($9c6b1212f20a86b6$var$A("title"));
            e = null;
            for(q in c)if ($9c6b1212f20a86b6$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(434));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($9c6b1212f20a86b6$var$A(b));
            g = e = null;
            for(k in c)if ($9c6b1212f20a86b6$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $9c6b1212f20a86b6$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($9c6b1212f20a86b6$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($9c6b1212f20a86b6$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($9c6b1212f20a86b6$var$A(b));
            for(var D in c)if ($9c6b1212f20a86b6$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(399, b));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $9c6b1212f20a86b6$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $9c6b1212f20a86b6$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $9c6b1212f20a86b6$var$va(a, c, b, d);
            a.push($9c6b1212f20a86b6$var$A(b));
            g = e = null;
            for(m in c)if ($9c6b1212f20a86b6$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $9c6b1212f20a86b6$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $9c6b1212f20a86b6$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $9c6b1212f20a86b6$var$v(h), '"');
            }
            a.push(">");
            $9c6b1212f20a86b6$var$y(a, g, e);
            return e;
    }
}
function $9c6b1212f20a86b6$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($9c6b1212f20a86b6$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $9c6b1212f20a86b6$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($9c6b1212f20a86b6$var$l(397));
    }
}
function $9c6b1212f20a86b6$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($9c6b1212f20a86b6$var$l(397));
    }
}
var $9c6b1212f20a86b6$var$Ca = /[<\u2028\u2029]/g;
function $9c6b1212f20a86b6$var$Da(a) {
    return JSON.stringify(a).replace($9c6b1212f20a86b6$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $9c6b1212f20a86b6$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $9c6b1212f20a86b6$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($9c6b1212f20a86b6$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($9c6b1212f20a86b6$var$v(b)), a = !0);
    return a;
}
var $9c6b1212f20a86b6$var$B = Object.assign, $9c6b1212f20a86b6$var$Ga = Symbol.for("react.element"), $9c6b1212f20a86b6$var$Ha = Symbol.for("react.portal"), $9c6b1212f20a86b6$var$Ia = Symbol.for("react.fragment"), $9c6b1212f20a86b6$var$Ja = Symbol.for("react.strict_mode"), $9c6b1212f20a86b6$var$Ka = Symbol.for("react.profiler"), $9c6b1212f20a86b6$var$La = Symbol.for("react.provider"), $9c6b1212f20a86b6$var$Ma = Symbol.for("react.context"), $9c6b1212f20a86b6$var$Na = Symbol.for("react.forward_ref"), $9c6b1212f20a86b6$var$Oa = Symbol.for("react.suspense"), $9c6b1212f20a86b6$var$Pa = Symbol.for("react.suspense_list"), $9c6b1212f20a86b6$var$Qa = Symbol.for("react.memo"), $9c6b1212f20a86b6$var$Ra = Symbol.for("react.lazy"), $9c6b1212f20a86b6$var$Sa = Symbol.for("react.scope"), $9c6b1212f20a86b6$var$Ta = Symbol.for("react.debug_trace_mode"), $9c6b1212f20a86b6$var$Ua = Symbol.for("react.legacy_hidden"), $9c6b1212f20a86b6$var$Va = Symbol.for("react.default_value"), $9c6b1212f20a86b6$var$Wa = Symbol.iterator;
function $9c6b1212f20a86b6$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9c6b1212f20a86b6$var$Ia:
            return "Fragment";
        case $9c6b1212f20a86b6$var$Ha:
            return "Portal";
        case $9c6b1212f20a86b6$var$Ka:
            return "Profiler";
        case $9c6b1212f20a86b6$var$Ja:
            return "StrictMode";
        case $9c6b1212f20a86b6$var$Oa:
            return "Suspense";
        case $9c6b1212f20a86b6$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9c6b1212f20a86b6$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $9c6b1212f20a86b6$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $9c6b1212f20a86b6$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9c6b1212f20a86b6$var$Qa:
            return b = a.displayName || null, null !== b ? b : $9c6b1212f20a86b6$var$Xa(a.type) || "Memo";
        case $9c6b1212f20a86b6$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $9c6b1212f20a86b6$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $9c6b1212f20a86b6$var$Ya = {};
function $9c6b1212f20a86b6$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $9c6b1212f20a86b6$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $9c6b1212f20a86b6$var$E = null;
function $9c6b1212f20a86b6$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($9c6b1212f20a86b6$var$l(401));
        } else {
            if (null === c) throw Error($9c6b1212f20a86b6$var$l(401));
            $9c6b1212f20a86b6$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $9c6b1212f20a86b6$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $9c6b1212f20a86b6$var$$a(a);
}
function $9c6b1212f20a86b6$var$ab(a) {
    var b = a.parent;
    null !== b && $9c6b1212f20a86b6$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $9c6b1212f20a86b6$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($9c6b1212f20a86b6$var$l(402));
    a.depth === b.depth ? $9c6b1212f20a86b6$var$F(a, b) : $9c6b1212f20a86b6$var$bb(a, b);
}
function $9c6b1212f20a86b6$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($9c6b1212f20a86b6$var$l(402));
    a.depth === c.depth ? $9c6b1212f20a86b6$var$F(a, c) : $9c6b1212f20a86b6$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $9c6b1212f20a86b6$var$G(a) {
    var b = $9c6b1212f20a86b6$var$E;
    b !== a && (null === b ? $9c6b1212f20a86b6$var$ab(a) : null === a ? $9c6b1212f20a86b6$var$$a(b) : b.depth === a.depth ? $9c6b1212f20a86b6$var$F(b, a) : b.depth > a.depth ? $9c6b1212f20a86b6$var$bb(b, a) : $9c6b1212f20a86b6$var$cb(b, a), $9c6b1212f20a86b6$var$E = a);
}
var $9c6b1212f20a86b6$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $9c6b1212f20a86b6$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $9c6b1212f20a86b6$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $9c6b1212f20a86b6$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $9c6b1212f20a86b6$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $9c6b1212f20a86b6$var$B({}, e, h)) : $9c6b1212f20a86b6$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $9c6b1212f20a86b6$var$fb = {
    id: 1,
    overflow: ""
};
function $9c6b1212f20a86b6$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $9c6b1212f20a86b6$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $9c6b1212f20a86b6$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $9c6b1212f20a86b6$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $9c6b1212f20a86b6$var$H = Math.clz32 ? Math.clz32 : $9c6b1212f20a86b6$var$hb, $9c6b1212f20a86b6$var$ib = Math.log, $9c6b1212f20a86b6$var$jb = Math.LN2;
function $9c6b1212f20a86b6$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9c6b1212f20a86b6$var$ib(a) / $9c6b1212f20a86b6$var$jb | 0) | 0;
}
function $9c6b1212f20a86b6$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9c6b1212f20a86b6$var$lb = "function" === typeof Object.is ? Object.is : $9c6b1212f20a86b6$var$kb, $9c6b1212f20a86b6$var$I = null, $9c6b1212f20a86b6$var$ob = null, $9c6b1212f20a86b6$var$J = null, $9c6b1212f20a86b6$var$K = null, $9c6b1212f20a86b6$var$L = !1, $9c6b1212f20a86b6$var$M = !1, $9c6b1212f20a86b6$var$N = 0, $9c6b1212f20a86b6$var$O = null, $9c6b1212f20a86b6$var$P = 0;
function $9c6b1212f20a86b6$var$Q() {
    if (null === $9c6b1212f20a86b6$var$I) throw Error($9c6b1212f20a86b6$var$l(321));
    return $9c6b1212f20a86b6$var$I;
}
function $9c6b1212f20a86b6$var$pb() {
    if (0 < $9c6b1212f20a86b6$var$P) throw Error($9c6b1212f20a86b6$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $9c6b1212f20a86b6$var$qb() {
    null === $9c6b1212f20a86b6$var$K ? null === $9c6b1212f20a86b6$var$J ? ($9c6b1212f20a86b6$var$L = !1, $9c6b1212f20a86b6$var$J = $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$pb()) : ($9c6b1212f20a86b6$var$L = !0, $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$J) : null === $9c6b1212f20a86b6$var$K.next ? ($9c6b1212f20a86b6$var$L = !1, $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$K.next = $9c6b1212f20a86b6$var$pb()) : ($9c6b1212f20a86b6$var$L = !0, $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$K.next);
    return $9c6b1212f20a86b6$var$K;
}
function $9c6b1212f20a86b6$var$rb() {
    $9c6b1212f20a86b6$var$ob = $9c6b1212f20a86b6$var$I = null;
    $9c6b1212f20a86b6$var$M = !1;
    $9c6b1212f20a86b6$var$J = null;
    $9c6b1212f20a86b6$var$P = 0;
    $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$O = null;
}
function $9c6b1212f20a86b6$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9c6b1212f20a86b6$var$tb(a, b, c) {
    $9c6b1212f20a86b6$var$I = $9c6b1212f20a86b6$var$Q();
    $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$qb();
    if ($9c6b1212f20a86b6$var$L) {
        var d = $9c6b1212f20a86b6$var$K.queue;
        b = d.dispatch;
        if (null !== $9c6b1212f20a86b6$var$O && (c = $9c6b1212f20a86b6$var$O.get(d), void 0 !== c)) {
            $9c6b1212f20a86b6$var$O.delete(d);
            d = $9c6b1212f20a86b6$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $9c6b1212f20a86b6$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $9c6b1212f20a86b6$var$K.memoizedState,
            b
        ];
    }
    a = a === $9c6b1212f20a86b6$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $9c6b1212f20a86b6$var$K.memoizedState = a;
    a = $9c6b1212f20a86b6$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $9c6b1212f20a86b6$var$ub.bind(null, $9c6b1212f20a86b6$var$I, a);
    return [
        $9c6b1212f20a86b6$var$K.memoizedState,
        a
    ];
}
function $9c6b1212f20a86b6$var$vb(a, b) {
    $9c6b1212f20a86b6$var$I = $9c6b1212f20a86b6$var$Q();
    $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $9c6b1212f20a86b6$var$K) {
        var c = $9c6b1212f20a86b6$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$9c6b1212f20a86b6$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $9c6b1212f20a86b6$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9c6b1212f20a86b6$var$ub(a, b, c) {
    if (25 <= $9c6b1212f20a86b6$var$P) throw Error($9c6b1212f20a86b6$var$l(301));
    if (a === $9c6b1212f20a86b6$var$I) {
        if ($9c6b1212f20a86b6$var$M = !0, a = {
            action: c,
            next: null
        }, null === $9c6b1212f20a86b6$var$O && ($9c6b1212f20a86b6$var$O = new Map), c = $9c6b1212f20a86b6$var$O.get(b), void 0 === c) $9c6b1212f20a86b6$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $9c6b1212f20a86b6$var$wb() {
    throw Error($9c6b1212f20a86b6$var$l(394));
}
function $9c6b1212f20a86b6$var$R() {}
var $9c6b1212f20a86b6$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $9c6b1212f20a86b6$var$Q();
        return a._currentValue2;
    },
    useMemo: $9c6b1212f20a86b6$var$vb,
    useReducer: $9c6b1212f20a86b6$var$tb,
    useRef: function(a) {
        $9c6b1212f20a86b6$var$I = $9c6b1212f20a86b6$var$Q();
        $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$qb();
        var b = $9c6b1212f20a86b6$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $9c6b1212f20a86b6$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $9c6b1212f20a86b6$var$tb($9c6b1212f20a86b6$var$sb, a);
    },
    useInsertionEffect: $9c6b1212f20a86b6$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $9c6b1212f20a86b6$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $9c6b1212f20a86b6$var$R,
    useEffect: $9c6b1212f20a86b6$var$R,
    useDebugValue: $9c6b1212f20a86b6$var$R,
    useDeferredValue: function(a) {
        $9c6b1212f20a86b6$var$Q();
        return a;
    },
    useTransition: function() {
        $9c6b1212f20a86b6$var$Q();
        return [
            !1,
            $9c6b1212f20a86b6$var$wb
        ];
    },
    useId: function() {
        var a = $9c6b1212f20a86b6$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $9c6b1212f20a86b6$var$H(a) - 1)).toString(32) + b;
        var c = $9c6b1212f20a86b6$var$S;
        if (null === c) throw Error($9c6b1212f20a86b6$var$l(404));
        b = $9c6b1212f20a86b6$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $9c6b1212f20a86b6$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($9c6b1212f20a86b6$var$l(407));
        return c();
    }
}, $9c6b1212f20a86b6$var$S = null, $9c6b1212f20a86b6$var$yb = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $9c6b1212f20a86b6$var$zb(a) {
    console.error(a);
    return null;
}
function $9c6b1212f20a86b6$var$T() {}
function $9c6b1212f20a86b6$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $9c6b1212f20a86b6$var$zb : f,
        onAllReady: void 0 === e ? $9c6b1212f20a86b6$var$T : e,
        onShellReady: void 0 === g ? $9c6b1212f20a86b6$var$T : g,
        onShellError: void 0 === h ? $9c6b1212f20a86b6$var$T : h,
        onFatalError: void 0 === k ? $9c6b1212f20a86b6$var$T : k
    };
    c = $9c6b1212f20a86b6$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $9c6b1212f20a86b6$var$Bb(b, a, null, c, n, $9c6b1212f20a86b6$var$Ya, null, $9c6b1212f20a86b6$var$fb);
    m.push(a);
    return b;
}
function $9c6b1212f20a86b6$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $9c6b1212f20a86b6$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $9c6b1212f20a86b6$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $9c6b1212f20a86b6$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $9c6b1212f20a86b6$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $9c6b1212f20a86b6$var$Db(a, b, c, d, f) {
    $9c6b1212f20a86b6$var$I = {};
    $9c6b1212f20a86b6$var$ob = b;
    $9c6b1212f20a86b6$var$N = 0;
    for(a = c(d, f); $9c6b1212f20a86b6$var$M;)$9c6b1212f20a86b6$var$M = !1, $9c6b1212f20a86b6$var$N = 0, $9c6b1212f20a86b6$var$P += 1, $9c6b1212f20a86b6$var$K = null, a = c(d, f);
    $9c6b1212f20a86b6$var$rb();
    return a;
}
function $9c6b1212f20a86b6$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($9c6b1212f20a86b6$var$l(108, $9c6b1212f20a86b6$var$Xa(d) || "Unknown", h));
            d = $9c6b1212f20a86b6$var$B({}, g, c);
        }
        b.legacyContext = d;
        $9c6b1212f20a86b6$var$X(a, b, f);
        b.legacyContext = g;
    } else $9c6b1212f20a86b6$var$X(a, b, f);
}
function $9c6b1212f20a86b6$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $9c6b1212f20a86b6$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9c6b1212f20a86b6$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $9c6b1212f20a86b6$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $9c6b1212f20a86b6$var$eb(e, c, d, f);
            $9c6b1212f20a86b6$var$Eb(a, b, e, c);
        } else {
            e = $9c6b1212f20a86b6$var$Za(c, b.legacyContext);
            f = $9c6b1212f20a86b6$var$Db(a, b, c, d, e);
            var g = 0 !== $9c6b1212f20a86b6$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $9c6b1212f20a86b6$var$eb(f, c, d, e), $9c6b1212f20a86b6$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $9c6b1212f20a86b6$var$gb(d, 1, 0);
                try {
                    $9c6b1212f20a86b6$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $9c6b1212f20a86b6$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $9c6b1212f20a86b6$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $9c6b1212f20a86b6$var$ra(g, c, d);
        $9c6b1212f20a86b6$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $9c6b1212f20a86b6$var$Ua:
            case $9c6b1212f20a86b6$var$Ta:
            case $9c6b1212f20a86b6$var$Ja:
            case $9c6b1212f20a86b6$var$Ka:
            case $9c6b1212f20a86b6$var$Ia:
                $9c6b1212f20a86b6$var$X(a, b, d.children);
                return;
            case $9c6b1212f20a86b6$var$Pa:
                $9c6b1212f20a86b6$var$X(a, b, d.children);
                return;
            case $9c6b1212f20a86b6$var$Sa:
                throw Error($9c6b1212f20a86b6$var$l(343));
            case $9c6b1212f20a86b6$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $9c6b1212f20a86b6$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $9c6b1212f20a86b6$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($9c6b1212f20a86b6$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $9c6b1212f20a86b6$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $9c6b1212f20a86b6$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $9c6b1212f20a86b6$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $9c6b1212f20a86b6$var$Na:
                d = $9c6b1212f20a86b6$var$Db(a, b, c.render, d, f);
                if (0 !== $9c6b1212f20a86b6$var$N) {
                    c = b.treeContext;
                    b.treeContext = $9c6b1212f20a86b6$var$gb(c, 1, 0);
                    try {
                        $9c6b1212f20a86b6$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $9c6b1212f20a86b6$var$X(a, b, d);
                return;
            case $9c6b1212f20a86b6$var$Qa:
                c = c.type;
                d = $9c6b1212f20a86b6$var$Fb(c, d);
                $9c6b1212f20a86b6$var$Gb(a, b, c, d, f);
                return;
            case $9c6b1212f20a86b6$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $9c6b1212f20a86b6$var$E;
                $9c6b1212f20a86b6$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $9c6b1212f20a86b6$var$X(a, b, f);
                a = $9c6b1212f20a86b6$var$E;
                if (null === a) throw Error($9c6b1212f20a86b6$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $9c6b1212f20a86b6$var$Va ? a.context._defaultValue : d;
                a = $9c6b1212f20a86b6$var$E = a.parent;
                b.context = a;
                return;
            case $9c6b1212f20a86b6$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $9c6b1212f20a86b6$var$X(a, b, d);
                return;
            case $9c6b1212f20a86b6$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $9c6b1212f20a86b6$var$Fb(c, d);
                $9c6b1212f20a86b6$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($9c6b1212f20a86b6$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $9c6b1212f20a86b6$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $9c6b1212f20a86b6$var$Ga:
                $9c6b1212f20a86b6$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $9c6b1212f20a86b6$var$Ha:
                throw Error($9c6b1212f20a86b6$var$l(257));
            case $9c6b1212f20a86b6$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $9c6b1212f20a86b6$var$X(a, b, c);
                return;
        }
        if ($9c6b1212f20a86b6$var$qa(c)) {
            $9c6b1212f20a86b6$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $9c6b1212f20a86b6$var$Wa && c[$9c6b1212f20a86b6$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $9c6b1212f20a86b6$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($9c6b1212f20a86b6$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $9c6b1212f20a86b6$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $9c6b1212f20a86b6$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $9c6b1212f20a86b6$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $9c6b1212f20a86b6$var$gb(e, d, f);
        try {
            $9c6b1212f20a86b6$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $9c6b1212f20a86b6$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $9c6b1212f20a86b6$var$X(a, b, c);
    } catch (k) {
        if ($9c6b1212f20a86b6$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $9c6b1212f20a86b6$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $9c6b1212f20a86b6$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $9c6b1212f20a86b6$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $9c6b1212f20a86b6$var$G(e), k;
    }
}
function $9c6b1212f20a86b6$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $9c6b1212f20a86b6$var$Kb(this, b, a);
}
function $9c6b1212f20a86b6$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($9c6b1212f20a86b6$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $9c6b1212f20a86b6$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $9c6b1212f20a86b6$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $9c6b1212f20a86b6$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $9c6b1212f20a86b6$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($9c6b1212f20a86b6$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $9c6b1212f20a86b6$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $9c6b1212f20a86b6$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($9c6b1212f20a86b6$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($9c6b1212f20a86b6$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $9c6b1212f20a86b6$var$Cb(a) {
    if (2 !== a.status) {
        var b = $9c6b1212f20a86b6$var$E, c = $9c6b1212f20a86b6$var$yb.current;
        $9c6b1212f20a86b6$var$yb.current = $9c6b1212f20a86b6$var$xb;
        var d = $9c6b1212f20a86b6$var$S;
        $9c6b1212f20a86b6$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $9c6b1212f20a86b6$var$G(g.context);
                    try {
                        $9c6b1212f20a86b6$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $9c6b1212f20a86b6$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($9c6b1212f20a86b6$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $9c6b1212f20a86b6$var$V(h, q);
                            null === n ? $9c6b1212f20a86b6$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $9c6b1212f20a86b6$var$Mb(a, a.destination);
        } catch (z) {
            $9c6b1212f20a86b6$var$V(a, z), $9c6b1212f20a86b6$var$W(a, z);
        } finally{
            $9c6b1212f20a86b6$var$S = d, $9c6b1212f20a86b6$var$yb.current = c, c === $9c6b1212f20a86b6$var$xb && $9c6b1212f20a86b6$var$G(b);
        }
    }
}
function $9c6b1212f20a86b6$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $9c6b1212f20a86b6$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($9c6b1212f20a86b6$var$l(390));
    }
}
function $9c6b1212f20a86b6$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $9c6b1212f20a86b6$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $9c6b1212f20a86b6$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $9c6b1212f20a86b6$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $9c6b1212f20a86b6$var$za(b, a.responseState, d);
        $9c6b1212f20a86b6$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $9c6b1212f20a86b6$var$za(b, a.responseState, d.id), $9c6b1212f20a86b6$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($9c6b1212f20a86b6$var$l(391));
    $9c6b1212f20a86b6$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $9c6b1212f20a86b6$var$Ob(a, b, c) {
    $9c6b1212f20a86b6$var$Aa(b, a.responseState, c.formatContext, c.id);
    $9c6b1212f20a86b6$var$Nb(a, b, c);
    return $9c6b1212f20a86b6$var$Ba(b, c.formatContext);
}
function $9c6b1212f20a86b6$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$9c6b1212f20a86b6$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($9c6b1212f20a86b6$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $9c6b1212f20a86b6$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($9c6b1212f20a86b6$var$l(392));
        return $9c6b1212f20a86b6$var$Ob(a, b, d);
    }
    $9c6b1212f20a86b6$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $9c6b1212f20a86b6$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $9c6b1212f20a86b6$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($9c6b1212f20a86b6$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $9c6b1212f20a86b6$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $9c6b1212f20a86b6$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $9c6b1212f20a86b6$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$9c6b1212f20a86b6$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$9c6b1212f20a86b6$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$9c6b1212f20a86b6$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $9c6b1212f20a86b6$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $9c6b1212f20a86b6$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $9c6b1212f20a86b6$var$Mb(a, a.destination);
    } catch (d) {
        $9c6b1212f20a86b6$var$V(a, d), $9c6b1212f20a86b6$var$W(a, d);
    }
}
function $9c6b1212f20a86b6$var$Sb() {}
function $9c6b1212f20a86b6$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $9c6b1212f20a86b6$var$Ab(a, $9c6b1212f20a86b6$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, b && b.onError ? b.onError : $9c6b1212f20a86b6$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $9c6b1212f20a86b6$var$Cb(a);
    $9c6b1212f20a86b6$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $9c6b1212f20a86b6$var$Mb(a, h);
        } catch (m) {
            $9c6b1212f20a86b6$var$V(a, m), $9c6b1212f20a86b6$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($9c6b1212f20a86b6$var$l(426));
    return g;
}
$9c6b1212f20a86b6$export$307591e98609eddd = function() {
    throw Error($9c6b1212f20a86b6$var$l(207));
};
$9c6b1212f20a86b6$export$eb3a06aef9e6ee51 = function(a, b) {
    return $9c6b1212f20a86b6$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$9c6b1212f20a86b6$export$b23711c915539651 = function() {
    throw Error($9c6b1212f20a86b6$var$l(208));
};
$9c6b1212f20a86b6$export$80e7718417253a51 = function(a, b) {
    return $9c6b1212f20a86b6$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$9c6b1212f20a86b6$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("tjq0h", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $0581c5a3dec30813$export$7020a3240b287705, (v) => $0581c5a3dec30813$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $0581c5a3dec30813$export$83d89fbfd8236492, (v) => $0581c5a3dec30813$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0581c5a3dec30813$export$7020a3240b287705;
var $0581c5a3dec30813$export$83d89fbfd8236492;
'use strict';

var $eJOHy = parcelRequire("eJOHy");
function $0581c5a3dec30813$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0581c5a3dec30813$var$l = null, $0581c5a3dec30813$var$n = 0;
function $0581c5a3dec30813$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $0581c5a3dec30813$var$n && (a.enqueue(new Uint8Array($0581c5a3dec30813$var$l.buffer, 0, $0581c5a3dec30813$var$n)), $0581c5a3dec30813$var$l = new Uint8Array(512), $0581c5a3dec30813$var$n = 0), a.enqueue(b);
        else {
            var c = $0581c5a3dec30813$var$l.length - $0581c5a3dec30813$var$n;
            c < b.length && (0 === c ? a.enqueue($0581c5a3dec30813$var$l) : ($0581c5a3dec30813$var$l.set(b.subarray(0, c), $0581c5a3dec30813$var$n), a.enqueue($0581c5a3dec30813$var$l), b = b.subarray(c)), $0581c5a3dec30813$var$l = new Uint8Array(512), $0581c5a3dec30813$var$n = 0);
            $0581c5a3dec30813$var$l.set(b, $0581c5a3dec30813$var$n);
            $0581c5a3dec30813$var$n += b.length;
        }
    }
}
function $0581c5a3dec30813$var$t(a, b) {
    $0581c5a3dec30813$var$p(a, b);
    return !0;
}
function $0581c5a3dec30813$var$ba(a) {
    $0581c5a3dec30813$var$l && 0 < $0581c5a3dec30813$var$n && (a.enqueue(new Uint8Array($0581c5a3dec30813$var$l.buffer, 0, $0581c5a3dec30813$var$n)), $0581c5a3dec30813$var$l = null, $0581c5a3dec30813$var$n = 0);
}
var $0581c5a3dec30813$var$ca = new TextEncoder;
function $0581c5a3dec30813$var$u(a) {
    return $0581c5a3dec30813$var$ca.encode(a);
}
function $0581c5a3dec30813$var$w(a) {
    return $0581c5a3dec30813$var$ca.encode(a);
}
function $0581c5a3dec30813$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $0581c5a3dec30813$var$x = Object.prototype.hasOwnProperty, $0581c5a3dec30813$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0581c5a3dec30813$var$fa = {}, $0581c5a3dec30813$var$ha = {};
function $0581c5a3dec30813$var$ia(a) {
    if ($0581c5a3dec30813$var$x.call($0581c5a3dec30813$var$ha, a)) return !0;
    if ($0581c5a3dec30813$var$x.call($0581c5a3dec30813$var$fa, a)) return !1;
    if ($0581c5a3dec30813$var$ea.test(a)) return $0581c5a3dec30813$var$ha[a] = !0;
    $0581c5a3dec30813$var$fa[a] = !0;
    return !1;
}
function $0581c5a3dec30813$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $0581c5a3dec30813$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0581c5a3dec30813$var$ja = /[\-:]([a-z])/g;
function $0581c5a3dec30813$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0581c5a3dec30813$var$ja, $0581c5a3dec30813$var$ka);
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0581c5a3dec30813$var$ja, $0581c5a3dec30813$var$ka);
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0581c5a3dec30813$var$ja, $0581c5a3dec30813$var$ka);
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0581c5a3dec30813$var$z.xlinkHref = new $0581c5a3dec30813$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $0581c5a3dec30813$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0581c5a3dec30813$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0581c5a3dec30813$var$B).forEach(function(a) {
    $0581c5a3dec30813$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0581c5a3dec30813$var$B[b] = $0581c5a3dec30813$var$B[a];
    });
});
var $0581c5a3dec30813$var$oa = /["'&<>]/;
function $0581c5a3dec30813$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $0581c5a3dec30813$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $0581c5a3dec30813$var$pa = /([A-Z])/g, $0581c5a3dec30813$var$qa = /^ms-/, $0581c5a3dec30813$var$ra = Array.isArray, $0581c5a3dec30813$var$sa = $0581c5a3dec30813$var$w("<script>"), $0581c5a3dec30813$var$ta = $0581c5a3dec30813$var$w("\x3c/script>"), $0581c5a3dec30813$var$ua = $0581c5a3dec30813$var$w('<script src="'), $0581c5a3dec30813$var$va = $0581c5a3dec30813$var$w('<script type="module" src="'), $0581c5a3dec30813$var$wa = $0581c5a3dec30813$var$w('" async="">\x3c/script>'), $0581c5a3dec30813$var$xa = /(<\/|<)(s)(cript)/gi;
function $0581c5a3dec30813$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $0581c5a3dec30813$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $0581c5a3dec30813$var$sa : $0581c5a3dec30813$var$w('<script nonce="' + $0581c5a3dec30813$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $0581c5a3dec30813$var$u(("" + c).replace($0581c5a3dec30813$var$xa, $0581c5a3dec30813$var$ya)), $0581c5a3dec30813$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($0581c5a3dec30813$var$ua, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d[c])), $0581c5a3dec30813$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($0581c5a3dec30813$var$va, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(f[d])), $0581c5a3dec30813$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $0581c5a3dec30813$var$w(a + "P:"),
        segmentPrefix: $0581c5a3dec30813$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $0581c5a3dec30813$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $0581c5a3dec30813$var$Aa(a) {
    return $0581c5a3dec30813$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $0581c5a3dec30813$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $0581c5a3dec30813$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $0581c5a3dec30813$var$D(2, null);
        case "math":
            return $0581c5a3dec30813$var$D(3, null);
        case "foreignObject":
            return $0581c5a3dec30813$var$D(1, null);
        case "table":
            return $0581c5a3dec30813$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $0581c5a3dec30813$var$D(5, null);
        case "colgroup":
            return $0581c5a3dec30813$var$D(7, null);
        case "tr":
            return $0581c5a3dec30813$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $0581c5a3dec30813$var$D(1, null) : a;
}
var $0581c5a3dec30813$var$Ca = $0581c5a3dec30813$var$w("\x3c!-- --\x3e");
function $0581c5a3dec30813$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($0581c5a3dec30813$var$Ca);
    a.push($0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(b)));
    return !0;
}
var $0581c5a3dec30813$var$Ea = new Map, $0581c5a3dec30813$var$Fa = $0581c5a3dec30813$var$w(' style="'), $0581c5a3dec30813$var$Ga = $0581c5a3dec30813$var$w(":"), $0581c5a3dec30813$var$Ha = $0581c5a3dec30813$var$w(";");
function $0581c5a3dec30813$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($0581c5a3dec30813$var$k(62));
    b = !0;
    for(var d in c)if ($0581c5a3dec30813$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d));
                f = $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $0581c5a3dec30813$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $0581c5a3dec30813$var$w($0581c5a3dec30813$var$C(e.replace($0581c5a3dec30813$var$pa, "-$1").toLowerCase().replace($0581c5a3dec30813$var$qa, "-ms-"))), $0581c5a3dec30813$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $0581c5a3dec30813$var$x.call($0581c5a3dec30813$var$B, d) ? $0581c5a3dec30813$var$u("" + f) : $0581c5a3dec30813$var$u(f + "px") : $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($0581c5a3dec30813$var$Fa, e, $0581c5a3dec30813$var$Ga, f)) : a.push($0581c5a3dec30813$var$Ha, e, $0581c5a3dec30813$var$Ga, f);
        }
    }
    b || a.push($0581c5a3dec30813$var$E);
}
var $0581c5a3dec30813$var$H = $0581c5a3dec30813$var$w(" "), $0581c5a3dec30813$var$I = $0581c5a3dec30813$var$w('="'), $0581c5a3dec30813$var$E = $0581c5a3dec30813$var$w('"'), $0581c5a3dec30813$var$Ja = $0581c5a3dec30813$var$w('=""');
function $0581c5a3dec30813$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $0581c5a3dec30813$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $0581c5a3dec30813$var$z.hasOwnProperty(c) ? $0581c5a3dec30813$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $0581c5a3dec30813$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$Ja) : !1 !== d && a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
            }
        } else if ($0581c5a3dec30813$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($0581c5a3dec30813$var$H, $0581c5a3dec30813$var$u(c), $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
        }
    }
}
var $0581c5a3dec30813$var$K = $0581c5a3dec30813$var$w(">"), $0581c5a3dec30813$var$Ka = $0581c5a3dec30813$var$w("/>");
function $0581c5a3dec30813$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($0581c5a3dec30813$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($0581c5a3dec30813$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($0581c5a3dec30813$var$u("" + b));
    }
}
function $0581c5a3dec30813$var$La(a) {
    var b = "";
    $eJOHy.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $0581c5a3dec30813$var$Ma = $0581c5a3dec30813$var$w(' selected=""');
function $0581c5a3dec30813$var$Na(a, b, c, d) {
    a.push($0581c5a3dec30813$var$M(c));
    var f = c = null, e;
    for(e in b)if ($0581c5a3dec30813$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $0581c5a3dec30813$var$J(a, d, e, g);
        }
    }
    a.push($0581c5a3dec30813$var$K);
    $0581c5a3dec30813$var$L(a, f, c);
    return "string" === typeof c ? (a.push($0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(c))), null) : c;
}
var $0581c5a3dec30813$var$Oa = $0581c5a3dec30813$var$w("\n"), $0581c5a3dec30813$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $0581c5a3dec30813$var$Qa = new Map;
function $0581c5a3dec30813$var$M(a) {
    var b = $0581c5a3dec30813$var$Qa.get(a);
    if (void 0 === b) {
        if (!$0581c5a3dec30813$var$Pa.test(a)) throw Error($0581c5a3dec30813$var$k(65, a));
        b = $0581c5a3dec30813$var$w("<" + a);
        $0581c5a3dec30813$var$Qa.set(a, b);
    }
    return b;
}
var $0581c5a3dec30813$var$Ra = $0581c5a3dec30813$var$w("<!DOCTYPE html>");
function $0581c5a3dec30813$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($0581c5a3dec30813$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($0581c5a3dec30813$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $0581c5a3dec30813$var$J(a, d, r, h);
                }
            }
            a.push($0581c5a3dec30813$var$K);
            $0581c5a3dec30813$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($0581c5a3dec30813$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($0581c5a3dec30813$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $0581c5a3dec30813$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $0581c5a3dec30813$var$La(h), $0581c5a3dec30813$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($0581c5a3dec30813$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($0581c5a3dec30813$var$Ma);
            } else q && a.push($0581c5a3dec30813$var$Ma);
            a.push($0581c5a3dec30813$var$K);
            $0581c5a3dec30813$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($0581c5a3dec30813$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($0581c5a3dec30813$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(91));
                default:
                    $0581c5a3dec30813$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($0581c5a3dec30813$var$K);
            if (null != r) {
                if (null != e) throw Error($0581c5a3dec30813$var$k(92));
                if ($0581c5a3dec30813$var$ra(r) && 1 < r.length) throw Error($0581c5a3dec30813$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($0581c5a3dec30813$var$Oa);
            null !== e && a.push($0581c5a3dec30813$var$u($0581c5a3dec30813$var$C("" + e)));
            return null;
        case "input":
            a.push($0581c5a3dec30813$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($0581c5a3dec30813$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $0581c5a3dec30813$var$J(a, d, g, q);
            }
            null !== r ? $0581c5a3dec30813$var$J(a, d, "checked", r) : null !== m && $0581c5a3dec30813$var$J(a, d, "checked", m);
            null !== e ? $0581c5a3dec30813$var$J(a, d, "value", e) : null !== h && $0581c5a3dec30813$var$J(a, d, "value", h);
            a.push($0581c5a3dec30813$var$Ka);
            return null;
        case "menuitem":
            a.push($0581c5a3dec30813$var$M("menuitem"));
            for(var A in c)if ($0581c5a3dec30813$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(400));
                default:
                    $0581c5a3dec30813$var$J(a, d, A, e);
            }
            a.push($0581c5a3dec30813$var$K);
            return null;
        case "title":
            a.push($0581c5a3dec30813$var$M("title"));
            e = null;
            for(v in c)if ($0581c5a3dec30813$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(434));
                default:
                    $0581c5a3dec30813$var$J(a, d, v, g);
            }
            a.push($0581c5a3dec30813$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($0581c5a3dec30813$var$M(b));
            g = e = null;
            for(m in c)if ($0581c5a3dec30813$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $0581c5a3dec30813$var$J(a, d, m, h);
            }
            a.push($0581c5a3dec30813$var$K);
            if (null != g) {
                if (null != e) throw Error($0581c5a3dec30813$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($0581c5a3dec30813$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($0581c5a3dec30813$var$Oa, $0581c5a3dec30813$var$u(c)) : a.push($0581c5a3dec30813$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($0581c5a3dec30813$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($0581c5a3dec30813$var$M(b));
            for(var F in c)if ($0581c5a3dec30813$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(399, b));
                default:
                    $0581c5a3dec30813$var$J(a, d, F, e);
            }
            a.push($0581c5a3dec30813$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $0581c5a3dec30813$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($0581c5a3dec30813$var$Ra), $0581c5a3dec30813$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $0581c5a3dec30813$var$Na(a, c, b, d);
            a.push($0581c5a3dec30813$var$M(b));
            g = e = null;
            for(q in c)if ($0581c5a3dec30813$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $0581c5a3dec30813$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $0581c5a3dec30813$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($0581c5a3dec30813$var$H, $0581c5a3dec30813$var$u(q), $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(h)), $0581c5a3dec30813$var$E);
            }
            a.push($0581c5a3dec30813$var$K);
            $0581c5a3dec30813$var$L(a, g, e);
            return e;
    }
}
var $0581c5a3dec30813$var$Ta = $0581c5a3dec30813$var$w("</"), $0581c5a3dec30813$var$Ua = $0581c5a3dec30813$var$w(">"), $0581c5a3dec30813$var$Va = $0581c5a3dec30813$var$w('<template id="'), $0581c5a3dec30813$var$Wa = $0581c5a3dec30813$var$w('"></template>'), $0581c5a3dec30813$var$Xa = $0581c5a3dec30813$var$w("\x3c!--$--\x3e"), $0581c5a3dec30813$var$Ya = $0581c5a3dec30813$var$w('\x3c!--$?--\x3e<template id="'), $0581c5a3dec30813$var$Za = $0581c5a3dec30813$var$w('"></template>'), $0581c5a3dec30813$var$$a = $0581c5a3dec30813$var$w("\x3c!--$!--\x3e"), $0581c5a3dec30813$var$ab = $0581c5a3dec30813$var$w("\x3c!--/$--\x3e"), $0581c5a3dec30813$var$bb = $0581c5a3dec30813$var$w("<template"), $0581c5a3dec30813$var$cb = $0581c5a3dec30813$var$w('"'), $0581c5a3dec30813$var$db = $0581c5a3dec30813$var$w(' data-dgst="');
$0581c5a3dec30813$var$w(' data-msg="');
$0581c5a3dec30813$var$w(' data-stck="');
var $0581c5a3dec30813$var$eb = $0581c5a3dec30813$var$w("></template>");
function $0581c5a3dec30813$var$fb(a, b, c) {
    $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$Ya);
    if (null === c) throw Error($0581c5a3dec30813$var$k(395));
    $0581c5a3dec30813$var$p(a, c);
    return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$Za);
}
var $0581c5a3dec30813$var$gb = $0581c5a3dec30813$var$w('<div hidden id="'), $0581c5a3dec30813$var$hb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$ib = $0581c5a3dec30813$var$w("</div>"), $0581c5a3dec30813$var$jb = $0581c5a3dec30813$var$w('<svg aria-hidden="true" style="display:none" id="'), $0581c5a3dec30813$var$kb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$lb = $0581c5a3dec30813$var$w("</svg>"), $0581c5a3dec30813$var$mb = $0581c5a3dec30813$var$w('<math aria-hidden="true" style="display:none" id="'), $0581c5a3dec30813$var$nb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$ob = $0581c5a3dec30813$var$w("</math>"), $0581c5a3dec30813$var$pb = $0581c5a3dec30813$var$w('<table hidden id="'), $0581c5a3dec30813$var$qb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$rb = $0581c5a3dec30813$var$w("</table>"), $0581c5a3dec30813$var$sb = $0581c5a3dec30813$var$w('<table hidden><tbody id="'), $0581c5a3dec30813$var$tb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$ub = $0581c5a3dec30813$var$w("</tbody></table>"), $0581c5a3dec30813$var$vb = $0581c5a3dec30813$var$w('<table hidden><tr id="'), $0581c5a3dec30813$var$wb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$xb = $0581c5a3dec30813$var$w("</tr></table>"), $0581c5a3dec30813$var$yb = $0581c5a3dec30813$var$w('<table hidden><colgroup id="'), $0581c5a3dec30813$var$zb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$Ab = $0581c5a3dec30813$var$w("</colgroup></table>");
function $0581c5a3dec30813$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$gb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$hb);
        case 2:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$jb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$kb);
        case 3:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$mb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$nb);
        case 4:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$pb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$qb);
        case 5:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$sb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$tb);
        case 6:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$vb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$wb);
        case 7:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$yb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$zb);
        default:
            throw Error($0581c5a3dec30813$var$k(397));
    }
}
function $0581c5a3dec30813$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$ib);
        case 2:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$lb);
        case 3:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$ob);
        case 4:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$rb);
        case 5:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$ub);
        case 6:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$xb);
        case 7:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$Ab);
        default:
            throw Error($0581c5a3dec30813$var$k(397));
    }
}
var $0581c5a3dec30813$var$Db = $0581c5a3dec30813$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $0581c5a3dec30813$var$Eb = $0581c5a3dec30813$var$w('$RS("'), $0581c5a3dec30813$var$Gb = $0581c5a3dec30813$var$w('","'), $0581c5a3dec30813$var$Hb = $0581c5a3dec30813$var$w('")\x3c/script>'), $0581c5a3dec30813$var$Ib = $0581c5a3dec30813$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $0581c5a3dec30813$var$Jb = $0581c5a3dec30813$var$w('$RC("'), $0581c5a3dec30813$var$Kb = $0581c5a3dec30813$var$w('","'), $0581c5a3dec30813$var$Lb = $0581c5a3dec30813$var$w('")\x3c/script>'), $0581c5a3dec30813$var$Mb = $0581c5a3dec30813$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $0581c5a3dec30813$var$Nb = $0581c5a3dec30813$var$w('$RX("'), $0581c5a3dec30813$var$Ob = $0581c5a3dec30813$var$w('"'), $0581c5a3dec30813$var$Pb = $0581c5a3dec30813$var$w(")\x3c/script>"), $0581c5a3dec30813$var$Qb = $0581c5a3dec30813$var$w(","), $0581c5a3dec30813$var$Rb = /[<\u2028\u2029]/g;
function $0581c5a3dec30813$var$Sb(a) {
    return JSON.stringify(a).replace($0581c5a3dec30813$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $0581c5a3dec30813$var$N = Object.assign, $0581c5a3dec30813$var$Tb = Symbol.for("react.element"), $0581c5a3dec30813$var$Ub = Symbol.for("react.portal"), $0581c5a3dec30813$var$Vb = Symbol.for("react.fragment"), $0581c5a3dec30813$var$Wb = Symbol.for("react.strict_mode"), $0581c5a3dec30813$var$Xb = Symbol.for("react.profiler"), $0581c5a3dec30813$var$Yb = Symbol.for("react.provider"), $0581c5a3dec30813$var$Zb = Symbol.for("react.context"), $0581c5a3dec30813$var$$b = Symbol.for("react.forward_ref"), $0581c5a3dec30813$var$ac = Symbol.for("react.suspense"), $0581c5a3dec30813$var$bc = Symbol.for("react.suspense_list"), $0581c5a3dec30813$var$cc = Symbol.for("react.memo"), $0581c5a3dec30813$var$dc = Symbol.for("react.lazy"), $0581c5a3dec30813$var$ec = Symbol.for("react.scope"), $0581c5a3dec30813$var$fc = Symbol.for("react.debug_trace_mode"), $0581c5a3dec30813$var$gc = Symbol.for("react.legacy_hidden"), $0581c5a3dec30813$var$hc = Symbol.for("react.default_value"), $0581c5a3dec30813$var$ic = Symbol.iterator;
function $0581c5a3dec30813$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0581c5a3dec30813$var$Vb:
            return "Fragment";
        case $0581c5a3dec30813$var$Ub:
            return "Portal";
        case $0581c5a3dec30813$var$Xb:
            return "Profiler";
        case $0581c5a3dec30813$var$Wb:
            return "StrictMode";
        case $0581c5a3dec30813$var$ac:
            return "Suspense";
        case $0581c5a3dec30813$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0581c5a3dec30813$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $0581c5a3dec30813$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $0581c5a3dec30813$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0581c5a3dec30813$var$cc:
            return b = a.displayName || null, null !== b ? b : $0581c5a3dec30813$var$jc(a.type) || "Memo";
        case $0581c5a3dec30813$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $0581c5a3dec30813$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $0581c5a3dec30813$var$kc = {};
function $0581c5a3dec30813$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $0581c5a3dec30813$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $0581c5a3dec30813$var$O = null;
function $0581c5a3dec30813$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($0581c5a3dec30813$var$k(401));
        } else {
            if (null === c) throw Error($0581c5a3dec30813$var$k(401));
            $0581c5a3dec30813$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $0581c5a3dec30813$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $0581c5a3dec30813$var$mc(a);
}
function $0581c5a3dec30813$var$nc(a) {
    var b = a.parent;
    null !== b && $0581c5a3dec30813$var$nc(b);
    a.context._currentValue = a.value;
}
function $0581c5a3dec30813$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($0581c5a3dec30813$var$k(402));
    a.depth === b.depth ? $0581c5a3dec30813$var$P(a, b) : $0581c5a3dec30813$var$oc(a, b);
}
function $0581c5a3dec30813$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($0581c5a3dec30813$var$k(402));
    a.depth === c.depth ? $0581c5a3dec30813$var$P(a, c) : $0581c5a3dec30813$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $0581c5a3dec30813$var$Q(a) {
    var b = $0581c5a3dec30813$var$O;
    b !== a && (null === b ? $0581c5a3dec30813$var$nc(a) : null === a ? $0581c5a3dec30813$var$mc(b) : b.depth === a.depth ? $0581c5a3dec30813$var$P(b, a) : b.depth > a.depth ? $0581c5a3dec30813$var$oc(b, a) : $0581c5a3dec30813$var$pc(b, a), $0581c5a3dec30813$var$O = a);
}
var $0581c5a3dec30813$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $0581c5a3dec30813$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $0581c5a3dec30813$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $0581c5a3dec30813$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $0581c5a3dec30813$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $0581c5a3dec30813$var$N({}, e, h)) : $0581c5a3dec30813$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $0581c5a3dec30813$var$sc = {
    id: 1,
    overflow: ""
};
function $0581c5a3dec30813$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $0581c5a3dec30813$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $0581c5a3dec30813$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $0581c5a3dec30813$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $0581c5a3dec30813$var$uc = Math.clz32 ? Math.clz32 : $0581c5a3dec30813$var$vc, $0581c5a3dec30813$var$wc = Math.log, $0581c5a3dec30813$var$xc = Math.LN2;
function $0581c5a3dec30813$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0581c5a3dec30813$var$wc(a) / $0581c5a3dec30813$var$xc | 0) | 0;
}
function $0581c5a3dec30813$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0581c5a3dec30813$var$zc = "function" === typeof Object.is ? Object.is : $0581c5a3dec30813$var$yc, $0581c5a3dec30813$var$R = null, $0581c5a3dec30813$var$Ac = null, $0581c5a3dec30813$var$Bc = null, $0581c5a3dec30813$var$S = null, $0581c5a3dec30813$var$T = !1, $0581c5a3dec30813$var$Cc = !1, $0581c5a3dec30813$var$U = 0, $0581c5a3dec30813$var$V = null, $0581c5a3dec30813$var$Dc = 0;
function $0581c5a3dec30813$var$W() {
    if (null === $0581c5a3dec30813$var$R) throw Error($0581c5a3dec30813$var$k(321));
    return $0581c5a3dec30813$var$R;
}
function $0581c5a3dec30813$var$Ec() {
    if (0 < $0581c5a3dec30813$var$Dc) throw Error($0581c5a3dec30813$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $0581c5a3dec30813$var$Fc() {
    null === $0581c5a3dec30813$var$S ? null === $0581c5a3dec30813$var$Bc ? ($0581c5a3dec30813$var$T = !1, $0581c5a3dec30813$var$Bc = $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Ec()) : ($0581c5a3dec30813$var$T = !0, $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Bc) : null === $0581c5a3dec30813$var$S.next ? ($0581c5a3dec30813$var$T = !1, $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$S.next = $0581c5a3dec30813$var$Ec()) : ($0581c5a3dec30813$var$T = !0, $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$S.next);
    return $0581c5a3dec30813$var$S;
}
function $0581c5a3dec30813$var$Gc() {
    $0581c5a3dec30813$var$Ac = $0581c5a3dec30813$var$R = null;
    $0581c5a3dec30813$var$Cc = !1;
    $0581c5a3dec30813$var$Bc = null;
    $0581c5a3dec30813$var$Dc = 0;
    $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$V = null;
}
function $0581c5a3dec30813$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0581c5a3dec30813$var$Ic(a, b, c) {
    $0581c5a3dec30813$var$R = $0581c5a3dec30813$var$W();
    $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Fc();
    if ($0581c5a3dec30813$var$T) {
        var d = $0581c5a3dec30813$var$S.queue;
        b = d.dispatch;
        if (null !== $0581c5a3dec30813$var$V && (c = $0581c5a3dec30813$var$V.get(d), void 0 !== c)) {
            $0581c5a3dec30813$var$V.delete(d);
            d = $0581c5a3dec30813$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $0581c5a3dec30813$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $0581c5a3dec30813$var$S.memoizedState,
            b
        ];
    }
    a = a === $0581c5a3dec30813$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $0581c5a3dec30813$var$S.memoizedState = a;
    a = $0581c5a3dec30813$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $0581c5a3dec30813$var$Jc.bind(null, $0581c5a3dec30813$var$R, a);
    return [
        $0581c5a3dec30813$var$S.memoizedState,
        a
    ];
}
function $0581c5a3dec30813$var$Kc(a, b) {
    $0581c5a3dec30813$var$R = $0581c5a3dec30813$var$W();
    $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $0581c5a3dec30813$var$S) {
        var c = $0581c5a3dec30813$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$0581c5a3dec30813$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $0581c5a3dec30813$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0581c5a3dec30813$var$Jc(a, b, c) {
    if (25 <= $0581c5a3dec30813$var$Dc) throw Error($0581c5a3dec30813$var$k(301));
    if (a === $0581c5a3dec30813$var$R) {
        if ($0581c5a3dec30813$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $0581c5a3dec30813$var$V && ($0581c5a3dec30813$var$V = new Map), c = $0581c5a3dec30813$var$V.get(b), void 0 === c) $0581c5a3dec30813$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $0581c5a3dec30813$var$Lc() {
    throw Error($0581c5a3dec30813$var$k(394));
}
function $0581c5a3dec30813$var$Mc() {}
var $0581c5a3dec30813$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $0581c5a3dec30813$var$W();
        return a._currentValue;
    },
    useMemo: $0581c5a3dec30813$var$Kc,
    useReducer: $0581c5a3dec30813$var$Ic,
    useRef: function(a) {
        $0581c5a3dec30813$var$R = $0581c5a3dec30813$var$W();
        $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Fc();
        var b = $0581c5a3dec30813$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $0581c5a3dec30813$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $0581c5a3dec30813$var$Ic($0581c5a3dec30813$var$Hc, a);
    },
    useInsertionEffect: $0581c5a3dec30813$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $0581c5a3dec30813$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $0581c5a3dec30813$var$Mc,
    useEffect: $0581c5a3dec30813$var$Mc,
    useDebugValue: $0581c5a3dec30813$var$Mc,
    useDeferredValue: function(a) {
        $0581c5a3dec30813$var$W();
        return a;
    },
    useTransition: function() {
        $0581c5a3dec30813$var$W();
        return [
            !1,
            $0581c5a3dec30813$var$Lc
        ];
    },
    useId: function() {
        var a = $0581c5a3dec30813$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $0581c5a3dec30813$var$uc(a) - 1)).toString(32) + b;
        var c = $0581c5a3dec30813$var$Nc;
        if (null === c) throw Error($0581c5a3dec30813$var$k(404));
        b = $0581c5a3dec30813$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $0581c5a3dec30813$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($0581c5a3dec30813$var$k(407));
        return c();
    }
}, $0581c5a3dec30813$var$Nc = null, $0581c5a3dec30813$var$Pc = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $0581c5a3dec30813$var$Qc(a) {
    console.error(a);
    return null;
}
function $0581c5a3dec30813$var$X() {}
function $0581c5a3dec30813$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $0581c5a3dec30813$var$Qc : f,
        onAllReady: void 0 === e ? $0581c5a3dec30813$var$X : e,
        onShellReady: void 0 === g ? $0581c5a3dec30813$var$X : g,
        onShellError: void 0 === h ? $0581c5a3dec30813$var$X : h,
        onFatalError: void 0 === m ? $0581c5a3dec30813$var$X : m
    };
    c = $0581c5a3dec30813$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $0581c5a3dec30813$var$Tc(b, a, null, c, r, $0581c5a3dec30813$var$kc, null, $0581c5a3dec30813$var$sc);
    q.push(a);
    return b;
}
function $0581c5a3dec30813$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $0581c5a3dec30813$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $0581c5a3dec30813$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $0581c5a3dec30813$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $0581c5a3dec30813$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $0581c5a3dec30813$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $0581c5a3dec30813$var$Wc(a, b, c, d, f) {
    $0581c5a3dec30813$var$R = {};
    $0581c5a3dec30813$var$Ac = b;
    $0581c5a3dec30813$var$U = 0;
    for(a = c(d, f); $0581c5a3dec30813$var$Cc;)$0581c5a3dec30813$var$Cc = !1, $0581c5a3dec30813$var$U = 0, $0581c5a3dec30813$var$Dc += 1, $0581c5a3dec30813$var$S = null, a = c(d, f);
    $0581c5a3dec30813$var$Gc();
    return a;
}
function $0581c5a3dec30813$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($0581c5a3dec30813$var$k(108, $0581c5a3dec30813$var$jc(d) || "Unknown", h));
            d = $0581c5a3dec30813$var$N({}, g, c);
        }
        b.legacyContext = d;
        $0581c5a3dec30813$var$Z(a, b, f);
        b.legacyContext = g;
    } else $0581c5a3dec30813$var$Z(a, b, f);
}
function $0581c5a3dec30813$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $0581c5a3dec30813$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0581c5a3dec30813$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $0581c5a3dec30813$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $0581c5a3dec30813$var$rc(e, c, d, f);
            $0581c5a3dec30813$var$Xc(a, b, e, c);
        } else {
            e = $0581c5a3dec30813$var$lc(c, b.legacyContext);
            f = $0581c5a3dec30813$var$Wc(a, b, c, d, e);
            var g = 0 !== $0581c5a3dec30813$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $0581c5a3dec30813$var$rc(f, c, d, e), $0581c5a3dec30813$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $0581c5a3dec30813$var$tc(d, 1, 0);
                try {
                    $0581c5a3dec30813$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $0581c5a3dec30813$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $0581c5a3dec30813$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $0581c5a3dec30813$var$Ba(g, c, d);
        $0581c5a3dec30813$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($0581c5a3dec30813$var$Ta, $0581c5a3dec30813$var$u(c), $0581c5a3dec30813$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $0581c5a3dec30813$var$gc:
            case $0581c5a3dec30813$var$fc:
            case $0581c5a3dec30813$var$Wb:
            case $0581c5a3dec30813$var$Xb:
            case $0581c5a3dec30813$var$Vb:
                $0581c5a3dec30813$var$Z(a, b, d.children);
                return;
            case $0581c5a3dec30813$var$bc:
                $0581c5a3dec30813$var$Z(a, b, d.children);
                return;
            case $0581c5a3dec30813$var$ec:
                throw Error($0581c5a3dec30813$var$k(343));
            case $0581c5a3dec30813$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $0581c5a3dec30813$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $0581c5a3dec30813$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($0581c5a3dec30813$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($0581c5a3dec30813$var$Ca), q.status = 1, $0581c5a3dec30813$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $0581c5a3dec30813$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $0581c5a3dec30813$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $0581c5a3dec30813$var$$b:
                d = $0581c5a3dec30813$var$Wc(a, b, c.render, d, f);
                if (0 !== $0581c5a3dec30813$var$U) {
                    c = b.treeContext;
                    b.treeContext = $0581c5a3dec30813$var$tc(c, 1, 0);
                    try {
                        $0581c5a3dec30813$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $0581c5a3dec30813$var$Z(a, b, d);
                return;
            case $0581c5a3dec30813$var$cc:
                c = c.type;
                d = $0581c5a3dec30813$var$Yc(c, d);
                $0581c5a3dec30813$var$Zc(a, b, c, d, f);
                return;
            case $0581c5a3dec30813$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $0581c5a3dec30813$var$O;
                $0581c5a3dec30813$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $0581c5a3dec30813$var$Z(a, b, f);
                a = $0581c5a3dec30813$var$O;
                if (null === a) throw Error($0581c5a3dec30813$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $0581c5a3dec30813$var$hc ? a.context._defaultValue : d;
                a = $0581c5a3dec30813$var$O = a.parent;
                b.context = a;
                return;
            case $0581c5a3dec30813$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $0581c5a3dec30813$var$Z(a, b, d);
                return;
            case $0581c5a3dec30813$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $0581c5a3dec30813$var$Yc(c, d);
                $0581c5a3dec30813$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($0581c5a3dec30813$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $0581c5a3dec30813$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $0581c5a3dec30813$var$Tb:
                $0581c5a3dec30813$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $0581c5a3dec30813$var$Ub:
                throw Error($0581c5a3dec30813$var$k(257));
            case $0581c5a3dec30813$var$dc:
                var d = c._init;
                c = d(c._payload);
                $0581c5a3dec30813$var$Z(a, b, c);
                return;
        }
        if ($0581c5a3dec30813$var$ra(c)) {
            $0581c5a3dec30813$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $0581c5a3dec30813$var$ic && c[$0581c5a3dec30813$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $0581c5a3dec30813$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($0581c5a3dec30813$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $0581c5a3dec30813$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $0581c5a3dec30813$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $0581c5a3dec30813$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $0581c5a3dec30813$var$tc(e, d, f);
        try {
            $0581c5a3dec30813$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $0581c5a3dec30813$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $0581c5a3dec30813$var$Z(a, b, c);
    } catch (m) {
        if ($0581c5a3dec30813$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $0581c5a3dec30813$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $0581c5a3dec30813$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $0581c5a3dec30813$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $0581c5a3dec30813$var$Q(e), m;
    }
}
function $0581c5a3dec30813$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $0581c5a3dec30813$var$dd(this, b, a);
}
function $0581c5a3dec30813$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($0581c5a3dec30813$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $0581c5a3dec30813$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $0581c5a3dec30813$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $0581c5a3dec30813$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $0581c5a3dec30813$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($0581c5a3dec30813$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $0581c5a3dec30813$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $0581c5a3dec30813$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($0581c5a3dec30813$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($0581c5a3dec30813$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $0581c5a3dec30813$var$Uc(a) {
    if (2 !== a.status) {
        var b = $0581c5a3dec30813$var$O, c = $0581c5a3dec30813$var$Pc.current;
        $0581c5a3dec30813$var$Pc.current = $0581c5a3dec30813$var$Oc;
        var d = $0581c5a3dec30813$var$Nc;
        $0581c5a3dec30813$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $0581c5a3dec30813$var$Q(g.context);
                    try {
                        $0581c5a3dec30813$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($0581c5a3dec30813$var$Ca), g.abortSet.delete(g), m.status = 1, $0581c5a3dec30813$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($0581c5a3dec30813$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $0581c5a3dec30813$var$Y(h, v);
                            null === r ? $0581c5a3dec30813$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $0581c5a3dec30813$var$fd(a, a.destination);
        } catch (G) {
            $0581c5a3dec30813$var$Y(a, G), $0581c5a3dec30813$var$Vc(a, G);
        } finally{
            $0581c5a3dec30813$var$Nc = d, $0581c5a3dec30813$var$Pc.current = c, c === $0581c5a3dec30813$var$Oc && $0581c5a3dec30813$var$Q(b);
        }
    }
}
function $0581c5a3dec30813$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Va);
            $0581c5a3dec30813$var$p(b, a.placeholderPrefix);
            a = $0581c5a3dec30813$var$u(d.toString(16));
            $0581c5a3dec30813$var$p(b, a);
            return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$0581c5a3dec30813$var$p(b, d[e]);
                f = $0581c5a3dec30813$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$0581c5a3dec30813$var$p(b, d[e]);
            e < d.length && (f = $0581c5a3dec30813$var$t(b, d[e]));
            return f;
        default:
            throw Error($0581c5a3dec30813$var$k(390));
    }
}
function $0581c5a3dec30813$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $0581c5a3dec30813$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$$a), $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$bb), d && ($0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$db), $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d))), $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$cb)), $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$eb), $0581c5a3dec30813$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $0581c5a3dec30813$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $0581c5a3dec30813$var$fb(b, a.responseState, d);
        $0581c5a3dec30813$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $0581c5a3dec30813$var$fb(b, a.responseState, d.id), $0581c5a3dec30813$var$gd(a, b, c);
    else {
        $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($0581c5a3dec30813$var$k(391));
        $0581c5a3dec30813$var$hd(a, b, c[0]);
    }
    return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$ab);
}
function $0581c5a3dec30813$var$id(a, b, c) {
    $0581c5a3dec30813$var$Bb(b, a.responseState, c.formatContext, c.id);
    $0581c5a3dec30813$var$hd(a, b, c);
    return $0581c5a3dec30813$var$Cb(b, c.formatContext);
}
function $0581c5a3dec30813$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$0581c5a3dec30813$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $0581c5a3dec30813$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Ib));
    if (null === d) throw Error($0581c5a3dec30813$var$k(395));
    c = $0581c5a3dec30813$var$u(c.toString(16));
    $0581c5a3dec30813$var$p(b, d);
    $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Kb);
    $0581c5a3dec30813$var$p(b, a.segmentPrefix);
    $0581c5a3dec30813$var$p(b, c);
    return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Lb);
}
function $0581c5a3dec30813$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($0581c5a3dec30813$var$k(392));
        return $0581c5a3dec30813$var$id(a, b, d);
    }
    $0581c5a3dec30813$var$id(a, b, d);
    a = a.responseState;
    $0581c5a3dec30813$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Eb) : (a.sentCompleteSegmentFunction = !0, $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Db));
    $0581c5a3dec30813$var$p(b, a.segmentPrefix);
    f = $0581c5a3dec30813$var$u(f.toString(16));
    $0581c5a3dec30813$var$p(b, f);
    $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Gb);
    $0581c5a3dec30813$var$p(b, a.placeholderPrefix);
    $0581c5a3dec30813$var$p(b, f);
    return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Hb);
}
function $0581c5a3dec30813$var$fd(a, b) {
    $0581c5a3dec30813$var$l = new Uint8Array(512);
    $0581c5a3dec30813$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $0581c5a3dec30813$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$0581c5a3dec30813$var$p(b, d[c]);
            c < d.length && $0581c5a3dec30813$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $0581c5a3dec30813$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Nb) : (h.sentClientRenderFunction = !0, $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Mb));
            if (null === m) throw Error($0581c5a3dec30813$var$k(395));
            $0581c5a3dec30813$var$p(d, m);
            $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Ob);
            if (q || r || v) $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Qb), $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$Sb(q || "")));
            if (r || v) $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Qb), $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$Sb(r || "")));
            v && ($0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Qb), $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$Sb(v))));
            if (!$0581c5a3dec30813$var$t(d, $0581c5a3dec30813$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$0581c5a3dec30813$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $0581c5a3dec30813$var$ba(b);
        $0581c5a3dec30813$var$l = new Uint8Array(512);
        $0581c5a3dec30813$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$0581c5a3dec30813$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$0581c5a3dec30813$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $0581c5a3dec30813$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $0581c5a3dec30813$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $0581c5a3dec30813$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $0581c5a3dec30813$var$fd(a, a.destination);
    } catch (d) {
        $0581c5a3dec30813$var$Y(a, d), $0581c5a3dec30813$var$Vc(a, d);
    }
}
$0581c5a3dec30813$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $0581c5a3dec30813$var$Rc(a, $0581c5a3dec30813$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $0581c5a3dec30813$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $0581c5a3dec30813$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $0581c5a3dec30813$var$fd(h, a);
                        } catch (A) {
                            $0581c5a3dec30813$var$Y(h, A), $0581c5a3dec30813$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $0581c5a3dec30813$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $0581c5a3dec30813$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $0581c5a3dec30813$var$Uc(h);
    });
};
$0581c5a3dec30813$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("3pSHx", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $27ce236fe1a3184f$export$828c4931ae562af7);

var $caazz = parcelRequire("caazz");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issuefieldvalue/manifest.ts
var $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $caazz.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $caazz.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $27ce236fe1a3184f$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("caazz", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $8dae9ec06e7b65f0$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $8dae9ec06e7b65f0$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $8dae9ec06e7b65f0$export$39e9358142fbbc64 = "jira", $8dae9ec06e7b65f0$export$f9e57427271adc95 = "issuefieldvalue";

});


parcelRegister("hOcoS", function(module, exports) {

$parcel$export(module.exports, "convertAdfToText", () => $c3163b825f5afaef$export$f36d973840b7febc);

var $8DB98 = parcelRequire("8DB98");

var $fjfmN = parcelRequire("fjfmN");

var $1LVxc = parcelRequire("1LVxc");
const $c3163b825f5afaef$var$serializer = (0, $1LVxc.default).fromSchema((0, $8DB98.defaultSchema));
const $c3163b825f5afaef$export$f36d973840b7febc = (doc)=>{
    if (!doc) return '';
    if (doc?.content?.length < 1) // renderer has a bug where empty adf returns null instead of empty string
    return '';
    const outputText = (0, $fjfmN.renderDocument)(doc, $c3163b825f5afaef$var$serializer, (0, $8DB98.defaultSchema)).result;
    return outputText;
};

});
parcelRegister("8DB98", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $649ec7bd1a149376$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $649ec7bd1a149376$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $649ec7bd1a149376$export$1db618b7b2275ea1);

var $LFmXM = parcelRequire("LFmXM");

var $eSKW9 = parcelRequire("eSKW9");
var $6C9Qx = parcelRequire("6C9Qx");
var $jSvxD = parcelRequire("jSvxD");
var $gkLMH = parcelRequire("gkLMH");
var $e6HpD = parcelRequire("e6HpD");

var $g7Jv8 = parcelRequire("g7Jv8");
const $649ec7bd1a149376$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $649ec7bd1a149376$export$e4e3ac1fa64862db = $649ec7bd1a149376$var$getDefaultSchemaConfig();
const $649ec7bd1a149376$export$fd147e7d448dea03 = (0, $LFmXM.default)((stage = 'final')=>{
    const defaultSchemaConfig = $649ec7bd1a149376$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jSvxD.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $6C9Qx.multiBodiedExtension),
        extensionFrame: (0, $6C9Qx.extensionFrame),
        expand: (0, $eSKW9.expandWithNestedExpand),
        listItem: (0, $gkLMH.listItemWithDecisionStage0),
        table: (0, $e6HpD.tableWithNestedTable),
        tableRow: (0, $e6HpD.tableRowWithNestedTable),
        tableCell: (0, $e6HpD.tableCellWithNestedTable),
        tableHeader: (0, $e6HpD.tableHeaderWithNestedTable)
    };
    return (0, $g7Jv8.createSchema)(defaultSchemaConfig);
});
const $649ec7bd1a149376$export$1db618b7b2275ea1 = $649ec7bd1a149376$export$fd147e7d448dea03();

});
parcelRegister("eSKW9", function(module, exports) {

$parcel$export(module.exports, "expandWithNestedExpand", () => $ad5a848656ebe869$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $ad5a848656ebe869$export$54fd2c36b5cc6731);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $ad5a848656ebe869$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $ad5a848656ebe869$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $ad5a848656ebe869$export$7b80cba28d10b2c1 = (0, $nJVLW.expand)($ad5a848656ebe869$var$nodeSpecOptions);
const $ad5a848656ebe869$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("nJVLW", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $0475c6ffc1ba526d$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $0475c6ffc1ba526d$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $0475c6ffc1ba526d$export$199922e5af8e9a6);
$parcel$export(module.exports, "bodiedExtension", () => $0475c6ffc1ba526d$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $0475c6ffc1ba526d$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $0475c6ffc1ba526d$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $0475c6ffc1ba526d$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $0475c6ffc1ba526d$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $0475c6ffc1ba526d$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $0475c6ffc1ba526d$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $0475c6ffc1ba526d$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $0475c6ffc1ba526d$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $0475c6ffc1ba526d$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $0475c6ffc1ba526d$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $0475c6ffc1ba526d$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $0475c6ffc1ba526d$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $0475c6ffc1ba526d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $0475c6ffc1ba526d$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $0475c6ffc1ba526d$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $0475c6ffc1ba526d$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $0475c6ffc1ba526d$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $0475c6ffc1ba526d$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $0475c6ffc1ba526d$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $0475c6ffc1ba526d$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $0475c6ffc1ba526d$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $0475c6ffc1ba526d$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $0475c6ffc1ba526d$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $0475c6ffc1ba526d$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $0475c6ffc1ba526d$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $0475c6ffc1ba526d$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $0475c6ffc1ba526d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $0475c6ffc1ba526d$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $0475c6ffc1ba526d$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $0475c6ffc1ba526d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $0475c6ffc1ba526d$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $0475c6ffc1ba526d$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $0475c6ffc1ba526d$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $0475c6ffc1ba526d$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $0475c6ffc1ba526d$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $0475c6ffc1ba526d$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $0475c6ffc1ba526d$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $0475c6ffc1ba526d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $0475c6ffc1ba526d$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $0475c6ffc1ba526d$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $0475c6ffc1ba526d$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $0475c6ffc1ba526d$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $0475c6ffc1ba526d$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $0475c6ffc1ba526d$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $0475c6ffc1ba526d$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $0475c6ffc1ba526d$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $0475c6ffc1ba526d$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $0475c6ffc1ba526d$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $0475c6ffc1ba526d$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $0475c6ffc1ba526d$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $0475c6ffc1ba526d$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $0475c6ffc1ba526d$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $0475c6ffc1ba526d$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $0475c6ffc1ba526d$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $0475c6ffc1ba526d$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $1zhCF = parcelRequire("1zhCF");
const $0475c6ffc1ba526d$export$c4c2f833baaebdb8 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$67dc04e652a298ca = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
const $0475c6ffc1ba526d$export$199922e5af8e9a6 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $0475c6ffc1ba526d$export$27903d543b563e39 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$e7320d153c538837 = (0, $1zhCF.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$a140c94e5ea26bee = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $0475c6ffc1ba526d$export$8e3c2dfdc4f0453d = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $0475c6ffc1ba526d$export$7bb0d5c671655cc4 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $0475c6ffc1ba526d$export$e4f1c66d84049f8b = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $0475c6ffc1ba526d$export$daf889beb5092f95 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$e6e4878f43c27cab = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$3e6d667072febc87 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$324d90190a8b822a = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$47988d68fe575725 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$6959e16eeff859b4 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $0475c6ffc1ba526d$export$62d45a65fb43d95e = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$2a111da947c407d2 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $0475c6ffc1ba526d$export$be4283d9a1cb1ff6 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$a19185d1233fc4b2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$f5574b5d45fc2112 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9f77e0932fb78f72 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$7e3788972005cc72 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$1b45514b112dd749 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$a8baf338431a691 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b555be60c7703afb = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$371da9dd35aba193 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $0475c6ffc1ba526d$export$46e4a324ac90507f = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$1b0c1557b234fa00 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$85461f751c457cc2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$2b380a0f7e250af1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$5c452ff88e35e47d = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $0475c6ffc1ba526d$export$cbf8224b64e0d942 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$2f4e72b9459914ad = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$16b353b2649bd8d9 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b3b1e36c2105006d = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$ab76e7c03cd6f650 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $0475c6ffc1ba526d$export$b3b6a70a7fa4a5be = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $0475c6ffc1ba526d$export$cdae19acb0a520fd = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $0475c6ffc1ba526d$export$206007566ca0aca5 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $0475c6ffc1ba526d$export$76c7e83ecc9cdf05 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$df876f0305235056 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$987d49ffe1b0900f = (0, $1zhCF.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$2855e964765eac9 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $0475c6ffc1ba526d$export$38bab695e3f720f1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$969fe3781ca15058 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $0475c6ffc1ba526d$export$8d067f22dc2d1254 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$7e767666f2ce108a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$4bd9a38995f6bf50 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$db83999c14438df4 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$46f790bd65f760d0 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$750e45819f66d9d0 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $0475c6ffc1ba526d$export$63cadbf5f4296627 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$f03786aa6312d1e4 = (0, $1zhCF.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$a5dc81035676e7a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$21f42ab9b6679f44 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9c206ddddb32a9b = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$4f98472e6dc14293 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$ea332b61641b0588 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$a1f41dc4901771f8 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$c7187bbd1a7a9244 = (0, $1zhCF.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$fbeb3a3956e8a3c7 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block'
});
const $0475c6ffc1ba526d$export$471f7ae5c4103ae1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b6ce52be8d7a261 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9852986a3ec5f6a0 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0475c6ffc1ba526d$export$ce086a560a1d05f5 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0475c6ffc1ba526d$export$e1e720e5f4603e6a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0475c6ffc1ba526d$export$abf39ca178940ff3 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0475c6ffc1ba526d$export$48884d2a5190dc73 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0475c6ffc1ba526d$export$2a5a518232fa1a97 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0475c6ffc1ba526d$export$ce666bf02318c957 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $0475c6ffc1ba526d$export$7d657479499397 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $0475c6ffc1ba526d$export$6d8b0ef52e2e6390 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$375b6afcc5f4d291 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$6f093cfa640b7166 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$5ea06bc686c59dc2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$93256a4c17b33a82 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$a12828d0f14a2762 = (0, $1zhCF.createPMNodeSpecFactory)({});
const $0475c6ffc1ba526d$export$44b79b0979d0f0f7 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$310ebe0d80122e9b = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("1zhCF", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $1246bacc7b1ceffa$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $1246bacc7b1ceffa$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $1246bacc7b1ceffa$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $1246bacc7b1ceffa$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("6C9Qx", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $4d0dedfce6d8a509$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $4d0dedfce6d8a509$export$c3c04d555a8b9013);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $4d0dedfce6d8a509$export$4fdcae991fd743e7 = (0, $nJVLW.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4d0dedfce6d8a509$export$c3c04d555a8b9013 = (0, $nJVLW.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("fPSlo", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $b875c609076dd72b$export$1765e2758fc47004);
const $b875c609076dd72b$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $b875c609076dd72b$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $b875c609076dd72b$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("jSvxD", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $e78b86f811605f22$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e78b86f811605f22$export$4f9d8f623ff17117);

var $nJVLW = parcelRequire("nJVLW");
const $e78b86f811605f22$export$b3b6a70a7fa4a5be = (0, $nJVLW.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$cdae19acb0a520fd = (0, $nJVLW.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$4f9d8f623ff17117 = (0, $nJVLW.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gkLMH", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $be43949bca9723a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $be43949bca9723a7$export$b2cd54d5ce935ddb);

var $nJVLW = parcelRequire("nJVLW");
const $be43949bca9723a7$export$76c7e83ecc9cdf05 = (0, $nJVLW.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $be43949bca9723a7$export$b2cd54d5ce935ddb = (0, $nJVLW.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("e6HpD", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $a4534d0d8902e0f9$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $a4534d0d8902e0f9$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $a4534d0d8902e0f9$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $a4534d0d8902e0f9$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $a4534d0d8902e0f9$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $a4534d0d8902e0f9$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $a4534d0d8902e0f9$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $a4534d0d8902e0f9$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $a4534d0d8902e0f9$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $a4534d0d8902e0f9$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $a4534d0d8902e0f9$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $a4534d0d8902e0f9$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $a4534d0d8902e0f9$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $a4534d0d8902e0f9$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $a4534d0d8902e0f9$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $a4534d0d8902e0f9$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $a4534d0d8902e0f9$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $a4534d0d8902e0f9$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $a4534d0d8902e0f9$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $a4534d0d8902e0f9$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $a4534d0d8902e0f9$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $a4534d0d8902e0f9$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $a4534d0d8902e0f9$export$2a5a518232fa1a97);

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $2OrIX = parcelRequire("2OrIX");

var $4PpDP = parcelRequire("4PpDP");

var $nJVLW = parcelRequire("nJVLW");
const $a4534d0d8902e0f9$export$9cfceb893b24742a = 'pm-table';
const $a4534d0d8902e0f9$export$69cb4c3f80383763 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-content-wrap`;
const $a4534d0d8902e0f9$export$7b07d37d879c957f = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-header-content-wrap`;
const $a4534d0d8902e0f9$export$8dd42a84cd52da07 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $a4534d0d8902e0f9$export$5e26a5c19f0865d8 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $a4534d0d8902e0f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51dYk.N20).toLocaleLowerCase();
const $a4534d0d8902e0f9$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51dYk.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51dYk.isRgb)(backgroundColor)) {
        const result = (0, $51dYk.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $a4534d0d8902e0f9$var$testGlobalTheme;
const $a4534d0d8902e0f9$export$fd7e0dd2b74807f7 = (theme)=>{
    $a4534d0d8902e0f9$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $a4534d0d8902e0f9$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($a4534d0d8902e0f9$var$testGlobalTheme) return {
        colorMode: $a4534d0d8902e0f9$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $a4534d0d8902e0f9$var$cssVariablePattern = /^var\(--.*\)$/;
const $a4534d0d8902e0f9$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $a4534d0d8902e0f9$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $a4534d0d8902e0f9$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51dYk.isRgb)(background) && (0, $51dYk.rgbToHex)(background) ? (0, $51dYk.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $dyyJM.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $a4534d0d8902e0f9$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($a4534d0d8902e0f9$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $4PpDP.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $a4534d0d8902e0f9$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $a4534d0d8902e0f9$export$7b07d37d879c957f;
    else attrs.class = $a4534d0d8902e0f9$export$69cb4c3f80383763;
    return attrs;
};
const $a4534d0d8902e0f9$export$219b7f492ad209f8 = new Map();
const $a4534d0d8902e0f9$export$95e9c925fbf01d1c = (0, $51dYk.hexToRgba)((0, $51dYk.N800), 0.12) || (0, $51dYk.N0);
const $a4534d0d8902e0f9$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51dYk.N0),
        'White'
    ],
    [
        (0, $51dYk.B50),
        'Light blue'
    ],
    [
        (0, $51dYk.T50),
        'Light teal'
    ],
    [
        (0, $51dYk.G50),
        'Light green'
    ],
    [
        (0, $51dYk.Y50),
        'Light yellow'
    ],
    [
        (0, $51dYk.R50),
        'Light red'
    ],
    [
        (0, $51dYk.P50),
        'Light purple'
    ],
    [
        (0, $51dYk.N20),
        'Light gray'
    ],
    [
        (0, $51dYk.B75),
        'Blue'
    ],
    [
        (0, $51dYk.T75),
        'Teal'
    ],
    [
        (0, $51dYk.G75),
        'Green'
    ],
    [
        (0, $51dYk.Y75),
        'Yellow'
    ],
    [
        (0, $51dYk.R75),
        'Red'
    ],
    [
        (0, $51dYk.P75),
        'Purple'
    ],
    [
        (0, $51dYk.N60),
        'Gray'
    ],
    [
        (0, $51dYk.B100),
        'Dark blue'
    ],
    [
        (0, $51dYk.T100),
        'Dark teal'
    ],
    [
        (0, $51dYk.G200),
        'Dark green'
    ],
    [
        (0, $51dYk.Y200),
        'Dark yellow'
    ],
    [
        (0, $51dYk.R100),
        'Dark red'
    ],
    [
        (0, $51dYk.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $a4534d0d8902e0f9$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $a4534d0d8902e0f9$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $a4534d0d8902e0f9$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $2OrIX.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $a4534d0d8902e0f9$var$createTableSpec = ()=>(0, $nJVLW.table)($a4534d0d8902e0f9$var$tableNodeSpecOptions);
const $a4534d0d8902e0f9$export$9852986a3ec5f6a0 = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$export$90e634fbace1f0c4 = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$export$3862de5c8c9098cf = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $a4534d0d8902e0f9$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$a4534d0d8902e0f9$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $a4534d0d8902e0f9$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $a4534d0d8902e0f9$export$ce666bf02318c957 = (0, $nJVLW.tableRow)($a4534d0d8902e0f9$var$tableRowNodeSpecOptions);
const $a4534d0d8902e0f9$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $a4534d0d8902e0f9$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ]
};
const $a4534d0d8902e0f9$export$e1e720e5f4603e6a = (0, $nJVLW.tableCell)($a4534d0d8902e0f9$var$tableCellNodeSpecOptions);
const $a4534d0d8902e0f9$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($a4534d0d8902e0f9$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom, {
                    background: $a4534d0d8902e0f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ]
};
const $a4534d0d8902e0f9$export$48884d2a5190dc73 = (0, $nJVLW.tableHeader)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions);
const $a4534d0d8902e0f9$export$2af48797a1010bb1 = $a4534d0d8902e0f9$export$2ac34c099660f1a8;
const $a4534d0d8902e0f9$export$ce086a560a1d05f5 = (0, $nJVLW.tableWithNestedTable)($a4534d0d8902e0f9$var$tableNodeSpecOptions);
const $a4534d0d8902e0f9$export$7d657479499397 = (0, $nJVLW.tableRowWithNestedTable)($a4534d0d8902e0f9$var$tableRowNodeSpecOptions);
const $a4534d0d8902e0f9$export$abf39ca178940ff3 = (0, $nJVLW.tableCellWithNestedTable)($a4534d0d8902e0f9$var$tableCellNodeSpecOptions);
const $a4534d0d8902e0f9$export$2a5a518232fa1a97 = (0, $nJVLW.tableHeaderWithNestedTable)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions);

});
parcelRegister("dyyJM", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $028c05c3f3022d58$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $028c05c3f3022d58$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $028c05c3f3022d58$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $028c05c3f3022d58$export$a270511a0e7fd61a);

var $59rsN = parcelRequire("59rsN");
function $028c05c3f3022d58$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $028c05c3f3022d58$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $028c05c3f3022d58$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $59rsN.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $028c05c3f3022d58$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $028c05c3f3022d58$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $028c05c3f3022d58$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $028c05c3f3022d58$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51dYk", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a77e248cfc93706$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a77e248cfc93706$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a77e248cfc93706$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a77e248cfc93706$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $3a77e248cfc93706$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a77e248cfc93706$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a77e248cfc93706$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a77e248cfc93706$export$5aae31392d72caaa);
$parcel$export(module.exports, "Yellow200", () => $3a77e248cfc93706$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $3a77e248cfc93706$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a77e248cfc93706$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a77e248cfc93706$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a77e248cfc93706$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a77e248cfc93706$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $3a77e248cfc93706$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a77e248cfc93706$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a77e248cfc93706$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a77e248cfc93706$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a77e248cfc93706$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a77e248cfc93706$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a77e248cfc93706$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a77e248cfc93706$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a77e248cfc93706$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a77e248cfc93706$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a77e248cfc93706$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a77e248cfc93706$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a77e248cfc93706$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a77e248cfc93706$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a77e248cfc93706$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a77e248cfc93706$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a77e248cfc93706$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a77e248cfc93706$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a77e248cfc93706$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a77e248cfc93706$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a77e248cfc93706$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a77e248cfc93706$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a77e248cfc93706$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a77e248cfc93706$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a77e248cfc93706$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a77e248cfc93706$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a77e248cfc93706$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a77e248cfc93706$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a77e248cfc93706$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a77e248cfc93706$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a77e248cfc93706$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a77e248cfc93706$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a77e248cfc93706$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a77e248cfc93706$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a77e248cfc93706$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a77e248cfc93706$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a77e248cfc93706$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a77e248cfc93706$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a77e248cfc93706$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a77e248cfc93706$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a77e248cfc93706$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a77e248cfc93706$export$9665a07d9187b414);

var $k9rAg = parcelRequire("k9rAg");
const $3a77e248cfc93706$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a77e248cfc93706$export$b34b069eff244586 = '#FFBDAD';
const $3a77e248cfc93706$export$be802dd0d8b57f35 = '#FF8F73';
const $3a77e248cfc93706$export$4a7404f376229999 = '#FF5630';
const $3a77e248cfc93706$export$2010d0fb4295b346 = '#DE350B';
const $3a77e248cfc93706$export$2837b5a1a71d5c02 = '#BF2600';
const $3a77e248cfc93706$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a77e248cfc93706$export$41060a744ab0b7ae = '#FFF0B3';
const $3a77e248cfc93706$export$5aae31392d72caaa = '#FFC400';
const $3a77e248cfc93706$export$fc857b6f8771648a = '#F8E6A0';
const $3a77e248cfc93706$export$59619663aa6500fb = '#FF991F';
const $3a77e248cfc93706$export$874739ea9e379ab6 = '#FF8B00';
const $3a77e248cfc93706$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a77e248cfc93706$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a77e248cfc93706$export$747d86715d4175de = '#57D9A3';
const $3a77e248cfc93706$export$940e1f69e873f202 = '#36B37E';
const $3a77e248cfc93706$export$a49394138f7b8e85 = '#00875A';
const $3a77e248cfc93706$export$6fa04827ac68a4fb = '#006644';
const $3a77e248cfc93706$export$226de0355ed012f8 = '#DEEBFF';
const $3a77e248cfc93706$export$8c13c2ee36917869 = '#B3D4FF';
const $3a77e248cfc93706$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a77e248cfc93706$export$b3de0ae08da2ce64 = '#0052CC';
const $3a77e248cfc93706$export$a6ee3d71bc067634 = '#0747A6';
const $3a77e248cfc93706$export$f72948ef771f6f15 = '#D3F1A7';
const $3a77e248cfc93706$export$29a4f05edc054374 = '#FFFFFF';
const $3a77e248cfc93706$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a77e248cfc93706$export$3e51e8f1440314ba = '#EBECF0';
const $3a77e248cfc93706$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a77e248cfc93706$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a77e248cfc93706$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a77e248cfc93706$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a77e248cfc93706$export$7c87d337fb91a97d = '#8993A4';
const $3a77e248cfc93706$export$f563ee71e9ee74cd = '#6B778C';
const $3a77e248cfc93706$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a77e248cfc93706$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a77e248cfc93706$export$13609db0e6812ab8 = '#091E4224';
const $3a77e248cfc93706$export$c39c0fe0f26207ae = '#42526E';
const $3a77e248cfc93706$export$7090862dc3038a9f = '#758195';
const $3a77e248cfc93706$export$7d61b15e0da132af = '#172B4D';
const $3a77e248cfc93706$export$f78789c8b01753cd = '#172B4D';
const $3a77e248cfc93706$export$a19f0c33186f7767 = '#FDD0EC';
const $3a77e248cfc93706$export$51716a84e62e022c = '#FEDEC8';
const $3a77e248cfc93706$export$363e4475840015bb = '#EAE6FF';
const $3a77e248cfc93706$export$4b0a4417ed59760f = '#C0B6F2';
const $3a77e248cfc93706$export$6011520a64d9a187 = '#998DD9';
const $3a77e248cfc93706$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a77e248cfc93706$export$b48405b95304b5a1 = '#6554C0';
const $3a77e248cfc93706$export$c71e4279dd54a18d = '#5243AA';
const $3a77e248cfc93706$export$147899de772240ec = '#403294';
const $3a77e248cfc93706$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a77e248cfc93706$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a77e248cfc93706$export$776c9c497ef08533 = '#79E2F2';
const $3a77e248cfc93706$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a77e248cfc93706$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a77e248cfc93706$export$6036577f95c3877e = '#008DA6';
function $3a77e248cfc93706$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a77e248cfc93706$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a77e248cfc93706$export$e698776ec826343(color)) return $3a77e248cfc93706$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($k9rAg.default && $k9rAg.default[color]) color = $k9rAg.default[color];
        else if ($k9rAg && $k9rAg[color]) color = $k9rAg[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a77e248cfc93706$export$5a544e13ad4e1fa5(color) {
    if (!$3a77e248cfc93706$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a77e248cfc93706$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a77e248cfc93706$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a77e248cfc93706$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a77e248cfc93706$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a77e248cfc93706$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("k9rAg", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("2OrIX", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $20c5c1b68bce331d$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $20c5c1b68bce331d$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $20c5c1b68bce331d$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $20c5c1b68bce331d$var$staticValue = false;
const $20c5c1b68bce331d$export$31b40729666a4ae0 = {
    setStatic (value) {
        $20c5c1b68bce331d$var$staticValue = value;
    },
    generate () {
        return $20c5c1b68bce331d$var$staticValue || $20c5c1b68bce331d$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("4PpDP", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $383fd0b1d61f7ae7$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $383fd0b1d61f7ae7$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $383fd0b1d61f7ae7$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $383fd0b1d61f7ae7$var$rgbFromHex = (input)=>{
    const fullHex = $383fd0b1d61f7ae7$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $383fd0b1d61f7ae7$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $383fd0b1d61f7ae7$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $383fd0b1d61f7ae7$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $383fd0b1d61f7ae7$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $383fd0b1d61f7ae7$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $383fd0b1d61f7ae7$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $383fd0b1d61f7ae7$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $383fd0b1d61f7ae7$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $383fd0b1d61f7ae7$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $383fd0b1d61f7ae7$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $383fd0b1d61f7ae7$var$rgbToLch = (rgb)=>$383fd0b1d61f7ae7$var$labToLch($383fd0b1d61f7ae7$var$xyzToLab($383fd0b1d61f7ae7$var$rgbToXyz(rgb)));
const $383fd0b1d61f7ae7$var$lchToRgb = (lch)=>$383fd0b1d61f7ae7$var$xyzToRgb($383fd0b1d61f7ae7$var$labToXyz($383fd0b1d61f7ae7$var$lchToLab(lch)));
const $383fd0b1d61f7ae7$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $383fd0b1d61f7ae7$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $383fd0b1d61f7ae7$var$rgbToLch(rgb);
    lch.l = $383fd0b1d61f7ae7$var$clamp(newPercent, 0, 100);
    return $383fd0b1d61f7ae7$var$rgbToHex($383fd0b1d61f7ae7$var$lchToRgb(lch));
};
const $383fd0b1d61f7ae7$var$getLightness = (color)=>{
    const rgb = $383fd0b1d61f7ae7$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $383fd0b1d61f7ae7$var$rgbToLch(rgb);
    return lch.l;
};
const $383fd0b1d61f7ae7$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $383fd0b1d61f7ae7$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $383fd0b1d61f7ae7$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("g7Jv8", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $bbd098624269520c$export$5f4ce795563f4211);

var $3xw6l = parcelRequire("3xw6l");


var $mYA6R = parcelRequire("mYA6R");

var $fRfD8 = parcelRequire("fRfD8");
var $jxPcD = parcelRequire("jxPcD");
var $7i9jz = parcelRequire("7i9jz");
var $3Pxk9 = parcelRequire("3Pxk9");
var $7uhRT = parcelRequire("7uhRT");
var $eA6GD = parcelRequire("eA6GD");
var $04SjV = parcelRequire("04SjV");
var $dHJym = parcelRequire("dHJym");
var $eonww = parcelRequire("eonww");
var $6Ymtk = parcelRequire("6Ymtk");
var $7GG3N = parcelRequire("7GG3N");
var $h9kgv = parcelRequire("h9kgv");
var $f4V9T = parcelRequire("f4V9T");
var $YKDO7 = parcelRequire("YKDO7");
var $hI6rl = parcelRequire("hI6rl");
var $abZsg = parcelRequire("abZsg");
var $anaPs = parcelRequire("anaPs");
var $b7o0x = parcelRequire("b7o0x");
var $kdb0W = parcelRequire("kdb0W");
var $3pgGD = parcelRequire("3pgGD");

var $5sqgz = parcelRequire("5sqgz");
var $kuVVV = parcelRequire("kuVVV");
var $7T1su = parcelRequire("7T1su");
var $l2o3P = parcelRequire("l2o3P");
var $02BNy = parcelRequire("02BNy");
var $itOTx = parcelRequire("itOTx");
var $99RFR = parcelRequire("99RFR");
var $4LGm1 = parcelRequire("4LGm1");
var $s7CHM = parcelRequire("s7CHM");
var $eblOZ = parcelRequire("eblOZ");
var $9FkNK = parcelRequire("9FkNK");
var $gjQyF = parcelRequire("gjQyF");
var $YIci7 = parcelRequire("YIci7");
var $foHUC = parcelRequire("foHUC");
var $eSKW9 = parcelRequire("eSKW9");
var $iBSvH = parcelRequire("iBSvH");
var $ePdnq = parcelRequire("ePdnq");
var $6r1B4 = parcelRequire("6r1B4");
var $6C9Qx = parcelRequire("6C9Qx");
var $ewUmv = parcelRequire("ewUmv");
var $8FGKL = parcelRequire("8FGKL");
var $lM0g9 = parcelRequire("lM0g9");
var $3MHOZ = parcelRequire("3MHOZ");
var $5Ufvu = parcelRequire("5Ufvu");
var $gNk91 = parcelRequire("gNk91");
var $jSvxD = parcelRequire("jSvxD");
var $gkLMH = parcelRequire("gkLMH");
var $bTlUc = parcelRequire("bTlUc");
var $goVGV = parcelRequire("goVGV");
var $5RVMs = parcelRequire("5RVMs");
var $8Mfla = parcelRequire("8Mfla");
var $7axvl = parcelRequire("7axvl");
var $6UEeD = parcelRequire("6UEeD");
var $a4ifE = parcelRequire("a4ifE");
var $bK3tx = parcelRequire("bK3tx");
var $hbObi = parcelRequire("hbObi");
var $jC4KP = parcelRequire("jC4KP");
var $c2Gqu = parcelRequire("c2Gqu");
var $e6HpD = parcelRequire("e6HpD");
var $5iuEY = parcelRequire("5iuEY");
var $6Yq90 = parcelRequire("6Yq90");
var $53i5t = parcelRequire("53i5t");
var $bffKB = parcelRequire("bffKB");
var $e1kFZ = parcelRequire("e1kFZ");
var $5blh0 = parcelRequire("5blh0");
function $bbd098624269520c$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $bbd098624269520c$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $bbd098624269520c$var$markGroupDeclarations = [
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$9b982809044276a6)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$4498a6080fed604c)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$f8e8a5f34f6ea725)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$b395009ca7f092c7))
];
const $bbd098624269520c$var$markGroupDeclarationsNames = $bbd098624269520c$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $bbd098624269520c$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $gjQyF.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $bK3tx.paragraph)
    },
    {
        name: 'text',
        spec: (0, $53i5t.text)
    },
    {
        name: 'bulletList',
        spec: (0, $7T1su.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $a4ifE.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $gkLMH.listItem)
    },
    {
        name: 'heading',
        spec: (0, $8FGKL.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $iBSvH.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $02BNy.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $ePdnq.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $jC4KP.rule)
    },
    {
        name: 'image',
        spec: (0, $lM0g9.image)
    },
    {
        name: 'mention',
        spec: (0, $7axvl.mention)
    },
    {
        name: 'caption',
        spec: (0, $l2o3P.caption)
    },
    {
        name: 'media',
        spec: (0, $bTlUc.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $goVGV.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $8Mfla.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $5RVMs.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $hbObi.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jSvxD.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $gNk91.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $ewUmv.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $foHUC.emoji)
    },
    {
        name: 'table',
        spec: (0, $e6HpD.table)
    },
    {
        name: 'tableCell',
        spec: (0, $e6HpD.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $e6HpD.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $e6HpD.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $itOTx.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $4LGm1.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $99RFR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $9FkNK.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $eblOZ.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $6Yq90.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $5iuEY.taskItem)
    },
    {
        name: 'date',
        spec: (0, $s7CHM.date)
    },
    {
        name: 'status',
        spec: (0, $c2Gqu.status)
    },
    {
        name: 'expand',
        spec: (0, $eSKW9.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $6UEeD.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $6r1B4.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5Ufvu.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $kuVVV.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $6C9Qx.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $6C9Qx.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $3MHOZ.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $5sqgz.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $YIci7.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $bffKB.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $e1kFZ.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $5blh0.unsupportedInline)
    }
];
const $bbd098624269520c$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $h9kgv.link)
    },
    {
        name: 'em',
        spec: (0, $eonww.em)
    },
    {
        name: 'strong',
        spec: (0, $YKDO7.strong)
    },
    {
        name: 'textColor',
        spec: (0, $abZsg.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $7i9jz.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $f4V9T.strike)
    },
    {
        name: 'subsup',
        spec: (0, $hI6rl.subsup)
    },
    {
        name: 'underline',
        spec: (0, $b7o0x.underline)
    },
    {
        name: 'code',
        spec: (0, $eA6GD.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $anaPs.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $fRfD8.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $jxPcD.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $04SjV.confluenceInlineComment)
    },
    ...$bbd098624269520c$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $7uhRT.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $dHJym.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $6Ymtk.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $7GG3N.indentation)
    },
    {
        name: 'border',
        spec: (0, $3Pxk9.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $kdb0W.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $3pgGD.unsupportedNodeAttribute)
    }
];
function $bbd098624269520c$export$2d0c32a809131488() {
    const nodes = $bbd098624269520c$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $bbd098624269520c$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $bbd098624269520c$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($bbd098624269520c$var$markGroupDeclarationsNames);
    let nodes = $bbd098624269520c$var$addItems($bbd098624269520c$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $bbd098624269520c$var$addItems($bbd098624269520c$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $mYA6R.sanitizeNodes)(nodes, marks);
    return new (0, $3xw6l.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $bbd098624269520c$export$c77b6d30da5276a1 = true;

});
parcelRegister("3xw6l", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $293d5acde922b5fe$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $293d5acde922b5fe$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $293d5acde922b5fe$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $293d5acde922b5fe$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $293d5acde922b5fe$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $293d5acde922b5fe$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $293d5acde922b5fe$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $293d5acde922b5fe$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $293d5acde922b5fe$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $293d5acde922b5fe$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $293d5acde922b5fe$export$3476b78f8f5a8b72);

var $b22x6 = parcelRequire("b22x6");
function $293d5acde922b5fe$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $293d5acde922b5fe$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $293d5acde922b5fe$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $293d5acde922b5fe$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $293d5acde922b5fe$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $293d5acde922b5fe$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $293d5acde922b5fe$var$retIndex(0, pos);
        if (pos == this.size) return $293d5acde922b5fe$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $293d5acde922b5fe$var$retIndex(i + 1, end);
                return $293d5acde922b5fe$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $293d5acde922b5fe$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (nodes instanceof $293d5acde922b5fe$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $293d5acde922b5fe$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $293d5acde922b5fe$export$ffb0004e005737fa.empty = new $293d5acde922b5fe$export$ffb0004e005737fa([], 0);
const $293d5acde922b5fe$var$found = {
    index: 0,
    offset: 0
};
function $293d5acde922b5fe$var$retIndex(index, offset) {
    $293d5acde922b5fe$var$found.index = index;
    $293d5acde922b5fe$var$found.offset = offset;
    return $293d5acde922b5fe$var$found;
}
function $293d5acde922b5fe$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$293d5acde922b5fe$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$293d5acde922b5fe$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $293d5acde922b5fe$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $293d5acde922b5fe$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        if (marks instanceof $293d5acde922b5fe$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $293d5acde922b5fe$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $293d5acde922b5fe$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $293d5acde922b5fe$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $293d5acde922b5fe$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty = new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.empty, 0, 0);
function $293d5acde922b5fe$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($293d5acde922b5fe$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $293d5acde922b5fe$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $293d5acde922b5fe$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $293d5acde922b5fe$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inconsistent open depths");
    return $293d5acde922b5fe$var$replaceOuter($from, $to, slice, 0);
}
function $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $293d5acde922b5fe$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $293d5acde922b5fe$var$prepareSliceForReplace(slice, $from);
        return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $293d5acde922b5fe$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $293d5acde922b5fe$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $293d5acde922b5fe$var$checkJoin(node, $after.node(depth));
    return node;
}
function $293d5acde922b5fe$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $293d5acde922b5fe$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $293d5acde922b5fe$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$293d5acde922b5fe$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $293d5acde922b5fe$var$addNode($end.nodeBefore, target);
}
function $293d5acde922b5fe$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $293d5acde922b5fe$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $293d5acde922b5fe$var$joinable($end, $to, depth + 1);
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $293d5acde922b5fe$var$checkJoin(openStart, openEnd);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceTwoWay($from, $start, depth + 1)), content);
        $293d5acde922b5fe$var$addRange($start, $end, depth, content);
        if (openEnd) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openEnd, $293d5acde922b5fe$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $293d5acde922b5fe$var$joinable($from, $to, depth + 1);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(type, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $293d5acde922b5fe$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $293d5acde922b5fe$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $293d5acde922b5fe$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $293d5acde922b5fe$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $293d5acde922b5fe$var$resolveCache.set(doc, cache = new $293d5acde922b5fe$var$ResolveCache);
        let result = cache.elts[cache.i] = $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $293d5acde922b5fe$var$resolveCacheSize;
        return result;
    }
}
class $293d5acde922b5fe$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $293d5acde922b5fe$var$resolveCacheSize = 12, $293d5acde922b5fe$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $293d5acde922b5fe$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $293d5acde922b5fe$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $293d5acde922b5fe$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $293d5acde922b5fe$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $293d5acde922b5fe$var$emptyAttrs) && $293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $293d5acde922b5fe$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $293d5acde922b5fe$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $293d5acde922b5fe$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $293d5acde922b5fe$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$293d5acde922b5fe$export$85c928794f8d04d4.prototype.text = undefined;
class $293d5acde922b5fe$var$TextNode extends $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $293d5acde922b5fe$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $293d5acde922b5fe$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $293d5acde922b5fe$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $293d5acde922b5fe$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $293d5acde922b5fe$export$364ed450558d7ec4.empty;
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $293d5acde922b5fe$var$dfa($293d5acde922b5fe$var$nfa(expr));
        $293d5acde922b5fe$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $293d5acde922b5fe$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $293d5acde922b5fe$export$364ed450558d7ec4.empty = new $293d5acde922b5fe$export$364ed450558d7ec4(true);
class $293d5acde922b5fe$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $293d5acde922b5fe$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSubscript(stream) {
    let expr = $293d5acde922b5fe$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $293d5acde922b5fe$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $293d5acde922b5fe$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $293d5acde922b5fe$var$parseExprRange(stream, expr) {
    let min = $293d5acde922b5fe$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $293d5acde922b5fe$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $293d5acde922b5fe$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $293d5acde922b5fe$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $293d5acde922b5fe$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $293d5acde922b5fe$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $293d5acde922b5fe$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $293d5acde922b5fe$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($293d5acde922b5fe$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $293d5acde922b5fe$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($293d5acde922b5fe$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $293d5acde922b5fe$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $293d5acde922b5fe$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($293d5acde922b5fe$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $293d5acde922b5fe$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $293d5acde922b5fe$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $293d5acde922b5fe$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $293d5acde922b5fe$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $293d5acde922b5fe$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $293d5acde922b5fe$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $293d5acde922b5fe$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $293d5acde922b5fe$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $293d5acde922b5fe$export$ffb0004e005737fa.from(content), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, attrs, content.append(after), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $293d5acde922b5fe$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $293d5acde922b5fe$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $293d5acde922b5fe$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $293d5acde922b5fe$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $293d5acde922b5fe$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $b22x6.default).from(spec.nodes), instanceSpec.marks = (0, $b22x6.default).from(spec.marks || {}), this.nodes = $293d5acde922b5fe$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $293d5acde922b5fe$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $293d5acde922b5fe$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $293d5acde922b5fe$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $293d5acde922b5fe$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $293d5acde922b5fe$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $293d5acde922b5fe$var$TextNode(type, type.defaultAttrs, text, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $293d5acde922b5fe$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $293d5acde922b5fe$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $293d5acde922b5fe$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $293d5acde922b5fe$var$isTagRule(rule) {
    return rule.tag != null;
}
function $293d5acde922b5fe$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $293d5acde922b5fe$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($293d5acde922b5fe$var$isTagRule(rule)) this.tags.push(rule);
            else if ($293d5acde922b5fe$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, false);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, true);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($293d5acde922b5fe$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $293d5acde922b5fe$export$1059c6e7d2ce5669(schema, $293d5acde922b5fe$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $293d5acde922b5fe$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $293d5acde922b5fe$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $293d5acde922b5fe$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $293d5acde922b5fe$var$OPT_PRESERVE_WS = 1, $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL = 2, $293d5acde922b5fe$var$OPT_OPEN_LEFT = 4;
function $293d5acde922b5fe$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $293d5acde922b5fe$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS | $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : base & ~$293d5acde922b5fe$var$OPT_OPEN_LEFT;
}
class $293d5acde922b5fe$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $293d5acde922b5fe$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$293d5acde922b5fe$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $293d5acde922b5fe$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $293d5acde922b5fe$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $293d5acde922b5fe$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $293d5acde922b5fe$var$NodeContext(topNode.type, topNode.attrs, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $293d5acde922b5fe$var$NodeContext(null, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $293d5acde922b5fe$var$NodeContext(parser.schema.topNodeType, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($293d5acde922b5fe$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $293d5acde922b5fe$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $293d5acde922b5fe$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($293d5acde922b5fe$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $293d5acde922b5fe$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $293d5acde922b5fe$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $293d5acde922b5fe$var$OPT_OPEN_LEFT;
        let applyMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $293d5acde922b5fe$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $293d5acde922b5fe$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $293d5acde922b5fe$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $293d5acde922b5fe$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $293d5acde922b5fe$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $293d5acde922b5fe$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $293d5acde922b5fe$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $293d5acde922b5fe$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $293d5acde922b5fe$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $293d5acde922b5fe$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $293d5acde922b5fe$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $293d5acde922b5fe$var$gatherToDOM(schema.marks);
    }
}
function $293d5acde922b5fe$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $293d5acde922b5fe$var$doc(options) {
    return options.document || window.document;
}
const $293d5acde922b5fe$var$suspiciousAttributeCache = new WeakMap();
function $293d5acde922b5fe$var$suspiciousAttributes(attrs) {
    let value = $293d5acde922b5fe$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $293d5acde922b5fe$var$suspiciousAttributeCache.set(attrs, value = $293d5acde922b5fe$var$suspiciousAttributesInner(attrs));
    return value;
}
function $293d5acde922b5fe$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $293d5acde922b5fe$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $293d5acde922b5fe$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("b22x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8081d8961ff8b83a$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $8081d8961ff8b83a$var$OrderedMap(content) {
    this.content = content;
}
$8081d8961ff8b83a$var$OrderedMap.prototype = {
    constructor: $8081d8961ff8b83a$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $8081d8961ff8b83a$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$8081d8961ff8b83a$var$OrderedMap.from = function(value) {
    if (value instanceof $8081d8961ff8b83a$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $8081d8961ff8b83a$var$OrderedMap(content);
};
var $8081d8961ff8b83a$export$2e2bcd8739ae039 = $8081d8961ff8b83a$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $212f88bb056bb83b$export$4498a6080fed604c = 'fontStyle';
const $212f88bb056bb83b$export$f8e8a5f34f6ea725 = 'searchQuery';
const $212f88bb056bb83b$export$b395009ca7f092c7 = 'link';
const $212f88bb056bb83b$export$9b982809044276a6 = 'color';
const $212f88bb056bb83b$export$470d0905851e47a1 = 'alignment';
const $212f88bb056bb83b$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("mYA6R", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $04510c65475a01e5$export$daf54fed04c8fb77);
function $04510c65475a01e5$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $04510c65475a01e5$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $04510c65475a01e5$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$04510c65475a01e5$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$04510c65475a01e5$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $04510c65475a01e5$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $04510c65475a01e5$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("fRfD8", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $b8b7ee14906d8946$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $b8b7ee14906d8946$export$8e53000a4ec837);

var $dpWhK = parcelRequire("dpWhK");
const $b8b7ee14906d8946$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $b8b7ee14906d8946$export$8e53000a4ec837 = (0, $dpWhK.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("dpWhK", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $9c4ad26098e14d16$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $9c4ad26098e14d16$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $9c4ad26098e14d16$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $9c4ad26098e14d16$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $9c4ad26098e14d16$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $9c4ad26098e14d16$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $9c4ad26098e14d16$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $9c4ad26098e14d16$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $9c4ad26098e14d16$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $9c4ad26098e14d16$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $9c4ad26098e14d16$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $9c4ad26098e14d16$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $9c4ad26098e14d16$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $9c4ad26098e14d16$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $9c4ad26098e14d16$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $9c4ad26098e14d16$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $9c4ad26098e14d16$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $9c4ad26098e14d16$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $9c4ad26098e14d16$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $9c4ad26098e14d16$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $1zhCF = parcelRequire("1zhCF");
const $9c4ad26098e14d16$export$8e53000a4ec837 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $9c4ad26098e14d16$export$8512c9afa7b24c3b = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $9c4ad26098e14d16$export$8c5a050822fd698c = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $9c4ad26098e14d16$export$1edee58a52776cd9 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $9c4ad26098e14d16$export$89015c65f1c75e3f = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $9c4ad26098e14d16$export$6565f9f03506010b = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $9c4ad26098e14d16$export$f3b72f8fc4684ecd = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $9c4ad26098e14d16$export$3024f02c495408d6 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $9c4ad26098e14d16$export$c63c6f932822f543 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$f00aeb236b6f05af = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $9c4ad26098e14d16$export$480c699bd4ec0d86 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $9c4ad26098e14d16$export$9c30223ca0a664fb = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $9c4ad26098e14d16$export$4899a95d70ec5056 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$59ae2c325a998f89 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$b3401ee80eb31041 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$32f78bffcd82ff28 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $9c4ad26098e14d16$export$20af3dabbb5538df = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $9c4ad26098e14d16$export$425327af25286e5e = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$30d78d5eb6719bb8 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $9c4ad26098e14d16$export$a316dc07ff5182a2 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("jxPcD", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $e3a8d12fb24e7751$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $e3a8d12fb24e7751$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $e3a8d12fb24e7751$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $e3a8d12fb24e7751$export$8512c9afa7b24c3b);

var $dpWhK = parcelRequire("dpWhK");
let $e3a8d12fb24e7751$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $e3a8d12fb24e7751$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $e3a8d12fb24e7751$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $e3a8d12fb24e7751$export$8512c9afa7b24c3b = (0, $dpWhK.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$e3a8d12fb24e7751$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("7i9jz", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $54f1708b23d22a73$export$8c5a050822fd698c);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $abZsg = parcelRequire("abZsg");

var $4PpDP = parcelRequire("4PpDP");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
const $54f1708b23d22a73$var$colorArrayPalette = [
    [
        (0, $51dYk.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51dYk.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51dYk.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51dYk.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51dYk.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51dYk.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $54f1708b23d22a73$var$colorArrayPaletteNext = [
    [
        (0, $51dYk.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51dYk.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51dYk.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51dYk.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $51dYk.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51dYk.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51dYk.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $54f1708b23d22a73$export$14ec3f21a268e497 = new Map();
$54f1708b23d22a73$var$colorArrayPalette.forEach(([color, label])=>$54f1708b23d22a73$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $54f1708b23d22a73$export$7ab6fa38cecaeee2 = new Map();
$54f1708b23d22a73$var$colorArrayPaletteNext.forEach(([color, label])=>$54f1708b23d22a73$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label));
const $54f1708b23d22a73$export$8c5a050822fd698c = (0, $dpWhK.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51dYk.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $54f1708b23d22a73$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $54f1708b23d22a73$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dyyJM.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $abZsg.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("abZsg", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $76ba9a217de88ec9$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $76ba9a217de88ec9$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $76ba9a217de88ec9$export$32f78bffcd82ff28);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $4PpDP = parcelRequire("4PpDP");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $76ba9a217de88ec9$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51dYk.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51dYk.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51dYk.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51dYk.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51dYk.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51dYk.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51dYk.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51dYk.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51dYk.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51dYk.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51dYk.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51dYk.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51dYk.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51dYk.N0),
        'White'
    ],
    [
        (0, $51dYk.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51dYk.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51dYk.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51dYk.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51dYk.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51dYk.P50),
        'Light purple'
    ] // Lavender secret
];
const $76ba9a217de88ec9$export$569885e57444f84a = new Map();
const $76ba9a217de88ec9$export$81e5ed9e84fe2e28 = $76ba9a217de88ec9$export$569885e57444f84a;
$76ba9a217de88ec9$var$colorArrayPalette.forEach(([color, label])=>$76ba9a217de88ec9$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $76ba9a217de88ec9$var$testGlobalTheme;
const $76ba9a217de88ec9$export$fd7e0dd2b74807f7 = (theme)=>{
    $76ba9a217de88ec9$var$testGlobalTheme = theme;
};
const $76ba9a217de88ec9$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($76ba9a217de88ec9$var$testGlobalTheme) return {
        colorMode: $76ba9a217de88ec9$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $76ba9a217de88ec9$export$32f78bffcd82ff28 = (0, $dpWhK.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51dYk.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $76ba9a217de88ec9$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $76ba9a217de88ec9$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dyyJM.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($76ba9a217de88ec9$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("3Pxk9", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $2c9ffbf60e7d1542$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $2c9ffbf60e7d1542$export$1edee58a52776cd9);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $2c9ffbf60e7d1542$var$borderColorArrayPalette = [
    [
        (0, $51dYk.N300A),
        'Subtle gray'
    ],
    [
        (0, $51dYk.N600),
        'Gray'
    ],
    [
        (0, $51dYk.N1000),
        'Bold gray'
    ]
];
const $2c9ffbf60e7d1542$export$e4e044c989c86ca7 = new Map();
$2c9ffbf60e7d1542$var$borderColorArrayPalette.forEach(([color, label])=>$2c9ffbf60e7d1542$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $2c9ffbf60e7d1542$export$1edee58a52776cd9 = (0, $dpWhK.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $2c9ffbf60e7d1542$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $dyyJM.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("7uhRT", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $573931fdaecc07f5$export$89015c65f1c75e3f);

var $dpWhK = parcelRequire("dpWhK");
const $573931fdaecc07f5$var$allowedTypes = [
    'wide',
    'full-width'
];
const $573931fdaecc07f5$export$89015c65f1c75e3f = (0, $dpWhK.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $573931fdaecc07f5$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("eA6GD", function(module, exports) {

$parcel$export(module.exports, "code", () => $a9d99d50afe8568a$export$6565f9f03506010b);

var $dpWhK = parcelRequire("dpWhK");
const $a9d99d50afe8568a$export$6565f9f03506010b = (0, $dpWhK.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("04SjV", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $00ea82b899b17721$export$f3b72f8fc4684ecd);

var $dpWhK = parcelRequire("dpWhK");
const $00ea82b899b17721$export$f3b72f8fc4684ecd = (0, $dpWhK.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("dHJym", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $9fa2a06e539a28ed$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $9fa2a06e539a28ed$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $j783N = parcelRequire("j783N");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $9fa2a06e539a28ed$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $j783N.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $9fa2a06e539a28ed$export$3024f02c495408d6 = (0, $dpWhK.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$9fa2a06e539a28ed$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $9fa2a06e539a28ed$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("j783N", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $dea4ec58c68501e8$export$c296e2d4365c37a5);
const $dea4ec58c68501e8$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("eonww", function(module, exports) {

$parcel$export(module.exports, "em", () => $a7a58ddd4fa9ccdc$export$c63c6f932822f543);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name em_mark
 */ const $a7a58ddd4fa9ccdc$var$emDOM = [
    'em'
];
const $a7a58ddd4fa9ccdc$export$c63c6f932822f543 = (0, $dpWhK.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $a7a58ddd4fa9ccdc$var$emDOM;
    }
});

});

parcelRegister("6Ymtk", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $5139c72ca03c3689$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $5139c72ca03c3689$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $j783N = parcelRequire("j783N");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $5139c72ca03c3689$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $j783N.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $5139c72ca03c3689$export$f00aeb236b6f05af = (0, $dpWhK.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$5139c72ca03c3689$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $5139c72ca03c3689$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("7GG3N", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $598d14eba71ad958$export$480c699bd4ec0d86);

var $dpWhK = parcelRequire("dpWhK");
const $598d14eba71ad958$export$480c699bd4ec0d86 = (0, $dpWhK.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("h9kgv", function(module, exports) {

$parcel$export(module.exports, "link", () => $c7c2ff29c44bed75$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $c7c2ff29c44bed75$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $iKozC = parcelRequire("iKozC");
const $c7c2ff29c44bed75$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iKozC.isSafeUrl)(href)) return false;
        if ((0, $iKozC.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iKozC.normalizeUrl)(href);
        return attrs;
    };
const $c7c2ff29c44bed75$export$9c30223ca0a664fb = (0, $dpWhK.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $c7c2ff29c44bed75$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $c7c2ff29c44bed75$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iKozC.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $c7c2ff29c44bed75$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $c7c2ff29c44bed75$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($c7c2ff29c44bed75$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iKozC", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $da5f95a938306985$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $da5f95a938306985$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $da5f95a938306985$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $da5f95a938306985$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $da5f95a938306985$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $da5f95a938306985$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $agOHY = parcelRequire("agOHY");
const $da5f95a938306985$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $da5f95a938306985$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $da5f95a938306985$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $da5f95a938306985$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($agOHY)))();
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $da5f95a938306985$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('tel:', $da5f95a938306985$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('file:', $da5f95a938306985$var$urlWithoutSpacesValidator);
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $da5f95a938306985$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $da5f95a938306985$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$da5f95a938306985$var$tlds.push($da5f95a938306985$var$tlds2Char);
$da5f95a938306985$export$8ccbde94d5c7f8e7.tlds($da5f95a938306985$var$tlds, false);
const $da5f95a938306985$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $da5f95a938306985$export$6f7d7761b97f967 = (text)=>{
    if (!$da5f95a938306985$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($da5f95a938306985$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($da5f95a938306985$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $da5f95a938306985$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $da5f95a938306985$export$6f7d7761b97f967(str);
    if (!match.length) match = $da5f95a938306985$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $da5f95a938306985$export$6535eb414fa2c8b6(url) {
    const match = $da5f95a938306985$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $da5f95a938306985$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("agOHY", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $77a2bb99974301ae$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $77a2bb99974301ae$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $77a2bb99974301ae$var$isString(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object String]';
}
function $77a2bb99974301ae$var$isObject(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object Object]';
}
function $77a2bb99974301ae$var$isRegExp(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object RegExp]';
}
function $77a2bb99974301ae$var$isFunction(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object Function]';
}
function $77a2bb99974301ae$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $77a2bb99974301ae$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $77a2bb99974301ae$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $77a2bb99974301ae$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $77a2bb99974301ae$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $77a2bb99974301ae$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $77a2bb99974301ae$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $77a2bb99974301ae$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $77a2bb99974301ae$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $77a2bb99974301ae$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $77a2bb99974301ae$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("dZNb9"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($77a2bb99974301ae$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($77a2bb99974301ae$var$isObject(val)) {
            if ($77a2bb99974301ae$var$isRegExp(val.validate)) compiled.validate = $77a2bb99974301ae$var$createValidator(val.validate);
            else if ($77a2bb99974301ae$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($77a2bb99974301ae$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $77a2bb99974301ae$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($77a2bb99974301ae$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $77a2bb99974301ae$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($77a2bb99974301ae$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $77a2bb99974301ae$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $77a2bb99974301ae$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $77a2bb99974301ae$var$createMatch(self, shift) {
    var match = new $77a2bb99974301ae$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $77a2bb99974301ae$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $77a2bb99974301ae$var$LinkifyIt)) return new $77a2bb99974301ae$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($77a2bb99974301ae$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $77a2bb99974301ae$var$assign({}, $77a2bb99974301ae$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $77a2bb99974301ae$var$assign({}, $77a2bb99974301ae$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $77a2bb99974301ae$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $77a2bb99974301ae$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $77a2bb99974301ae$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $77a2bb99974301ae$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($77a2bb99974301ae$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($77a2bb99974301ae$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $77a2bb99974301ae$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $77a2bb99974301ae$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $77a2bb99974301ae$var$LinkifyIt;

});
parcelRegister("dZNb9", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("hZcCd")).source;
    re.src_Cc = (parcelRequire("iNnZB")).source;
    re.src_Z = (parcelRequire("23KJ1")).source;
    re.src_P = (parcelRequire("dDBFM")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("hZcCd", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("iNnZB", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("23KJ1", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("dDBFM", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("f4V9T", function(module, exports) {

$parcel$export(module.exports, "strike", () => $afa39141d5f07f7e$export$4899a95d70ec5056);

var $dpWhK = parcelRequire("dpWhK");
const $afa39141d5f07f7e$export$4899a95d70ec5056 = (0, $dpWhK.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("YKDO7", function(module, exports) {

$parcel$export(module.exports, "strong", () => $0b69c8a71c20472c$export$59ae2c325a998f89);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name strong_mark
 */ const $0b69c8a71c20472c$var$strongDOM = [
    'strong'
];
const $0b69c8a71c20472c$export$59ae2c325a998f89 = (0, $dpWhK.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $0b69c8a71c20472c$var$strongDOM;
    }
});

});

parcelRegister("hI6rl", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $ce4b8a96280c3122$export$b3401ee80eb31041);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name subsup_mark
 */ function $ce4b8a96280c3122$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $ce4b8a96280c3122$export$b3401ee80eb31041 = (0, $dpWhK.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$ce4b8a96280c3122$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$ce4b8a96280c3122$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("anaPs", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $78d473cb65f0df79$export$20af3dabbb5538df);

var $dpWhK = parcelRequire("dpWhK");

var $51dYk = parcelRequire("51dYk");
const $78d473cb65f0df79$export$20af3dabbb5538df = (0, $dpWhK.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51dYk.B400)}`
            }
        ];
    }
});

});

parcelRegister("b7o0x", function(module, exports) {

$parcel$export(module.exports, "underline", () => $8182f89abb2f8453$export$425327af25286e5e);

var $dpWhK = parcelRequire("dpWhK");
const $8182f89abb2f8453$export$425327af25286e5e = (0, $dpWhK.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("kdb0W", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $eb6d90b5414d615f$export$30d78d5eb6719bb8);

var $dpWhK = parcelRequire("dpWhK");
const $eb6d90b5414d615f$export$30d78d5eb6719bb8 = (0, $dpWhK.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("3pgGD", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $27b0a68621bb260d$export$a316dc07ff5182a2);

var $dpWhK = parcelRequire("dpWhK");
const $27b0a68621bb260d$export$a316dc07ff5182a2 = (0, $dpWhK.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("5sqgz", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $3f93f1394abd8f36$export$c4c2f833baaebdb8);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name blockCard_node
 */ const $3f93f1394abd8f36$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $3f93f1394abd8f36$export$c4c2f833baaebdb8 = (0, $nJVLW.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("kuVVV", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $eec38c5829cd5cfe$export$27903d543b563e39);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $eec38c5829cd5cfe$export$27903d543b563e39 = (0, $nJVLW.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7T1su", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $5bdecd1b7c926ffc$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $5bdecd1b7c926ffc$export$a140c94e5ea26bee);

var $nJVLW = parcelRequire("nJVLW");
const $5bdecd1b7c926ffc$export$5f25a39efab3b58b = '.ak-ul';
const $5bdecd1b7c926ffc$export$a140c94e5ea26bee = (0, $nJVLW.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $5bdecd1b7c926ffc$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("l2o3P", function(module, exports) {

$parcel$export(module.exports, "caption", () => $f50c72db8a29084b$export$8e3c2dfdc4f0453d);

var $nJVLW = parcelRequire("nJVLW");
const $f50c72db8a29084b$export$8e3c2dfdc4f0453d = (0, $nJVLW.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("02BNy", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $007d81fc2959166a$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $007d81fc2959166a$export$54fd2c36b5cc6731);

var $3xw6l = parcelRequire("3xw6l");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $007d81fc2959166a$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $007d81fc2959166a$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $007d81fc2959166a$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $007d81fc2959166a$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $007d81fc2959166a$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $007d81fc2959166a$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $007d81fc2959166a$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $007d81fc2959166a$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $007d81fc2959166a$export$7bb0d5c671655cc4 = (0, $nJVLW.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $007d81fc2959166a$var$getLanguageFromBitbucketStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromEditorStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $007d81fc2959166a$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $007d81fc2959166a$var$parseCodeFromHtml(domNode);
                return code ? (0, $3xw6l.Fragment).from(schema.text(code)) : (0, $3xw6l.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $007d81fc2959166a$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("itOTx", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $d7426a112a1f91a3$export$daf889beb5092f95);

var $nJVLW = parcelRequire("nJVLW");
const $d7426a112a1f91a3$var$name = 'confluenceJiraIssue';
const $d7426a112a1f91a3$export$daf889beb5092f95 = (0, $nJVLW.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$d7426a112a1f91a3$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $d7426a112a1f91a3$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("99RFR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $01b87e4e18733712$export$e6e4878f43c27cab);

var $nJVLW = parcelRequire("nJVLW");
const $01b87e4e18733712$var$name = 'confluenceUnsupportedBlock';
const $01b87e4e18733712$export$e6e4878f43c27cab = (0, $nJVLW.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $01b87e4e18733712$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01b87e4e18733712$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("4LGm1", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $378c67d877621958$export$3e6d667072febc87);

var $nJVLW = parcelRequire("nJVLW");
const $378c67d877621958$var$name = 'confluenceUnsupportedInline';
const $378c67d877621958$export$3e6d667072febc87 = (0, $nJVLW.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $378c67d877621958$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$378c67d877621958$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("s7CHM", function(module, exports) {

$parcel$export(module.exports, "date", () => $0548877699ee10bf$export$324d90190a8b822a);

var $nJVLW = parcelRequire("nJVLW");
const $0548877699ee10bf$export$324d90190a8b822a = (0, $nJVLW.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("eblOZ", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $a533050aace96451$export$6959e16eeff859b4);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $a533050aace96451$export$6959e16eeff859b4 = (0, $nJVLW.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2OrIX.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("9FkNK", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $70981417a2cd0f7b$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $70981417a2cd0f7b$export$62d45a65fb43d95e);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name decisionList_node
 */ const $70981417a2cd0f7b$var$name = 'decisionList';
const $70981417a2cd0f7b$export$a5393ce68c2ff601 = `[data-node-type="${$70981417a2cd0f7b$var$name}"]`;
const $70981417a2cd0f7b$export$62d45a65fb43d95e = (0, $nJVLW.decisionList)({
    parseDOM: [
        {
            tag: `ol${$70981417a2cd0f7b$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $70981417a2cd0f7b$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gjQyF", function(module, exports) {

$parcel$export(module.exports, "doc", () => $be1730a7caadbb4e$export$2a111da947c407d2);

var $nJVLW = parcelRequire("nJVLW");
const $be1730a7caadbb4e$export$2a111da947c407d2 = (0, $nJVLW.doc)({});

});

parcelRegister("YIci7", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $0b67e35d143af9e6$export$be4283d9a1cb1ff6);

var $nJVLW = parcelRequire("nJVLW");
const $0b67e35d143af9e6$export$be4283d9a1cb1ff6 = (0, $nJVLW.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("foHUC", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $b35b28eecd7e0f91$export$a19185d1233fc4b2);

var $4Dhy7 = parcelRequire("4Dhy7");

var $nJVLW = parcelRequire("nJVLW");
const $b35b28eecd7e0f91$export$a19185d1233fc4b2 = (0, $nJVLW.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4Dhy7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4Dhy7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4Dhy7", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $35f86add2efe8d16$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $35f86add2efe8d16$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $35f86add2efe8d16$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $35f86add2efe8d16$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $35f86add2efe8d16$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $35f86add2efe8d16$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $35f86add2efe8d16$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $35f86add2efe8d16$export$f61e93bda2a8b420(acName) {
    const emojiData = $35f86add2efe8d16$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $35f86add2efe8d16$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $35f86add2efe8d16$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$35f86add2efe8d16$var$acNameToEmojiMap[acName] ? $35f86add2efe8d16$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($35f86add2efe8d16$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $35f86add2efe8d16$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$35f86add2efe8d16$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $35f86add2efe8d16$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $35f86add2efe8d16$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($35f86add2efe8d16$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $35f86add2efe8d16$var$getAcNameFromShortName(shortName);
        if (possibleName in $35f86add2efe8d16$var$acNameToEmojiMap) return possibleName;
    }
    return $35f86add2efe8d16$export$bc94e44ec0e7bd82(id) || $35f86add2efe8d16$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("iBSvH", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $d8c5f74ef3d86bcc$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $d8c5f74ef3d86bcc$export$70a64939da3e8455);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name blockquote_node
 */ const $d8c5f74ef3d86bcc$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $d8c5f74ef3d86bcc$export$67dc04e652a298ca = (0, $nJVLW.blockquoteLegacy)($d8c5f74ef3d86bcc$var$nodeSpecOptions);
const $d8c5f74ef3d86bcc$export$70a64939da3e8455 = (0, $nJVLW.blockquote)($d8c5f74ef3d86bcc$var$nodeSpecOptions);

});

parcelRegister("ePdnq", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $acb0347d33162113$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $acb0347d33162113$export$ce20b13564211141);

var $nJVLW = parcelRequire("nJVLW");
let $acb0347d33162113$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $acb0347d33162113$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $acb0347d33162113$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $acb0347d33162113$export$969277cf61e5a7aa.CUSTOM ? $acb0347d33162113$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $acb0347d33162113$var$createPanelNodeSpecOptions = (allowCustomPanel)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$acb0347d33162113$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $acb0347d33162113$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $acb0347d33162113$export$ce20b13564211141 = (allowCustomPanel)=>(0, $nJVLW.panel)($acb0347d33162113$var$createPanelNodeSpecOptions(allowCustomPanel));

});

parcelRegister("6r1B4", function(module, exports) {

$parcel$export(module.exports, "extension", () => $01358634d8baf68a$export$1b45514b112dd749);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $01358634d8baf68a$export$1b45514b112dd749 = (0, $nJVLW.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("ewUmv", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $a93fc62957e42117$export$371da9dd35aba193);

var $nJVLW = parcelRequire("nJVLW");
const $a93fc62957e42117$export$371da9dd35aba193 = (0, $nJVLW.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("8FGKL", function(module, exports) {

$parcel$export(module.exports, "heading", () => $650350f97a125578$export$46e4a324ac90507f);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $650350f97a125578$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $650350f97a125578$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $650350f97a125578$export$46e4a324ac90507f = (0, $nJVLW.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $650350f97a125578$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $650350f97a125578$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $650350f97a125578$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $650350f97a125578$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $650350f97a125578$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $650350f97a125578$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("lM0g9", function(module, exports) {

$parcel$export(module.exports, "image", () => $fd9e48320ef47dab$export$5c452ff88e35e47d);

var $nJVLW = parcelRequire("nJVLW");
const $fd9e48320ef47dab$export$5c452ff88e35e47d = (0, $nJVLW.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("3MHOZ", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $2c17d8cd4306fb03$export$cbf8224b64e0d942);

var $nJVLW = parcelRequire("nJVLW");
const $2c17d8cd4306fb03$export$cbf8224b64e0d942 = (0, $nJVLW.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5Ufvu", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $44ce3609d5dda29d$export$16b353b2649bd8d9);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $44ce3609d5dda29d$export$16b353b2649bd8d9 = (0, $nJVLW.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("gNk91", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $c3a0d938bf65ffc4$export$ab76e7c03cd6f650);

var $nJVLW = parcelRequire("nJVLW");
const $c3a0d938bf65ffc4$export$ab76e7c03cd6f650 = (0, $nJVLW.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("bTlUc", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $8a85d2bbd938d1a8$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $8a85d2bbd938d1a8$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $8a85d2bbd938d1a8$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $8a85d2bbd938d1a8$export$54fd2c36b5cc6731);

var $51dYk = parcelRequire("51dYk");

var $nJVLW = parcelRequire("nJVLW");
const $8a85d2bbd938d1a8$export$bb3fe706be61f640 = (0, $nJVLW.media)({}).attrs;
const $8a85d2bbd938d1a8$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $8a85d2bbd938d1a8$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51dYk.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $8a85d2bbd938d1a8$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$8a85d2bbd938d1a8$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $nJVLW.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $nJVLW.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $8a85d2bbd938d1a8$export$987d49ffe1b0900f = $8a85d2bbd938d1a8$export$35bdbf5bc8caa677($8a85d2bbd938d1a8$export$bb3fe706be61f640, false);
const $8a85d2bbd938d1a8$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $8a85d2bbd938d1a8$export$111130fa8968d741 = (from, to, map)=>{
    if ($8a85d2bbd938d1a8$export$987d49ffe1b0900f.attrs) Object.keys($8a85d2bbd938d1a8$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $8a85d2bbd938d1a8$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $8a85d2bbd938d1a8$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $8a85d2bbd938d1a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $8a85d2bbd938d1a8$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($8a85d2bbd938d1a8$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("goVGV", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $bf0ba381e6b14c0b$export$2855e964765eac9);

var $nJVLW = parcelRequire("nJVLW");
const $bf0ba381e6b14c0b$export$2855e964765eac9 = (0, $nJVLW.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("5RVMs", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $445eb905c73a8551$export$38bab695e3f720f1);

var $bTlUc = parcelRequire("bTlUc");

var $nJVLW = parcelRequire("nJVLW");
const $445eb905c73a8551$export$38bab695e3f720f1 = (0, $bTlUc.createMediaSpec)((0, $nJVLW.mediaInline)({}).attrs, true);

});

parcelRegister("8Mfla", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $663eb4b9329f7335$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $663eb4b9329f7335$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $663eb4b9329f7335$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $663eb4b9329f7335$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $663eb4b9329f7335$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $663eb4b9329f7335$export$54fd2c36b5cc6731);

var $QD9UD = parcelRequire("QD9UD");

var $j783N = parcelRequire("j783N");

var $nJVLW = parcelRequire("nJVLW");
const $663eb4b9329f7335$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $663eb4b9329f7335$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $j783N.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $QD9UD.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $QD9UD.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $nJVLW.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $nJVLW.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $nJVLW.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $nJVLW.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $663eb4b9329f7335$export$969fe3781ca15058 = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $663eb4b9329f7335$export$d35e6c006d4abdfb = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $663eb4b9329f7335$export$9c58e19811ce4cf5 = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $663eb4b9329f7335$export$7e767666f2ce108a = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $663eb4b9329f7335$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("QD9UD", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $09e33b94b508f894$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $09e33b94b508f894$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("7axvl", function(module, exports) {

$parcel$export(module.exports, "mention", () => $538374e55dff7f13$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $538374e55dff7f13$export$54fd2c36b5cc6731);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
let $538374e55dff7f13$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $538374e55dff7f13$export$db83999c14438df4 = (0, $nJVLW.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $538374e55dff7f13$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $538374e55dff7f13$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $538374e55dff7f13$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $2OrIX.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($538374e55dff7f13$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $538374e55dff7f13$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $538374e55dff7f13$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($538374e55dff7f13$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("6UEeD", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $50872edefbef1f48$export$63cadbf5f4296627);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $50872edefbef1f48$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $50872edefbef1f48$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $50872edefbef1f48$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $50872edefbef1f48$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $50872edefbef1f48$export$63cadbf5f4296627 = (0, $nJVLW.nestedExpand)($50872edefbef1f48$var$nestedExpandFactoryOptions);

});

parcelRegister("a4ifE", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $75486f772c8c4cf6$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $75486f772c8c4cf6$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $75486f772c8c4cf6$export$b9ab759e8298198f);

var $nJVLW = parcelRequire("nJVLW");
const $75486f772c8c4cf6$export$4e7125c7ff595be5 = '.ak-ol';
const $75486f772c8c4cf6$export$a5dc81035676e7a = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $75486f772c8c4cf6$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $75486f772c8c4cf6$export$b9ab759e8298198f = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $75486f772c8c4cf6$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $75486f772c8c4cf6$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bK3tx", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $88c6afc1badc0455$export$9c206ddddb32a9b);

var $nJVLW = parcelRequire("nJVLW");
const $88c6afc1badc0455$export$9c206ddddb32a9b = (0, $nJVLW.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $88c6afc1badc0455$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("hbObi", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $c83a63aa944f66a1$export$c7187bbd1a7a9244);

var $nJVLW = parcelRequire("nJVLW");
const $c83a63aa944f66a1$export$c7187bbd1a7a9244 = (0, $nJVLW.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $c83a63aa944f66a1$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("jC4KP", function(module, exports) {

$parcel$export(module.exports, "rule", () => $e475410b583b636d$export$fbeb3a3956e8a3c7);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name rule_node
 */ const $e475410b583b636d$var$hrDOM = [
    'hr'
];
const $e475410b583b636d$export$fbeb3a3956e8a3c7 = (0, $nJVLW.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $e475410b583b636d$var$hrDOM;
    }
});

});

parcelRegister("c2Gqu", function(module, exports) {

$parcel$export(module.exports, "status", () => $8c4694e34f16e8bc$export$471f7ae5c4103ae1);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $8c4694e34f16e8bc$export$471f7ae5c4103ae1 = (0, $nJVLW.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $2OrIX.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("5iuEY", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $3db66a9f0ad7bab5$export$6d8b0ef52e2e6390);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $3db66a9f0ad7bab5$export$6d8b0ef52e2e6390 = (0, $nJVLW.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2OrIX.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6Yq90", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $014f6df118f8d370$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $014f6df118f8d370$export$375b6afcc5f4d291);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name taskList_node
 */ const $014f6df118f8d370$var$name = 'actionList';
const $014f6df118f8d370$export$c0ec71adb7a18fb2 = `[data-node-type="${$014f6df118f8d370$var$name}"]`;
const $014f6df118f8d370$export$375b6afcc5f4d291 = (0, $nJVLW.taskList)({
    parseDOM: [
        {
            tag: `div${$014f6df118f8d370$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $014f6df118f8d370$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("53i5t", function(module, exports) {

$parcel$export(module.exports, "text", () => $3adb434dc421ab11$export$6f093cfa640b7166);

var $nJVLW = parcelRequire("nJVLW");
const $3adb434dc421ab11$export$6f093cfa640b7166 = (0, $nJVLW.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("bffKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82fd5027b66be343$export$2e2bcd8739ae039);
const $82fd5027b66be343$var$name = 'unknownBlock';
var $82fd5027b66be343$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $82fd5027b66be343$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$82fd5027b66be343$var$name}"]`
        }
    ]
};

});

parcelRegister("e1kFZ", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $a3513293b95ecc1d$export$44b79b0979d0f0f7);

var $nJVLW = parcelRequire("nJVLW");
const $a3513293b95ecc1d$export$44b79b0979d0f0f7 = (0, $nJVLW.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("5blh0", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $3c5e7b4352f31e0d$export$310ebe0d80122e9b);

var $nJVLW = parcelRequire("nJVLW");
const $3c5e7b4352f31e0d$export$310ebe0d80122e9b = (0, $nJVLW.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("fjfmN", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $7a1052b2a1567e8a$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8DB98 = parcelRequire("8DB98");

var $djAo6 = parcelRequire("djAo6");
var $jF4Mi = parcelRequire("jF4Mi");

var $bMFKb = parcelRequire("bMFKb");

var $3mTkR = parcelRequire("3mTkR");
var $3Ussg = parcelRequire("3Ussg");

var $cRsRn = parcelRequire("cRsRn");

var $eGOwo = parcelRequire("eGOwo");

var $LFmXM = parcelRequire("LFmXM");

var $7ueoK = parcelRequire("7ueoK");

var $lE3K0 = parcelRequire("lE3K0");

var $86V7W = parcelRequire("86V7W");
const $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $7a1052b2a1567e8a$var$withStopwatch = (cb)=>{
    const startTime = $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $7a1052b2a1567e8a$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $djAo6.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $3Ussg.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $cRsRn.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jF4Mi.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer',
            disableNestedRendererTreatment: (0, $eGOwo.fg)('platform_editor_nested_table_extension_comment_fix')
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $bMFKb.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $7a1052b2a1567e8a$var$memoValidation = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_validation, (newArgs, lastArgs)=>{
    let result = false;
    if ((0, $eGOwo.fg)('cc_complexit_fe_memovalidation_redundant_calls_2')) {
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        newSkipValidation, newValidationOverrides] = newArgs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    } else {
        // This path has a bug and it will wrongfully assign dispatchAnalyticsEvent to skipValidation/oldSkipValidation
        // instead of ignoring it as it does not skip it when unpacking the array.
        // This results the function returning false when it should return true
        // and causing extra re-renders. see https://hello.jira.atlassian.cloud/browse/COMPLEXIT-161.
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , skipValidation, newValidationOverrides] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    }
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a1052b2a1567e8a$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $7a1052b2a1567e8a$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $7a1052b2a1567e8a$var$memoSerializeFragment = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc);
});
const $7a1052b2a1567e8a$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $7a1052b2a1567e8a$var$memoCreateNodeAndCheck = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc);
});
const $7a1052b2a1567e8a$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $8DB98.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $3mTkR.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $lE3K0.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $86V7W.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("djAo6", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $b2a4642f722aa8d8$export$6528700f3fa2fe2a);

var $0mclG = parcelRequire("0mclG");
const $b2a4642f722aa8d8$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("0mclG", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $9495d7eb76b80944$export$df3f009e3d155b20);
function $9495d7eb76b80944$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $9495d7eb76b80944$export$df3f009e3d155b20(adf, visitors) {
    if (!$9495d7eb76b80944$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $9495d7eb76b80944$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $9495d7eb76b80944$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $9495d7eb76b80944$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("jF4Mi", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $7043dab3dcfeb1cc$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $7043dab3dcfeb1cc$export$8a334a7d9fe120ec);

var $0mclG = parcelRequire("0mclG");

var $8zW2f = parcelRequire("8zW2f");

var $lmGkG = parcelRequire("lmGkG");
const $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $7043dab3dcfeb1cc$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY;
const $7043dab3dcfeb1cc$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $lmGkG.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $7043dab3dcfeb1cc$export$18544d0b5f43e4a1 = (adf, // TODO: EDITOR-806 - Remove options when cleaning feature gate platform_editor_nested_table_extension_comment_fix as no longer needed
options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        extension: (node, parent)=>{
            if ($7043dab3dcfeb1cc$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $7043dab3dcfeb1cc$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $7043dab3dcfeb1cc$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $8zW2f.extension)({
                    extensionType: $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $lmGkG.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("8zW2f", function(module, exports) {

$parcel$export(module.exports, "extension", () => $5a200accbce47c41$export$1b45514b112dd749);
const $5a200accbce47c41$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("lmGkG", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $e75bb52268bda547$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $e75bb52268bda547$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("bMFKb", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $17b833dfd922470c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $17b833dfd922470c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $17b833dfd922470c$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $17b833dfd922470c$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $17b833dfd922470c$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $17b833dfd922470c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $17b833dfd922470c$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $17b833dfd922470c$export$9f0b2adf3cfd71b7);
var $17b833dfd922470c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $17b833dfd922470c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $17b833dfd922470c$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $17b833dfd922470c$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $17b833dfd922470c$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $17b833dfd922470c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $17b833dfd922470c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $17b833dfd922470c$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $17b833dfd922470c$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("3mTkR", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $66b6d13af08c068e$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $66b6d13af08c068e$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $66b6d13af08c068e$export$3a34598135e7219b);

var $bMFKb = parcelRequire("bMFKb");
const $66b6d13af08c068e$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $66b6d13af08c068e$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $66b6d13af08c068e$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $66b6d13af08c068e$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $66b6d13af08c068e$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$66b6d13af08c068e$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $66b6d13af08c068e$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $bMFKb.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $66b6d13af08c068e$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$66b6d13af08c068e$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $66b6d13af08c068e$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $66b6d13af08c068e$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $66b6d13af08c068e$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $66b6d13af08c068e$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $66b6d13af08c068e$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $66b6d13af08c068e$var$trackUnsupportedContentTooltipActionFor((0, $bMFKb.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("3Ussg", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $263400656bb608dd$export$884cfad20dece33e);

var $2MkAG = parcelRequire("2MkAG");

var $bMFKb = parcelRequire("bMFKb");

var $3mTkR = parcelRequire("3mTkR");
const $263400656bb608dd$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $263400656bb608dd$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $263400656bb608dd$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $263400656bb608dd$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $263400656bb608dd$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $263400656bb608dd$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $263400656bb608dd$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $263400656bb608dd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $263400656bb608dd$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $263400656bb608dd$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $263400656bb608dd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $263400656bb608dd$export$87b732fa69cdf16e(child) : validate(child, $263400656bb608dd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $263400656bb608dd$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $263400656bb608dd$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $3mTkR.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $263400656bb608dd$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $2MkAG.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $263400656bb608dd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $263400656bb608dd$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("2MkAG", function(module, exports) {

$parcel$export(module.exports, "validator", () => $96effbef339de82e$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $l7cdi = parcelRequire("l7cdi");

var $kfOTy = parcelRequire("kfOTy");

var $eZqxv = parcelRequire("eZqxv");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96effbef339de82e$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $96effbef339de82e$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $96effbef339de82e$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($l7cdi).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$l7cdi[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $kfOTy.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $l7cdi[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $kfOTy.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($l7cdi[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $l7cdi[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($l7cdi[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $l7cdi[subItem] : (0, $kfOTy.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $96effbef339de82e$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96effbef339de82e$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $96effbef339de82e$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $96effbef339de82e$export$66c739158ef99a42(spec, value) {
    if (!(0, $kfOTy.isDefined)(value)) return !!spec.optional;
    if ($96effbef339de82e$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $96effbef339de82e$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $96effbef339de82e$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $kfOTy.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $kfOTy.isBoolean)(value);
        case 'number':
            return (0, $kfOTy.isNumber)(value) && ((0, $kfOTy.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $kfOTy.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $kfOTy.isInteger)(value) && ((0, $kfOTy.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $kfOTy.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $kfOTy.isDefined)((0, $eZqxv.validatorFnMap)[rule]) && (0, $eZqxv.validatorFnMap)[rule](value);
            return (0, $kfOTy.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $kfOTy.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $kfOTy.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $kfOTy.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$96effbef339de82e$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$96effbef339de82e$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $kfOTy.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $96effbef339de82e$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $96effbef339de82e$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $96effbef339de82e$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $96effbef339de82e$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $96effbef339de82e$var$getUnsupportedOptions(parentSpec));
};
const $96effbef339de82e$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $96effbef339de82e$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $96effbef339de82e$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $96effbef339de82e$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $96effbef339de82e$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $96effbef339de82e$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $96effbef339de82e$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $96effbef339de82e$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $96effbef339de82e$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $kfOTy.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $kfOTy.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$96effbef339de82e$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $kfOTy.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $kfOTy.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $kfOTy.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $96effbef339de82e$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $96effbef339de82e$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $96effbef339de82e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $96effbef339de82e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $96effbef339de82e$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $96effbef339de82e$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $96effbef339de82e$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $96effbef339de82e$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $kfOTy.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $kfOTy.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $96effbef339de82e$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $kfOTy.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $96effbef339de82e$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $kfOTy.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $kfOTy.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $96effbef339de82e$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $96effbef339de82e$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("l7cdi", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("aio1x")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("aio1x")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("aio1x")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("aio1x")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("aio1x")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("aio1x")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aio1x")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("aio1x")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("aio1x")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("aio1x")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("aio1x")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("aio1x")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("aio1x")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("aio1x")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("aio1x")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("aio1x")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("aio1x")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("aio1x")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("aio1x")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("aio1x")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("aio1x")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("aio1x")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("aio1x")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("aio1x")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("aio1x")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("aio1x")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("aio1x")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("aio1x")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("aio1x")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("aio1x")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("aio1x")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("aio1x")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("aio1x")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("aio1x")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("aio1x")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("aio1x")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("aio1x")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("aio1x")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("aio1x")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("aio1x")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("aio1x")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("aio1x")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("aio1x")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("aio1x")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("aio1x")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("aio1x")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("aio1x")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("aio1x")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("aio1x")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("aio1x")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("aio1x")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("aio1x")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("aio1x")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("aio1x")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("aio1x")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("aio1x")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("aio1x")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("aio1x")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("aio1x")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("aio1x")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("aio1x")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("aio1x")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("aio1x")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("aio1x")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("aio1x")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("aio1x")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("aio1x")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("aio1x")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("aio1x")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("aio1x")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("aio1x")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("aio1x")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("aio1x")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("aio1x")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("aio1x")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("aio1x")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("aio1x")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("aio1x")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("aio1x")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("aio1x")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("aio1x")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("aio1x")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("aio1x")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("aio1x")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aio1x = parcelRequire("aio1x");

});
parcelRegister("aio1x", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $77ee386e3e14f4e0$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $77ee386e3e14f4e0$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $77ee386e3e14f4e0$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $77ee386e3e14f4e0$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $77ee386e3e14f4e0$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $77ee386e3e14f4e0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $77ee386e3e14f4e0$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $77ee386e3e14f4e0$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $77ee386e3e14f4e0$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $77ee386e3e14f4e0$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $77ee386e3e14f4e0$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $77ee386e3e14f4e0$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $77ee386e3e14f4e0$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $77ee386e3e14f4e0$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $77ee386e3e14f4e0$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $77ee386e3e14f4e0$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $77ee386e3e14f4e0$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $77ee386e3e14f4e0$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $77ee386e3e14f4e0$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $77ee386e3e14f4e0$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $77ee386e3e14f4e0$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $77ee386e3e14f4e0$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $77ee386e3e14f4e0$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $77ee386e3e14f4e0$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $77ee386e3e14f4e0$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $77ee386e3e14f4e0$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $77ee386e3e14f4e0$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $77ee386e3e14f4e0$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $77ee386e3e14f4e0$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $77ee386e3e14f4e0$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $77ee386e3e14f4e0$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $77ee386e3e14f4e0$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $77ee386e3e14f4e0$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $77ee386e3e14f4e0$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $77ee386e3e14f4e0$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $77ee386e3e14f4e0$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $77ee386e3e14f4e0$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $77ee386e3e14f4e0$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $77ee386e3e14f4e0$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $77ee386e3e14f4e0$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $77ee386e3e14f4e0$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $77ee386e3e14f4e0$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $77ee386e3e14f4e0$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $77ee386e3e14f4e0$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $77ee386e3e14f4e0$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $77ee386e3e14f4e0$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $77ee386e3e14f4e0$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $77ee386e3e14f4e0$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $77ee386e3e14f4e0$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $77ee386e3e14f4e0$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $77ee386e3e14f4e0$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $77ee386e3e14f4e0$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $77ee386e3e14f4e0$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $77ee386e3e14f4e0$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $77ee386e3e14f4e0$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $77ee386e3e14f4e0$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $77ee386e3e14f4e0$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $77ee386e3e14f4e0$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $77ee386e3e14f4e0$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $77ee386e3e14f4e0$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $77ee386e3e14f4e0$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $77ee386e3e14f4e0$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $77ee386e3e14f4e0$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $77ee386e3e14f4e0$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $77ee386e3e14f4e0$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $77ee386e3e14f4e0$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $77ee386e3e14f4e0$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $77ee386e3e14f4e0$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $77ee386e3e14f4e0$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $77ee386e3e14f4e0$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $77ee386e3e14f4e0$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $77ee386e3e14f4e0$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $77ee386e3e14f4e0$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $77ee386e3e14f4e0$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $77ee386e3e14f4e0$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $77ee386e3e14f4e0$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $77ee386e3e14f4e0$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $77ee386e3e14f4e0$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $77ee386e3e14f4e0$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $77ee386e3e14f4e0$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $77ee386e3e14f4e0$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $77ee386e3e14f4e0$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $77ee386e3e14f4e0$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $77ee386e3e14f4e0$export$425327af25286e5e);
const $77ee386e3e14f4e0$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $77ee386e3e14f4e0$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $77ee386e3e14f4e0$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $77ee386e3e14f4e0$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $77ee386e3e14f4e0$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $77ee386e3e14f4e0$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $77ee386e3e14f4e0$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $77ee386e3e14f4e0$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("kfOTy", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $e5985938f1ee69ed$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $e5985938f1ee69ed$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $e5985938f1ee69ed$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $e5985938f1ee69ed$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $e5985938f1ee69ed$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $e5985938f1ee69ed$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $e5985938f1ee69ed$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $e5985938f1ee69ed$export$7b85fd78dd236198);
const $e5985938f1ee69ed$export$4e62c701997796c1 = (x)=>x != null;
const $e5985938f1ee69ed$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $e5985938f1ee69ed$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $e5985938f1ee69ed$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $e5985938f1ee69ed$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $e5985938f1ee69ed$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $e5985938f1ee69ed$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $e5985938f1ee69ed$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("eZqxv", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $804f031b1e946960$export$d1b377ca77ac267d);

var $iKozC = parcelRequire("iKozC");
const $804f031b1e946960$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iKozC.isSafeUrl)
};

});



parcelRegister("cRsRn", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $0190d1906f5ad323$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $0190d1906f5ad323$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $0190d1906f5ad323$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $0190d1906f5ad323$export$81b20b6c83a56bd);

var $2OrIX = parcelRequire("2OrIX");
var $fAF2Y = parcelRequire("fAF2Y");
var $iKozC = parcelRequire("iKozC");
var $ePdnq = parcelRequire("ePdnq");

var $8DB98 = parcelRequire("8DB98");

var $eGOwo = parcelRequire("eGOwo");
const $0190d1906f5ad323$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $0190d1906f5ad323$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $0190d1906f5ad323$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $0190d1906f5ad323$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$0190d1906f5ad323$export$62d5811a2955c1d8.indexOf(a.type.name) - $0190d1906f5ad323$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $0190d1906f5ad323$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $0190d1906f5ad323$export$fb80336a7e408cb3 = (doc, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const node = $0190d1906f5ad323$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $0190d1906f5ad323$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $0190d1906f5ad323$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $fAF2Y.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $0190d1906f5ad323$export$fafd4f799ee68da0 = (content, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$0190d1906f5ad323$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$ANCHOR_LINK = /^#/;
const $0190d1906f5ad323$var$flattenUnknownBlockTree = (node, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($0190d1906f5ad323$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$0190d1906f5ad323$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $0190d1906f5ad323$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iKozC.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $0190d1906f5ad323$var$flattenUnknownBlockTree(node)
    };
};
const $0190d1906f5ad323$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $0190d1906f5ad323$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $0190d1906f5ad323$export$81b20b6c83a56bd = (originalNode, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $0190d1906f5ad323$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $0190d1906f5ad323$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $0190d1906f5ad323$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $0190d1906f5ad323$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $0190d1906f5ad323$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $0190d1906f5ad323$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $ePdnq.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $2OrIX.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $0190d1906f5ad323$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
};
const $0190d1906f5ad323$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$0190d1906f5ad323$var$RELATIVE_LINK.test(linkHref) && !$0190d1906f5ad323$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iKozC.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($0190d1906f5ad323$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $0190d1906f5ad323$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $0190d1906f5ad323$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("fAF2Y", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $b59a0ee18888e473$export$b1f729c6af6f2a6e);

var $jd35j = parcelRequire("jd35j");
const $b59a0ee18888e473$var$typedNodes = $jd35j;
const $b59a0ee18888e473$export$b1f729c6af6f2a6e = new Set(Object.keys($b59a0ee18888e473$var$typedNodes).filter((key)=>$b59a0ee18888e473$var$typedNodes[key] && $b59a0ee18888e473$var$typedNodes[key].group === 'inline'));

});
parcelRegister("jd35j", function(module, exports) {

$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("eSKW9")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("eSKW9")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("itOTx")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("99RFR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("4LGm1")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("gjQyF")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("iBSvH")).blockquote);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("iBSvH")).extendedBlockquote);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("7T1su")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("7T1su")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("02BNy")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("02BNy")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("ewUmv")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("8FGKL")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("jC4KP")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("a4ifE")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("a4ifE")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("a4ifE")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("bK3tx")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("foHUC")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("lM0g9")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("7axvl")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("7axvl")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("gkLMH")).listItem);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("gkLMH")).listItemWithDecisionStage0);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("ePdnq")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("ePdnq")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("53i5t")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("bffKB")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("l2o3P")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("bTlUc")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("bTlUc")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("bTlUc")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("goVGV")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5RVMs")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("8Mfla")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("8Mfla")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("8Mfla")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("8Mfla")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("8Mfla")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("8Mfla")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("e6HpD")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("e6HpD")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("e6HpD")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("e6HpD")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("e6HpD")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("e6HpD")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("e6HpD")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("e6HpD")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("e6HpD")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("e6HpD")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("e6HpD")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("e6HpD")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("e6HpD")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("e6HpD")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("e6HpD")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("e6HpD")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("e6HpD")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("e6HpD")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("e6HpD")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("e6HpD")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("e6HpD")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("e6HpD")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("e6HpD")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("9FkNK")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("9FkNK")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("eblOZ")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("6Yq90")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("6Yq90")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5iuEY")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("s7CHM")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("hbObi")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jSvxD")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jSvxD")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("gNk91")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("3MHOZ")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5sqgz")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("e1kFZ")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("5blh0")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("c2Gqu")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("6UEeD")).nestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("YIci7")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("6r1B4")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5Ufvu")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("kuVVV")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("6C9Qx")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("6C9Qx")).multiBodiedExtension);

var $eSKW9 = parcelRequire("eSKW9");

var $itOTx = parcelRequire("itOTx");

var $99RFR = parcelRequire("99RFR");

var $4LGm1 = parcelRequire("4LGm1");

var $gjQyF = parcelRequire("gjQyF");

var $iBSvH = parcelRequire("iBSvH");

var $7T1su = parcelRequire("7T1su");

var $02BNy = parcelRequire("02BNy");

var $ewUmv = parcelRequire("ewUmv");

var $8FGKL = parcelRequire("8FGKL");

var $jC4KP = parcelRequire("jC4KP");

var $a4ifE = parcelRequire("a4ifE");

var $bK3tx = parcelRequire("bK3tx");

var $foHUC = parcelRequire("foHUC");

var $lM0g9 = parcelRequire("lM0g9");

var $7axvl = parcelRequire("7axvl");

var $gkLMH = parcelRequire("gkLMH");

var $ePdnq = parcelRequire("ePdnq");

var $53i5t = parcelRequire("53i5t");

var $bffKB = parcelRequire("bffKB");

var $l2o3P = parcelRequire("l2o3P");

var $bTlUc = parcelRequire("bTlUc");

var $goVGV = parcelRequire("goVGV");

var $5RVMs = parcelRequire("5RVMs");

var $8Mfla = parcelRequire("8Mfla");

var $e6HpD = parcelRequire("e6HpD");

var $9FkNK = parcelRequire("9FkNK");

var $eblOZ = parcelRequire("eblOZ");

var $6Yq90 = parcelRequire("6Yq90");

var $5iuEY = parcelRequire("5iuEY");

var $s7CHM = parcelRequire("s7CHM");

var $hbObi = parcelRequire("hbObi");

var $jSvxD = parcelRequire("jSvxD");

var $gNk91 = parcelRequire("gNk91");

var $3MHOZ = parcelRequire("3MHOZ");

var $5sqgz = parcelRequire("5sqgz");

var $e1kFZ = parcelRequire("e1kFZ");

var $5blh0 = parcelRequire("5blh0");

var $c2Gqu = parcelRequire("c2Gqu");

var $6UEeD = parcelRequire("6UEeD");

var $YIci7 = parcelRequire("YIci7");

var $6r1B4 = parcelRequire("6r1B4");

var $5Ufvu = parcelRequire("5Ufvu");

var $kuVVV = parcelRequire("kuVVV");

var $6C9Qx = parcelRequire("6C9Qx");

});



parcelRegister("7ueoK", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $0b4fec753ef144f9$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $0b4fec753ef144f9$export$e48589d9e4824227);
var $0b4fec753ef144f9$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $0b4fec753ef144f9$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $0b4fec753ef144f9$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($0b4fec753ef144f9$var$RESOLVE_METHOD || {});

});

parcelRegister("lE3K0", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $16664e34104af16b$export$a43de96edd8d0a0);

var $dyNYh = parcelRequire("dyNYh");
var $33XK0 = parcelRequire("33XK0");

var $bMFKb = parcelRequire("bMFKb");

var $7ueoK = parcelRequire("7ueoK");
const $16664e34104af16b$var$rendersMap = {};
const $16664e34104af16b$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $33XK0.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $dyNYh.getAnalyticsAppearance)(item.appearance),
                platform: (0, $7ueoK.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $16664e34104af16b$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $16664e34104af16b$var$DEFAULT_SAMPLING_RATE = 100;
const $16664e34104af16b$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$16664e34104af16b$var$rendersMap[appearance]) $16664e34104af16b$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $16664e34104af16b$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $16664e34104af16b$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $16664e34104af16b$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($16664e34104af16b$var$rendersMap[appearance].size === 1) $16664e34104af16b$var$schedule(()=>$16664e34104af16b$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($16664e34104af16b$var$rendersMap[appearance].size % sampleRate === 0) $16664e34104af16b$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("dyNYh", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $6098e217e78ad5fc$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $6098e217e78ad5fc$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $6098e217e78ad5fc$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $6098e217e78ad5fc$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $6098e217e78ad5fc$export$288273ee3e3b6132);

var $457Jo = parcelRequire("457Jo");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");
const $6098e217e78ad5fc$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $6098e217e78ad5fc$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$6098e217e78ad5fc$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $6098e217e78ad5fc$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $6098e217e78ad5fc$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $3lIcL.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $cwzAY.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $BmspC.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $6098e217e78ad5fc$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $6098e217e78ad5fc$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("3lIcL", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $27059f7464a1d1f5$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $27059f7464a1d1f5$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $27059f7464a1d1f5$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $27059f7464a1d1f5$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $27059f7464a1d1f5$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $27059f7464a1d1f5$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $27059f7464a1d1f5$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $27059f7464a1d1f5$export$1692d8b0e89cecc3);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $27059f7464a1d1f5$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $27059f7464a1d1f5$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $3xw6l.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
            if (i == 0) $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $27059f7464a1d1f5$export$c2b25f346d19bcbb($pos) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, 0, 0, 1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $27059f7464a1d1f5$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $27059f7464a1d1f5$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $27059f7464a1d1f5$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $27059f7464a1d1f5$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $27059f7464a1d1f5$var$warnedAboutTextSelection = false;
function $27059f7464a1d1f5$var$checkTextSelection($pos) {
    if (!$27059f7464a1d1f5$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $27059f7464a1d1f5$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $27059f7464a1d1f5$export$c2b25f346d19bcbb extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $27059f7464a1d1f5$var$checkTextSelection($anchor);
        $27059f7464a1d1f5$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $27059f7464a1d1f5$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $3xw6l.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $27059f7464a1d1f5$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("text", $27059f7464a1d1f5$export$c2b25f346d19bcbb);
class $27059f7464a1d1f5$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $27059f7464a1d1f5$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $27059f7464a1d1f5$export$e2940151ac854c0b extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
        return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$27059f7464a1d1f5$export$e2940151ac854c0b.prototype.visible = false;
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("node", $27059f7464a1d1f5$export$e2940151ac854c0b);
class $27059f7464a1d1f5$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $27059f7464a1d1f5$var$TextBookmark(pos, pos) : new $27059f7464a1d1f5$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(node)) return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
        return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $27059f7464a1d1f5$export$c15d9ba76bdbcd95 extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        if (content == (0, $3xw6l.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $27059f7464a1d1f5$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $27059f7464a1d1f5$var$AllBookmark;
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("all", $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
const $27059f7464a1d1f5$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $27059f7464a1d1f5$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $27059f7464a1d1f5$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $27059f7464a1d1f5$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(child)) return $27059f7464a1d1f5$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $27059f7464a1d1f5$var$UPDATED_SEL = 1, $27059f7464a1d1f5$var$UPDATED_MARKS = 2, $27059f7464a1d1f5$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $27059f7464a1d1f5$export$febc5573c75cefb0 extends (0, $lzEKq.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $27059f7464a1d1f5$var$UPDATED_SEL) & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $27059f7464a1d1f5$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $3xw6l.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $3xw6l.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $27059f7464a1d1f5$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SCROLL) > 0;
    }
}
function $27059f7464a1d1f5$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $27059f7464a1d1f5$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $27059f7464a1d1f5$var$bind(desc.init, self);
        this.apply = $27059f7464a1d1f5$var$bind(desc.apply, self);
    }
}
const $27059f7464a1d1f5$var$baseFields = [
    new $27059f7464a1d1f5$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $27059f7464a1d1f5$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $27059f7464a1d1f5$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $27059f7464a1d1f5$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $27059f7464a1d1f5$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $27059f7464a1d1f5$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $27059f7464a1d1f5$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $27059f7464a1d1f5$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $27059f7464a1d1f5$var$Configuration(config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $3xw6l.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $27059f7464a1d1f5$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $27059f7464a1d1f5$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $27059f7464a1d1f5$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $27059f7464a1d1f5$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $27059f7464a1d1f5$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $27059f7464a1d1f5$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $27059f7464a1d1f5$var$keys = Object.create(null);
function $27059f7464a1d1f5$var$createKey(name) {
    if (name in $27059f7464a1d1f5$var$keys) return name + "$" + ++$27059f7464a1d1f5$var$keys[name];
    $27059f7464a1d1f5$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $27059f7464a1d1f5$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $27059f7464a1d1f5$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("lzEKq", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $040d9edd1880ca83$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $040d9edd1880ca83$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $040d9edd1880ca83$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $040d9edd1880ca83$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $040d9edd1880ca83$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $040d9edd1880ca83$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $040d9edd1880ca83$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $040d9edd1880ca83$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $040d9edd1880ca83$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $040d9edd1880ca83$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $040d9edd1880ca83$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $040d9edd1880ca83$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $040d9edd1880ca83$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $040d9edd1880ca83$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $040d9edd1880ca83$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $040d9edd1880ca83$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $040d9edd1880ca83$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $040d9edd1880ca83$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $040d9edd1880ca83$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $040d9edd1880ca83$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $040d9edd1880ca83$export$563a914cafbdc389);

var $3xw6l = parcelRequire("3xw6l");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $040d9edd1880ca83$var$lower16 = 0xffff;
const $040d9edd1880ca83$var$factor16 = Math.pow(2, 16);
function $040d9edd1880ca83$var$makeRecover(index, offset) {
    return index + offset * $040d9edd1880ca83$var$factor16;
}
function $040d9edd1880ca83$var$recoverIndex(value) {
    return value & $040d9edd1880ca83$var$lower16;
}
function $040d9edd1880ca83$var$recoverOffset(value) {
    return (value - (value & $040d9edd1880ca83$var$lower16)) / $040d9edd1880ca83$var$factor16;
}
const $040d9edd1880ca83$var$DEL_BEFORE = 1, $040d9edd1880ca83$var$DEL_AFTER = 2, $040d9edd1880ca83$var$DEL_ACROSS = 4, $040d9edd1880ca83$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $040d9edd1880ca83$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_BEFORE | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_AFTER | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $040d9edd1880ca83$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $040d9edd1880ca83$export$c53d01c3ab9721b3.empty) return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $040d9edd1880ca83$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $040d9edd1880ca83$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $040d9edd1880ca83$var$DEL_AFTER : pos == end ? $040d9edd1880ca83$var$DEL_BEFORE : $040d9edd1880ca83$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $040d9edd1880ca83$var$DEL_SIDE;
                return new $040d9edd1880ca83$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $040d9edd1880ca83$export$c53d01c3ab9721b3.empty : new $040d9edd1880ca83$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $040d9edd1880ca83$export$c53d01c3ab9721b3.empty = new $040d9edd1880ca83$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $040d9edd1880ca83$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $040d9edd1880ca83$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $040d9edd1880ca83$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $040d9edd1880ca83$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $040d9edd1880ca83$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $040d9edd1880ca83$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $040d9edd1880ca83$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $3xw6l.ReplaceError)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $040d9edd1880ca83$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($040d9edd1880ca83$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $3xw6l.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $040d9edd1880ca83$export$d24ba56b0e3464a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addMark", $040d9edd1880ca83$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $040d9edd1880ca83$export$94150db1311f67a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeMark", $040d9edd1880ca83$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $040d9edd1880ca83$export$adefd16c402fee4e extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addNodeMark", $040d9edd1880ca83$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $040d9edd1880ca83$export$fdf7d1dc10724da2 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeNodeMark", $040d9edd1880ca83$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $040d9edd1880ca83$export$5c860b2e74034756 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $040d9edd1880ca83$var$contentBetween(doc, this.from, this.to)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $040d9edd1880ca83$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $040d9edd1880ca83$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $040d9edd1880ca83$export$5c860b2e74034756(json.from, json.to, (0, $3xw6l.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replace", $040d9edd1880ca83$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $040d9edd1880ca83$export$444ba800d6024a98 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($040d9edd1880ca83$var$contentBetween(doc, this.from, this.gapFrom) || $040d9edd1880ca83$var$contentBetween(doc, this.gapTo, this.to))) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $040d9edd1880ca83$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $040d9edd1880ca83$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $040d9edd1880ca83$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $3xw6l.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replaceAround", $040d9edd1880ca83$export$444ba800d6024a98);
function $040d9edd1880ca83$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $040d9edd1880ca83$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $040d9edd1880ca83$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $040d9edd1880ca83$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $040d9edd1880ca83$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $3xw6l.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $040d9edd1880ca83$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur, end, (0, $3xw6l.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $3xw6l.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $3xw6l.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $040d9edd1880ca83$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $040d9edd1880ca83$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$040d9edd1880ca83$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $040d9edd1880ca83$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $3xw6l.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $3xw6l.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $3xw6l.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $3xw6l.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $3xw6l.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $040d9edd1880ca83$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $040d9edd1880ca83$var$findWrappingOutside(range, nodeType);
    let inner = around && $040d9edd1880ca83$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($040d9edd1880ca83$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($040d9edd1880ca83$var$withAttrs));
}
function $040d9edd1880ca83$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $040d9edd1880ca83$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $040d9edd1880ca83$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $040d9edd1880ca83$var$wrap(tr, range, wrappers) {
    let content = (0, $3xw6l.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $3xw6l.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, start, end, new (0, $3xw6l.Slice)(content, 0, 0), wrappers.length, true));
}
function $040d9edd1880ca83$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $040d9edd1880ca83$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $040d9edd1880ca83$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $040d9edd1880ca83$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $040d9edd1880ca83$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $040d9edd1880ca83$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $040d9edd1880ca83$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $3xw6l.Fragment).empty, after = (0, $3xw6l.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $3xw6l.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $3xw6l.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(pos, pos, new (0, $3xw6l.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $040d9edd1880ca83$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $040d9edd1880ca83$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $040d9edd1880ca83$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $040d9edd1880ca83$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $040d9edd1880ca83$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $040d9edd1880ca83$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $040d9edd1880ca83$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $040d9edd1880ca83$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $3xw6l.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $040d9edd1880ca83$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $040d9edd1880ca83$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $040d9edd1880ca83$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $040d9edd1880ca83$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $3xw6l.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice);
    return new $040d9edd1880ca83$var$Fitter($from, $to, slice).fit();
}
function $040d9edd1880ca83$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $040d9edd1880ca83$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $3xw6l.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $3xw6l.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $3xw6l.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $040d9edd1880ca83$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $040d9edd1880ca83$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $040d9edd1880ca83$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $3xw6l.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $3xw6l.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($040d9edd1880ca83$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, frontierDepth, (0, $3xw6l.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$040d9edd1880ca83$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $040d9edd1880ca83$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $040d9edd1880ca83$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.depth, (0, $3xw6l.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $3xw6l.Fragment).empty, true);
        if (add.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $040d9edd1880ca83$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($040d9edd1880ca83$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $040d9edd1880ca83$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($040d9edd1880ca83$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $040d9edd1880ca83$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $040d9edd1880ca83$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $040d9edd1880ca83$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $040d9edd1880ca83$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$040d9edd1880ca83$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $040d9edd1880ca83$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $040d9edd1880ca83$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $040d9edd1880ca83$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $040d9edd1880ca83$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $040d9edd1880ca83$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $3xw6l.Slice)($040d9edd1880ca83$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $040d9edd1880ca83$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($040d9edd1880ca83$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return fragment;
}
function $040d9edd1880ca83$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $040d9edd1880ca83$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
}
function $040d9edd1880ca83$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $040d9edd1880ca83$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $040d9edd1880ca83$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $040d9edd1880ca83$export$626399c38172f669 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $040d9edd1880ca83$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("attr", $040d9edd1880ca83$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $040d9edd1880ca83$export$f50707b396300ac9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $040d9edd1880ca83$export$f50707b396300ac9(json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("docAttr", $040d9edd1880ca83$export$f50707b396300ac9);
/**
@internal
*/ let $040d9edd1880ca83$export$88cc3a1dfce48dd3 = class extends Error {
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.constructor = $040d9edd1880ca83$export$88cc3a1dfce48dd3;
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $040d9edd1880ca83$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $040d9edd1880ca83$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $040d9edd1880ca83$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $3xw6l.Slice).empty) {
        let step = $040d9edd1880ca83$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $3xw6l.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $040d9edd1880ca83$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $040d9edd1880ca83$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $040d9edd1880ca83$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $040d9edd1880ca83$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $040d9edd1880ca83$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $040d9edd1880ca83$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $040d9edd1880ca83$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $040d9edd1880ca83$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $040d9edd1880ca83$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $040d9edd1880ca83$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $040d9edd1880ca83$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $3xw6l.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $040d9edd1880ca83$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $040d9edd1880ca83$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $040d9edd1880ca83$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $040d9edd1880ca83$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("BmspC", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $0704e05c57d80c1d$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $0704e05c57d80c1d$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $0704e05c57d80c1d$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $0704e05c57d80c1d$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $0704e05c57d80c1d$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $0704e05c57d80c1d$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $0704e05c57d80c1d$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $0704e05c57d80c1d$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $0704e05c57d80c1d$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $0704e05c57d80c1d$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $0704e05c57d80c1d$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $0704e05c57d80c1d$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $0704e05c57d80c1d$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $0704e05c57d80c1d$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $0704e05c57d80c1d$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $0704e05c57d80c1d$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $0704e05c57d80c1d$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $0704e05c57d80c1d$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $0704e05c57d80c1d$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $0704e05c57d80c1d$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $0704e05c57d80c1d$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $0704e05c57d80c1d$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $0704e05c57d80c1d$export$2344b14b097df817);
// src/selection.ts

var $3lIcL = parcelRequire("3lIcL");

var $3xw6l = parcelRequire("3xw6l");
var $0704e05c57d80c1d$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $0704e05c57d80c1d$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $0704e05c57d80c1d$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $0704e05c57d80c1d$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $0704e05c57d80c1d$export$7d6e4e6663186878 = (tr)=>{
    if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $0704e05c57d80c1d$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $0704e05c57d80c1d$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $3xw6l.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $3xw6l.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $0704e05c57d80c1d$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $0704e05c57d80c1d$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $0704e05c57d80c1d$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $3xw6l.Node) && node.type && node.type.spec.selectable);
var $0704e05c57d80c1d$var$shouldSelectNode = (node)=>$0704e05c57d80c1d$var$isSelectableNode(node) && node.type.isLeaf;
var $0704e05c57d80c1d$var$setSelection = (node, pos, tr)=>{
    if ($0704e05c57d80c1d$var$shouldSelectNode(node)) return tr.setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve(pos)));
    return $0704e05c57d80c1d$export$1df6d14df6b0b758(pos)(tr);
};
var $0704e05c57d80c1d$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $0704e05c57d80c1d$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($0704e05c57d80c1d$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $0704e05c57d80c1d$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $0704e05c57d80c1d$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $0704e05c57d80c1d$var$setSelection(content, pos, tr);
            }
        }
        if ($0704e05c57d80c1d$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $0704e05c57d80c1d$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $0704e05c57d80c1d$var$cloneTr($0704e05c57d80c1d$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($0704e05c57d80c1d$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $0704e05c57d80c1d$var$cloneTr($0704e05c57d80c1d$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $0704e05c57d80c1d$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $0704e05c57d80c1d$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $0704e05c57d80c1d$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $0704e05c57d80c1d$var$cloneTr(tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $0704e05c57d80c1d$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $0704e05c57d80c1d$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $0704e05c57d80c1d$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $0704e05c57d80c1d$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $3lIcL.NodeSelection);
};
var $0704e05c57d80c1d$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $0704e05c57d80c1d$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $0704e05c57d80c1d$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($0704e05c57d80c1d$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $0704e05c57d80c1d$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $0704e05c57d80c1d$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $0704e05c57d80c1d$var$cloneTr(tr);
        }
        return tr;
    };
var $0704e05c57d80c1d$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $3xw6l.Fragment) ? content : (0, $3xw6l.Fragment).from(content));
};
var $0704e05c57d80c1d$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $0704e05c57d80c1d$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $0704e05c57d80c1d$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $3xw6l.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $3xw6l.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $0704e05c57d80c1d$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $0704e05c57d80c1d$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $0704e05c57d80c1d$export$fe09644e3bc6166b($from, predicate);
    };
var $0704e05c57d80c1d$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $0704e05c57d80c1d$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $0704e05c57d80c1d$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $0704e05c57d80c1d$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $0704e05c57d80c1d$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$0704e05c57d80c1d$export$dc159056ffdb4c76(predicate)(selection);
    };
var $0704e05c57d80c1d$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $0704e05c57d80c1d$export$dc159056ffdb4c76((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node))(selection);
    };
var $0704e05c57d80c1d$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $0704e05c57d80c1d$export$fe09644e3bc6166b($pos, (node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node));
};
var $0704e05c57d80c1d$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $0704e05c57d80c1d$export$178ecaf80f45fdb6((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node))(selection);
    };
var $0704e05c57d80c1d$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $0704e05c57d80c1d$export$8556d79fa8189214((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $0704e05c57d80c1d$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($0704e05c57d80c1d$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $0704e05c57d80c1d$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $3lIcL.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $0704e05c57d80c1d$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $0704e05c57d80c1d$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $0704e05c57d80c1d$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $0704e05c57d80c1d$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $0704e05c57d80c1d$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $0704e05c57d80c1d$export$ddc1620722e25671 = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $0704e05c57d80c1d$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $0704e05c57d80c1d$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $0704e05c57d80c1d$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $0704e05c57d80c1d$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $0704e05c57d80c1d$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$0704e05c57d80c1d$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("cwzAY", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $d2163c16df8aab18$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $9sdKa = parcelRequire("9sdKa");

var $2vA54 = parcelRequire("2vA54");

var $cSPHa = parcelRequire("cSPHa");

var $9K0SW = parcelRequire("9K0SW");

var $7VjxU = parcelRequire("7VjxU");

var $7lSnz = parcelRequire("7lSnz");
class $d2163c16df8aab18$export$831cc7e2a83afa94 extends (0, $3lIcL.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $7VjxU.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $cSPHa.pointsAtCell)($anchorCell) && (0, $cSPHa.pointsAtCell)($headCell) && (0, $7lSnz.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $d2163c16df8aab18$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $d2163c16df8aab18$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $d2163c16df8aab18$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $3lIcL.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $2vA54.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $9K0SW.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $9K0SW.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $3xw6l.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
        }
        const sel = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $2vA54.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $2vA54.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $d2163c16df8aab18$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $2vA54.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $d2163c16df8aab18$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $2vA54.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $d2163c16df8aab18$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $d2163c16df8aab18$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $d2163c16df8aab18$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $9sdKa.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $3lIcL.Selection).jsonID('cell', $d2163c16df8aab18$export$831cc7e2a83afa94);

});
parcelRegister("9sdKa", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $261b53ebec41e3a8$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $3lIcL = parcelRequire("3lIcL");

var $7lSnz = parcelRequire("7lSnz");
class $261b53ebec41e3a8$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $261b53ebec41e3a8$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $7lSnz.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $3lIcL.Selection).fromJSON(doc, data);
        }
        return (0, $3lIcL.Selection).near($headCell, 1);
    }
}

});
parcelRegister("7lSnz", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $03a54050b67a9b6d$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $03a54050b67a9b6d$export$debd62b44eb7e281);
function $03a54050b67a9b6d$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $03a54050b67a9b6d$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("2vA54", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $92f17257f5177c44$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $92f17257f5177c44$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $92f17257f5177c44$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $92f17257f5177c44$var$readFromCache, $92f17257f5177c44$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $92f17257f5177c44$var$readFromCache = (key)=>cache.get(key);
    $92f17257f5177c44$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $92f17257f5177c44$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $92f17257f5177c44$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $92f17257f5177c44$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $92f17257f5177c44$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $92f17257f5177c44$export$c60fae4049791eae = 140;
class $92f17257f5177c44$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $92f17257f5177c44$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $92f17257f5177c44$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $92f17257f5177c44$var$readFromCache(table) || $92f17257f5177c44$var$addToCache(table, $92f17257f5177c44$var$computeMap(table));
    }
}
// Compute a table map.
function $92f17257f5177c44$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $92f17257f5177c44$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $92f17257f5177c44$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($92f17257f5177c44$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $92f17257f5177c44$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $92f17257f5177c44$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $92f17257f5177c44$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $92f17257f5177c44$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $92f17257f5177c44$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("cSPHa", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $2dfed9e7e05b2316$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $2dfed9e7e05b2316$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $2dfed9e7e05b2316$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $2dfed9e7e05b2316$export$172699367bb25225);

var $2vA54 = parcelRequire("2vA54");
function $2dfed9e7e05b2316$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $2dfed9e7e05b2316$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $2dfed9e7e05b2316$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $2dfed9e7e05b2316$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $2vA54.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("9K0SW", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $786bf010e3609b18$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $786bf010e3609b18$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $786bf010e3609b18$export$147ee78a1321ac36);
function $786bf010e3609b18$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $786bf010e3609b18$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $786bf010e3609b18$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $786bf010e3609b18$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("7VjxU", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $c774abe147af6cb9$export$a60a444208fd5099);

var $3lIcL = parcelRequire("3lIcL");

var $2vA54 = parcelRequire("2vA54");
function $c774abe147af6cb9$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $2vA54.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $3lIcL.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("33XK0", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $5e806909aed268e6$export$484b83e0462998d);

var $0mclG = parcelRequire("0mclG");
var $5e806909aed268e6$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $5e806909aed268e6$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $5e806909aed268e6$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $5e806909aed268e6$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $5e806909aed268e6$export$f9f8a29778652c3e.BLOCKING
    };
};
const $5e806909aed268e6$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $0mclG.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $0mclG.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $5e806909aed268e6$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $5e806909aed268e6$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $5e806909aed268e6$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $5e806909aed268e6$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $5e806909aed268e6$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("86V7W", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $11211b02bfd44def$export$1daf15cbaf649dad);

var $7Tt7Y = parcelRequire("7Tt7Y");
function $11211b02bfd44def$export$1daf15cbaf649dad(adfDocument) {
    return (0, $7Tt7Y.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("7Tt7Y", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $a7e2059b80756531$export$533b26079ad0b4b);

var $0mclG = parcelRequire("0mclG");
function $a7e2059b80756531$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1LVxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $336b1a6c1be58861$export$2e2bcd8739ae039);

var $8DB98 = parcelRequire("8DB98");

var $aqskg = parcelRequire("aqskg");
class $336b1a6c1be58861$export$2e2bcd8739ae039 {
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $aqskg.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $8DB98.defaultSchema)) {
        return new $336b1a6c1be58861$export$2e2bcd8739ae039(schema);
    }
}

});
parcelRegister("aqskg", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $d8ee4d14254d50da$export$533b26079ad0b4b);

var $iOn6j = parcelRequire("iOn6j");

var $c4jiB = parcelRequire("c4jiB");

var $5u70q = parcelRequire("5u70q");

var $EiR1g = parcelRequire("EiR1g");

var $14Wro = parcelRequire("14Wro");

var $3Vvcc = parcelRequire("3Vvcc");

var $6IeNj = parcelRequire("6IeNj");

var $1wZsI = parcelRequire("1wZsI");

var $6ySZE = parcelRequire("6ySZE");

var $9x58g = parcelRequire("9x58g");

var $deM66 = parcelRequire("deM66");

var $dnx3d = parcelRequire("dnx3d");

var $dX58h = parcelRequire("dX58h");

var $g6zW9 = parcelRequire("g6zW9");

var $bOElj = parcelRequire("bOElj");

var $iI82H = parcelRequire("iI82H");

var $eknNa = parcelRequire("eknNa");

var $jFFK7 = parcelRequire("jFFK7");
const $d8ee4d14254d50da$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $d8ee4d14254d50da$var$nodeToReducerMapping[node.type.name] || $d8ee4d14254d50da$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $d8ee4d14254d50da$var$nodeToReducerMapping = {
    blockquote: $iOn6j.default,
    bulletList: $c4jiB.default,
    date: $5u70q.default,
    decisionItem: $EiR1g.default,
    hardBreak: $14Wro.default,
    heading: $3Vvcc.default,
    inlineCard: $6IeNj.default,
    listItem: $1wZsI.default,
    mediaGroup: $6ySZE.default,
    mention: $9x58g.default,
    orderedList: $deM66.default,
    panel: $dnx3d.default,
    paragraph: $dX58h.default,
    rule: $g6zW9.default,
    status: $bOElj.default,
    table: $iI82H.default,
    taskItem: $eknNa.default,
    unknown: $jFFK7.default
};

});
parcelRegister("iOn6j", function(module, exports) {

$parcel$export(module.exports, "default", () => $814291df79e48746$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $814291df79e48746$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $814291df79e48746$export$2e2bcd8739ae039 = $814291df79e48746$var$blockquote;

});

parcelRegister("c4jiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1dfcef05bc506d9$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $b1dfcef05bc506d9$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $aqskg.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $b1dfcef05bc506d9$export$2e2bcd8739ae039 = $b1dfcef05bc506d9$var$bulletList;

});

parcelRegister("5u70q", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ccb14051a2b76d$export$2e2bcd8739ae039);

var $dZ5Iy = parcelRequire("dZ5Iy");

var $g9wjI = parcelRequire("g9wjI");
const $19ccb14051a2b76d$var$date = (node, schema)=>{
    return node.attrs.timestamp ? (0, $dZ5Iy.timestampToIsoFormat)(node.attrs.timestamp) : (0, $g9wjI.getText)(node);
};
var $19ccb14051a2b76d$export$2e2bcd8739ae039 = $19ccb14051a2b76d$var$date;

});
parcelRegister("dZ5Iy", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $588f444e520afb69$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $588f444e520afb69$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $588f444e520afb69$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $588f444e520afb69$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $588f444e520afb69$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $588f444e520afb69$export$fbc04a9e57b04a80);

var $btz6U = parcelRequire("btz6U");

var $bf0oy = parcelRequire("bf0oy");
var $588f444e520afb69$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($588f444e520afb69$var$FORMATS || {});
const $588f444e520afb69$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $588f444e520afb69$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $588f444e520afb69$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $588f444e520afb69$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $588f444e520afb69$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $588f444e520afb69$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $588f444e520afb69$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$588f444e520afb69$var$addLeadingZero(date.getUTCMonth() + 1)}-${$588f444e520afb69$var$addLeadingZero(date.getUTCDate())}`;
};
const $588f444e520afb69$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $bf0oy.default)(new Date(Number(timestamp)), new Date(Number($588f444e520afb69$export$6297728405c48562())));
};
const $588f444e520afb69$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($588f444e520afb69$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $btz6U.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $588f444e520afb69$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $588f444e520afb69$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("g9wjI", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $cd37434dd3346d1d$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $cd37434dd3346d1d$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $cd37434dd3346d1d$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $cd37434dd3346d1d$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8DB98 = parcelRequire("8DB98");

var $lovmf = parcelRequire("lovmf");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cd37434dd3346d1d$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $cd37434dd3346d1d$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $8DB98.defaultSchema));
        this.encode = $cd37434dd3346d1d$var$createEncoder(transformer, new (0, $lovmf.JSONTransformer)());
    }
}
const $cd37434dd3346d1d$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $cd37434dd3346d1d$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $cd37434dd3346d1d$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $cd37434dd3346d1d$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("lovmf", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $452aa29341178512$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $452aa29341178512$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cSmYj = parcelRequire("cSmYj");

var $02BNy = parcelRequire("02BNy");
var $dHJym = parcelRequire("dHJym");
var $eSKW9 = parcelRequire("eSKW9");
var $6Ymtk = parcelRequire("6Ymtk");
var $h9kgv = parcelRequire("h9kgv");
var $8Mfla = parcelRequire("8Mfla");
var $bTlUc = parcelRequire("bTlUc");
var $7axvl = parcelRequire("7axvl");
var $e6HpD = parcelRequire("e6HpD");

var $8DB98 = parcelRequire("8DB98");

var $5RXjG = parcelRequire("5RXjG");

var $lGx2C = parcelRequire("lGx2C");
var $452aa29341178512$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $452aa29341178512$var$isType = (type)=>(node)=>node.type.name === type;
const $452aa29341178512$var$isCodeBlock = $452aa29341178512$var$isType('codeBlock');
const $452aa29341178512$var$isMediaNode = $452aa29341178512$var$isType('media');
const $452aa29341178512$var$isMediaInline = $452aa29341178512$var$isType('mediaInline');
const $452aa29341178512$var$isMediaSingleNode = $452aa29341178512$var$isType('mediaSingle');
const $452aa29341178512$var$isMentionNode = $452aa29341178512$var$isType('mention');
const $452aa29341178512$var$isParagraph = $452aa29341178512$var$isType('paragraph');
const $452aa29341178512$var$isHeading = $452aa29341178512$var$isType('heading');
const $452aa29341178512$var$isTable = $452aa29341178512$var$isType('table');
const $452aa29341178512$var$isTableCell = $452aa29341178512$var$isType('tableCell');
const $452aa29341178512$var$isTableHeader = $452aa29341178512$var$isType('tableHeader');
const $452aa29341178512$var$isLinkMark = $452aa29341178512$var$isType('link');
const $452aa29341178512$var$isUnsupportedMark = $452aa29341178512$var$isType('unsupportedMark');
const $452aa29341178512$var$isUnsupportedNodeAttributeMark = $452aa29341178512$var$isType('unsupportedNodeAttribute');
const $452aa29341178512$var$isExpand = $452aa29341178512$var$isType('expand');
const $452aa29341178512$var$isNestedExpand = $452aa29341178512$var$isType('nestedExpand');
const $452aa29341178512$var$isUnsupportedNode = (node)=>$452aa29341178512$var$isType('unsupportedBlock')(node) || $452aa29341178512$var$isType('unsupportedInline')(node);
const $452aa29341178512$var$isDataConsumer = $452aa29341178512$var$isType('dataConsumer');
const $452aa29341178512$var$isFragmentMark = $452aa29341178512$var$isType('fragment');
const $452aa29341178512$var$isHardBreak = $452aa29341178512$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $452aa29341178512$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $452aa29341178512$var$filterNull(current);
    }
    return output;
};
const $452aa29341178512$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $452aa29341178512$var$emptyDoc = $452aa29341178512$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $452aa29341178512$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($452aa29341178512$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($452aa29341178512$var$isMediaNode(node)) obj.attrs = (0, $bTlUc.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMediaSingleNode(node)) obj.attrs = (0, $8Mfla.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMediaInline(node)) obj.attrs = (0, $bTlUc.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMentionNode(node)) obj.attrs = (0, $7axvl.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isCodeBlock(node)) obj.attrs = (0, $02BNy.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isTable(node)) obj.attrs = (0, $e6HpD.tableToJSON)(node).attrs;
    else if ($452aa29341178512$var$isTableCell(node)) obj.attrs = (0, $e6HpD.toJSONTableCell)(node).attrs;
    else if ($452aa29341178512$var$isTableHeader(node)) obj.attrs = (0, $e6HpD.toJSONTableHeader)(node).attrs;
    else if ($452aa29341178512$var$isExpand(node) || $452aa29341178512$var$isNestedExpand(node)) obj.attrs = (0, $eSKW9.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $452aa29341178512$var$filterNull(obj.attrs);
    if ($452aa29341178512$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($452aa29341178512$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($452aa29341178512$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($452aa29341178512$var$toJSON(child, mentionMap));
    });
    if ($452aa29341178512$var$isParagraph(node) || $452aa29341178512$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($452aa29341178512$var$isUnsupportedMark(mark)) return $452aa29341178512$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($452aa29341178512$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($452aa29341178512$var$isLinkMark(mark)) return (0, $h9kgv.toJSON)(mark);
            else if ($452aa29341178512$var$isDataConsumer(mark)) {
                const serialised = (0, $dHJym.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($452aa29341178512$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $6Ymtk.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($452aa29341178512$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$452aa29341178512$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $452aa29341178512$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $5RXjG.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $452aa29341178512$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $452aa29341178512$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $8DB98.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $lGx2C.sanitizeNode)($452aa29341178512$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(content, $452aa29341178512$var$emptyDoc.content)) return $452aa29341178512$var$createDocFromContent([]);
        return $452aa29341178512$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $8DB98.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($452aa29341178512$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $lGx2C.sanitizeNode)($452aa29341178512$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("5RXjG", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $dde2fa0263905fa8$export$28e4e3c024cce988);
const $dde2fa0263905fa8$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $dde2fa0263905fa8$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $dde2fa0263905fa8$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $dde2fa0263905fa8$var$defaultAllowOverrideBehaviour;
        default:
            return $dde2fa0263905fa8$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("lGx2C", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $6129054bcfac353f$export$48b382180baf8e88);

var $jF4Mi = parcelRequire("jF4Mi");

var $0mclG = parcelRequire("0mclG");

var $jME2s = parcelRequire("jME2s");
const $6129054bcfac353f$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $6129054bcfac353f$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $0mclG.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $jME2s.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($6129054bcfac353f$var$hasNestedTable(node)) return (0, $jF4Mi.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($6129054bcfac353f$var$hasNestedTable(node)) return (0, $jF4Mi.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $jME2s.removeNonAnnotationMarks),
        mention: (0, $jME2s.removeNonAnnotationMarks),
        date: (0, $jME2s.removeNonAnnotationMarks),
        hardBreak: (0, $jME2s.removeMarks),
        inlineCard: (0, $jME2s.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("jME2s", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7ddfde3dbc93f214$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7ddfde3dbc93f214$export$8cae9126fc577085);
function $7ddfde3dbc93f214$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7ddfde3dbc93f214$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});





parcelRegister("EiR1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad4719240189e00$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $1ad4719240189e00$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $aqskg.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $1ad4719240189e00$export$2e2bcd8739ae039 = $1ad4719240189e00$var$decisionItem;

});

parcelRegister("14Wro", function(module, exports) {

$parcel$export(module.exports, "default", () => $67ba2bd16f9488d6$export$2e2bcd8739ae039);
const $67ba2bd16f9488d6$var$hardBreak = ()=>{
    return '\n';
};
var $67ba2bd16f9488d6$export$2e2bcd8739ae039 = $67ba2bd16f9488d6$var$hardBreak;

});

parcelRegister("3Vvcc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6711d88b3cbd025$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $e6711d88b3cbd025$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('');
};
var $e6711d88b3cbd025$export$2e2bcd8739ae039 = $e6711d88b3cbd025$var$heading;

});

parcelRegister("6IeNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1a756ed65e214d$export$2e2bcd8739ae039);

var $g9wjI = parcelRequire("g9wjI");
const $1e1a756ed65e214d$var$inlineCard = (node, schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $g9wjI.getText)(node);
};
var $1e1a756ed65e214d$export$2e2bcd8739ae039 = $1e1a756ed65e214d$var$inlineCard;

});

parcelRegister("1wZsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bc040febe608e24$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $5bc040febe608e24$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('\n');
};
var $5bc040febe608e24$export$2e2bcd8739ae039 = $5bc040febe608e24$var$listItem;

});

parcelRegister("6ySZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff5eb0444c3b3502$export$2e2bcd8739ae039);
const $ff5eb0444c3b3502$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $ff5eb0444c3b3502$export$2e2bcd8739ae039 = $ff5eb0444c3b3502$var$mediaGroup;

});

parcelRegister("9x58g", function(module, exports) {

$parcel$export(module.exports, "default", () => $357bdc948e15b537$export$2e2bcd8739ae039);
const $357bdc948e15b537$var$mention = (node, schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $357bdc948e15b537$export$2e2bcd8739ae039 = $357bdc948e15b537$var$mention;

});

parcelRegister("deM66", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7ff775365af6469$export$2e2bcd8739ae039);

var $fCXIH = parcelRequire("fCXIH");

var $aqskg = parcelRequire("aqskg");
const $d7ff775365af6469$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $fCXIH.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $aqskg.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $d7ff775365af6469$export$2e2bcd8739ae039 = $d7ff775365af6469$var$orderedList;

});
parcelRegister("fCXIH", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $8408b0ba796dc38c$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $8408b0ba796dc38c$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $8408b0ba796dc38c$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $8408b0ba796dc38c$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $8408b0ba796dc38c$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $8408b0ba796dc38c$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $8408b0ba796dc38c$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $8408b0ba796dc38c$export$8ef94ae42a3729bd = 1;
const $8408b0ba796dc38c$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $8408b0ba796dc38c$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $8408b0ba796dc38c$export$d445360e2a3c026b(order) ?? $8408b0ba796dc38c$export$8ef94ae42a3729bd;
};
const $8408b0ba796dc38c$export$320582fc14ba1e0f = (options)=>{
    const order = $8408b0ba796dc38c$export$d445360e2a3c026b(options.order) ?? $8408b0ba796dc38c$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $8408b0ba796dc38c$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $8408b0ba796dc38c$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $8408b0ba796dc38c$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $8408b0ba796dc38c$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("dnx3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $219c1648a3127a2e$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $219c1648a3127a2e$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('\n');
};
var $219c1648a3127a2e$export$2e2bcd8739ae039 = $219c1648a3127a2e$var$panel;

});

parcelRegister("dX58h", function(module, exports) {

$parcel$export(module.exports, "default", () => $55b5d30ee0a92e9f$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $55b5d30ee0a92e9f$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $aqskg.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $55b5d30ee0a92e9f$export$2e2bcd8739ae039 = $55b5d30ee0a92e9f$var$paragraph;

});

parcelRegister("g6zW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2faedd5e5cae2ee3$export$2e2bcd8739ae039);
const $2faedd5e5cae2ee3$var$rule = ()=>{
    return '';
};
var $2faedd5e5cae2ee3$export$2e2bcd8739ae039 = $2faedd5e5cae2ee3$var$rule;

});

parcelRegister("bOElj", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d2c37c2076739c$export$2e2bcd8739ae039);

var $g9wjI = parcelRequire("g9wjI");
const $28d2c37c2076739c$var$status = (node, schema)=>{
    return node.attrs.text ? `[ ${node.attrs.text.toUpperCase()} ]` : (0, $g9wjI.getText)(node);
};
var $28d2c37c2076739c$export$2e2bcd8739ae039 = $28d2c37c2076739c$var$status;

});

parcelRegister("iI82H", function(module, exports) {

$parcel$export(module.exports, "default", () => $731aa0da9202d7ff$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $731aa0da9202d7ff$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($731aa0da9202d7ff$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $731aa0da9202d7ff$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($731aa0da9202d7ff$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $731aa0da9202d7ff$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('\n');
};
var $731aa0da9202d7ff$export$2e2bcd8739ae039 = $731aa0da9202d7ff$var$table;

});

parcelRegister("eknNa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9a4a811fcd6b1b$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $cc9a4a811fcd6b1b$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $aqskg.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $cc9a4a811fcd6b1b$export$2e2bcd8739ae039 = $cc9a4a811fcd6b1b$var$taskItem;

});

parcelRegister("jFFK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $238cc03aa2c3282b$export$2e2bcd8739ae039);

var $g9wjI = parcelRequire("g9wjI");

var $aqskg = parcelRequire("aqskg");
const $238cc03aa2c3282b$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $g9wjI.getText)(node);
};
var $238cc03aa2c3282b$export$2e2bcd8739ae039 = $238cc03aa2c3282b$var$unknown;

});







//# sourceMappingURL=async-bulkOps-core-full.a7c7d9f2.js.map
